export default {
  'pt-BR': {
    'gestationalAge.label': 'Informações',
    'gestationalAge.info.label': 'Gestação',
    'gestationalAge.info.interationDate.label': 'Data do exame',
    'gestationalAge.info.dateBirthMother.label': 'Data de nascimento da mãe',
    'gestationalAge.info.via.label': 'Via do exame',
    'gestationalAge.info.via.items.abdominal.text': 'Abdominal',
    'gestationalAge.info.via.items.transvaginal.text': 'Transvaginal',
    'gestationalAge.info.via.items.pélvica.text': 'Pélvica',
    'gestationalAge.info.indicacao.label': 'Indicação do exame',
    'gestationalAge.info.indicacao.items.Datar gestação.text': 'Datar gestação',
    'gestationalAge.info.indicacao.items.Rastreio de aneuploidias.text': 'Rastreio de aneuploidias',
    'gestationalAge.info.indicacao.items.Sangramento.text': 'Sangramento',
    'gestationalAge.info.indicacao.items.Diagnosticar gestação.text': 'Diagnosticar gestação',
    'gestationalAge.info.qualidade.label': 'Qualidade do exame',
    'gestationalAge.info.qualidade.items.Satisfatória.text': 'Satisfatória',
    'gestationalAge.info.qualidade.items.Prejudicado pela adiposidade materna.text': 'Prejudicado pela adiposidade materna',
    'gestationalAge.info.qualidade.items.Prejudicado pela estática fetal.text': 'Prejudicado pela estática fetal',
    'gestationalAge.info.qualidade.items.Prejudicado pela movimentação fetal.text': 'Prejudicado pela movimentação fetal',
    'gestationalAge.info.calculo.label': 'Cálculo da idade gestacional',
    'gestationalAge.info.calculo.items.DUM.text': 'Última menstruação',
    'gestationalAge.info.calculo.items.exame-anterior.text': 'Exame anterior',
    'gestationalAge.info.calculo.items.informada.text': 'Informada pela paciente',
    'gestationalAge.info.calculo.items.data-parto.text': 'Data provável do parto',
    'gestationalAge.info.calculo.items.desconhecido.text': 'Desconhecido',
    'gestationalAge.info.calculo.items.manual.text': 'Manual',
    'gestationalAge.info.date.label': 'Data',
    'gestationalAge.info.dateTest.label': 'Data',
    'gestationalAge.info.weeks.label': 'Semanas',
    'gestationalAge.info.days.label': 'Dias',
    'gestationalAge.info.calculada.label': 'Calculada',
    'gestationalAge.info.concepcao.label': 'Método de concepção',
    'gestationalAge.info.concepcao.items.Espontânea.text': 'Espontânea',
    'gestationalAge.info.concepcao.items.Indução da ovulação.text': 'Indução da ovulação',
    'gestationalAge.info.concepcao.items.Fertilização in vitro.text': 'Fertilização in vitro',
    'gestationalAge.info.fertilizacaoInVitro.label': 'Fertilização in Vitro',
    'gestationalAge.info.fertilizacaoInVitro.items.Normal.text': 'Normal',
    'gestationalAge.info.fertilizacaoInVitro.items.Doação de óvulo.text': 'Doação de óvulo',
    'gestationalAge.info.fertilizacaoInVitro.items.Óvulo congelado.text': 'Óvulo congelado',
    'gestationalAge.info.dateDoadora.label': 'Data de nascimento da doadora',
    'gestationalAge.info.dateCongelamento.label': 'Data do congelamento',
    'gestationalAge.info.qtdSacoGestacional.label': 'Número de sacos gestacionais',
    'gestationalAge.info.qtdSacoGestacional.items.1.text': 'Um',
    'gestationalAge.info.qtdSacoGestacional.items.2.text': 'Dois',
    'gestationalAge.info.qtdSacoGestacional.items.3.text': 'Três',
    'gestationalAge.info.qtdSacoGestacional.items.4.text': 'Quatro',
    'gestationalAge.info.fetos.label': 'Embriões / Fetos',
    'gestationalAge.info.fetos.items.0.text': 'Anembrionada',
    'gestationalAge.info.fetos.items.1.text': 'Único',
    'gestationalAge.info.fetos.items.2.text': 'Gemelar',
    'gestationalAge.info.fetos.items.3.text': 'Triplo',
    'gestationalAge.info.fetos.items.4.text': 'Quádruplo',
    'gestationalAge.info.fetos.items.Não visto.text': 'Não visto',
    'gestationalAge.info.movimentosFetais.label': 'Movimentos fetais',
    'gestationalAge.info.movimentosFetais.items.presente.text': 'Presente',
    'gestationalAge.info.movimentosFetais.items.ausente.text': 'Ausente',
    '1stinitialquarter.label': '1º TRIMESTRE INICIAL',
    '1stinitialquarter.exame.label': 'INFORMAÇÕES',
    '1stinitialquarter.exame.sacoGestacional.label': 'Saco gestacional',
    '1stinitialquarter.exame.sacoGestacional.items.regular.text': 'Regular',
    '1stinitialquarter.exame.sacoGestacional.items.irregular.text': 'Irregular',
    '1stinitialquarter.exame.localizacao.label': 'Localização',
    '1stinitialquarter.exame.localizacao.items.fundo uterino.text': 'Fundo uterino',
    '1stinitialquarter.exame.localizacao.items.corporal.text': 'Corporal',
    '1stinitialquarter.exame.localizacao.items.colo.text': 'Colo',
    '1stinitialquarter.exame.localizacao.items.cicatriz cesariana.text': 'Cicatriz cesariana',
    '1stinitialquarter.exame.deslocamentoOvular.label': 'Descolamento ovular',
    '1stinitialquarter.exame.deslocamentoOvular.items.presente.text': 'Presente',
    '1stinitialquarter.exame.deslocamentoOvular.items.ausente.text': 'Ausente',
    '1stinitialquarter.exame.hematoma.label': 'Hematoma',
    '1stinitialquarter.exame.hematoma.items.corion frondoso.text': 'Córion Frondoso',
    '1stinitialquarter.exame.hematoma.items.corion liso.text': 'Córion Liso',
    '1stinitialquarter.exame.hematoma.items.ausente.text': 'Ausente',
    '1stinitialquarter.biometria.label': 'EMBRIÕES',
    '1stinitialquarter.biometria.sacos.label': 'Sacos',
    '1stinitialquarter.biometria.sacos.saco$.label': 'Saco',
    '1stinitialquarter.biometria.sacos.saco$.long.label': 'Long.',
    '1stinitialquarter.biometria.sacos.saco$.ap.label': 'Ap.',
    '1stinitialquarter.biometria.sacos.saco$.transv.label': 'Transv.',
    '1stinitialquarter.biometria.sacos.saco$.measure.label': 'Média',
    '1stinitialquarter.biometria.sacos.saco$.idadeGestaSaco.label': 'Saco',
    '1stinitialquarter.biometria.fetos.label': 'Fetos',
    '1stinitialquarter.biometria.fetos.feto$.label': 'Feto',
    '1stinitialquarter.biometria.fetos.feto$.saco.label': 'Saco',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.1.text': 'Saco 1',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.2.text': 'Saco 2',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.3.text': 'Saco 3',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.4.text': 'Saco 4',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.5.text': 'Saco 5',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.6.text': 'Saco 6',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.7.text': 'Saco 7',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.8.text': 'Saco 8',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.label': 'Movimentos embrionários',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.items.presente.text': 'Presente',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.items.ausente.text': 'Ausente',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.label': 'Batimentos embrionários/fetais',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.items.presente.text': 'Presente',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.items.ausente.text': 'Ausente',
    '1stinitialquarter.biometria.fetos.feto$.visiculaVitelinia.label': 'Vesícula vitelínica',
    '1stinitialquarter.biometria.fetos.feto$.bcf.label': 'BCF',
    '1stinitialquarter.biometria.fetos.feto$.ccn.label': 'CCN',
    '1stinitialquarter.biometria.fetos.feto$.igCCN.label': 'CCN',
    '1stinitialquarter.ovarios.label': 'OVÁRIOS e Anexos',
    '1stinitialquarter.ovarios.direito.label': 'Direito',
    '1stinitialquarter.ovarios.direitoAspecto.label': 'Aspecto',
    '1stinitialquarter.ovarios.direitoAspecto.items.normal.text': 'Normal',
    '1stinitialquarter.ovarios.direitoAspecto.items.alterado.text': 'Alterado',
    '1stinitialquarter.ovarios.direitoAspecto.items.não visto.text': 'Não Visto',
    '1stinitialquarter.ovarios.direitoLong.label': 'Longitudinal',
    '1stinitialquarter.ovarios.direitoAnte.label': 'Anteroposterior',
    '1stinitialquarter.ovarios.direitoTransv.label': 'Transversa',
    '1stinitialquarter.ovarios.direitoVolume.label': 'Volume',
    '1stinitialquarter.ovarios.esquerdo.label': 'Esquerdo',
    '1stinitialquarter.ovarios.esquerdoAspecto.label': 'Aspecto',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.normal.text': 'Normal',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.alterado.text': 'Alterado',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.não visto.text': 'Não Visto',
    '1stinitialquarter.ovarios.esquerdoLong.label': 'Longitudinal',
    '1stinitialquarter.ovarios.esquerdoAnte.label': 'Anteroposterior',
    '1stinitialquarter.ovarios.esquerdoTransv.label': 'Transversa',
    '1stinitialquarter.ovarios.esquerdoVolume.label': 'Volume',
    '1stinitialquarter.ovarios.anexos.label': 'Anexos',
    '1stinitialquarter.ovarios.anexos.items.normal.text': 'Normal',
    '1stinitialquarter.ovarios.anexos.items.alterado.text': 'Alterado',
    '1stinitialquarter.ovarios.corpoluteo.label': 'Corpo Luteo',
    '1stinitialquarter.ovarios.corpoluteo.items.direito.text': 'Direito',
    '1stinitialquarter.ovarios.corpoluteo.items.esquerdo.text': 'Esquerdo',
    '1stinitialquarter.ovarios.corpoluteo.items.naovisto.text': 'Não Visto',
    '1stinitialquarter.graph.label': 'Gráficos',
    '1stinitialquarter.graph.sacoGestacional.label': 'Saco Gestacional',
    '1stinitialquarter.graph.ccn.label': 'CCN',
    '1stinitialquarter.conclusao.label': 'Observações',
    '1stinitialquarter.conclusao.conclusao.label': 'Observações',
    '1stinitialtracking.label': '1º TRIMESTRE RASTREIO',
    '1stinitialtracking.biometria.label': 'BIOMETRIA FETAL',
    '1stinitialtracking.biometria.fetos.label': 'Fetos',
    '1stinitialtracking.biometria.fetos.feto$.label': 'Feto',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.label': 'Corionicidade',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.1.text': 'Monocoriônico',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.2.text': 'Dicoriônico',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.3.text': 'Tricoriônico',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.label': 'Amniocidade',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.1.text': 'Monoamniótico',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.2.text': 'Diamniótico',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.3.text': 'Trioamniótico',
    '1stinitialtracking.biometria.fetos.feto$.ccn.label': 'CCN',
    '1stinitialtracking.biometria.fetos.feto$.idadeGestaCCN.label': 'CCN',
    '1stinitialtracking.biometria.fetos.feto$.dbp.label': 'DBP',
    '1stinitialtracking.biometria.fetos.feto$.igDbp.label': 'DBP',
    '1stinitialtracking.biometria.fetos.feto$.cc.label': 'CC',
    '1stinitialtracking.biometria.fetos.feto$.igCC.label': 'CC',
    '1stinitialtracking.biometria.fetos.feto$.ca.label': 'CA',
    '1stinitialtracking.biometria.fetos.feto$.igCA.label': 'CA',
    '1stinitialtracking.biometria.fetos.feto$.cf.label': 'CF',
    '1stinitialtracking.biometria.fetos.feto$.igCF.label': 'CF',
    '1stinitialtracking.biometria.fetos.feto$.cu.label': 'UM',
    '1stinitialtracking.biometria.fetos.feto$.igCU.label': 'UM',
    '1stinitialtracking.biometria.fetos.feto$.ductoVenoso.label': 'PI Ducto Venoso',
    '1stinitialtracking.biometria.fetos.feto$.ductoVenosoIG.label': 'DV',
    '1stinitialtracking.biometria.fetos.feto$.tn.label': 'TN',
    '1stinitialtracking.biometria.fetos.feto$.igTN.label': 'TN',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.label': 'Osso Nasal',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.items.Presente.text': 'Presente',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.items.Ausente.text': 'Ausente',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.label': 'Fluxo Tricúspide',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.items.Presente.text': 'Presente',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.items.Ausente.text': 'Ausente',
    '1stinitialtracking.biometria.fetos.feto$.visiculaVitelinia.label': 'Vesícula vitelínica',
    '1stinitialtracking.biometria.fetos.feto$.bcf.label': 'BCF',
    '1stinitialtracking.biometria.fetos.feto$.dopplerUtirinas.label': 'Doppler das Uterinas',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaEsquerda.label': 'PI da uterina esquerda',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaDireita.label': 'PI da uterina direita',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaMedia.label': 'PI da uterina (Média)',
    '1stinitialtracking.anatomiaFetal.label': 'ANATOMIA FETAL',
    '1stinitialtracking.anatomiaFetal.fetos.label': 'Fetos',
    '1stinitialtracking.anatomiaFetal.fetos.feto$.label': 'Feto',
    '1stinitialtracking.avalRiscoTrissomia.label': 'RISCO TRISSOMIA',
    '1stinitialtracking.avalRiscoTrissomia.labelIncid.label': 'Incidência de trissomia na gestação anterior',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.label': 'T21',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.items.1.text': 'Sim',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.items.0.text': 'Não',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.label': 'T18',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.items.1.text': 'Sim',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.items.0.text': 'Não',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.label': 'T13',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.items.1.text': 'Sim',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.items.0.text': 'Não',
    '1stinitialtracking.avalRiscoTrissomia.fetos.label': 'Fetos',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.label': 'Feto',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia21.label': 'Risco de trissomia 21 pela idade materna',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia21Corrigido.label': 'Corrigido',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia18.label': 'Risco de trissomia 18 pela idade materna',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia18Corrigido.label': 'Corrigido',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia13.label': 'Risco de trissomia 13 pela idade materna',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia13Corrigido.label': 'Corrigido',
    '1stinitialtracking.graph.label': 'Gráficos',
    '1stinitialtracking.graph.ccn.label': 'CCN',
    '1stinitialtracking.graph.dbp.label': 'DBP',
    '1stinitialtracking.graph.cc.label': 'CC',
    '1stinitialtracking.graph.ca.label': 'CA',
    '1stinitialtracking.graph.cf.label': 'CF',
    '1stinitialtracking.graph.cu.label': 'UM',
    '1stinitialtracking.graph.tn.label': 'TN',
    '1stinitialtracking.conclusao.label': 'Observações',
    '1stinitialtracking.conclusao.conclusao.label': 'Observações',
    '2ndand3rdquarter.label': '2º e 3º TRIMESTRE',
    '2ndand3rdquarter.avaliacaoGestacao.label': 'AVALIAÇÃO GESTAÇÃO',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.label': 'Fetos',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.label': 'Feto',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.label': 'Corionicidade',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.1.text': 'Monocoriônico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.2.text': 'Dicoriônico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.3.text': 'Tricoriônico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.label': 'Amniocidade',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.1.text': 'Monoamniótico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.2.text': 'Diamniótico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.3.text': 'Trioamniótico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.label': 'Situação fetal',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Longitudinal.text': 'Longitudinal',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Transversal.text': 'Transversal',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Oblíqua.text': 'Oblíqua',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.label': 'Apresentação fetal',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Cefálica.text': 'Cefálica',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Pélvica.text': 'Pélvica',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Córmica.text': 'Córmica',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Outros.text': 'Outros',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.label': 'Dorso fetal',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Anterior.text': 'Anterior',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Posterior.text': 'Posterior',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral direita.text': 'Lateral direita',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral esquerda.text': 'Lateral esquerda',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Outros.text': 'Outros',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.label': 'Movimentos fetais',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Presente.text': 'Presente',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Ausente.text': 'Ausente',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.label': 'Batimentos fetais',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Presente.text': 'Presente',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Ausente.text': 'Ausente',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.bcf.label': 'BCF',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.label': 'Placenta',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Anterior.text': 'Anterior',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Posterior.text': 'Posterior',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral direita.text': 'Lateral direita',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral esquerda.text': 'Lateral esquerda',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia parcial.text': 'Prévia parcial',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia total.text': 'Prévia total',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Outros.text': 'Outros',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.label': 'Maturidade placentária(GRANUMM)',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.0.text': '0',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.I.text': 'I',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.II.text': 'II',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.III.text': 'III',
    '2ndand3rdquarter.biometria.label': 'BIOMETRIA FETAL',
    '2ndand3rdquarter.biometria.fetos.label': 'Fetos',
    '2ndand3rdquarter.biometria.fetos.feto$.label': 'Feto',
    '2ndand3rdquarter.biometria.fetos.feto$.dbp.label': 'DBP',
    '2ndand3rdquarter.biometria.fetos.feto$.igDbp.label': 'DBP',
    '2ndand3rdquarter.biometria.fetos.feto$.cc.label': 'CC',
    '2ndand3rdquarter.biometria.fetos.feto$.igCC.label': 'CC',
    '2ndand3rdquarter.biometria.fetos.feto$.ca.label': 'CA',
    '2ndand3rdquarter.biometria.fetos.feto$.igCA.label': 'CA',
    '2ndand3rdquarter.biometria.fetos.feto$.cf.label': 'CF',
    '2ndand3rdquarter.biometria.fetos.feto$.igCF.label': 'CF',
    '2ndand3rdquarter.biometria.fetos.feto$.cu.label': 'UM',
    '2ndand3rdquarter.biometria.fetos.feto$.igCU.label': 'UM',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoCCCA.label': 'Relação CC/CA',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoCACF.label': 'Relação CA/CF',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoBPDCF.label': 'Relação BPD/CF',
    '2ndand3rdquarter.biometria.fetos.feto$.pesoEstimado.label': 'Peso estimado (± 15%)',
    '2ndand3rdquarter.biometria.fetos.feto$.comprimentoEstimado.label': 'Comprimento estimado',
    '2ndand3rdquarter.anatomiaFetal.label': 'ANATOMIA FETAL',
    '2ndand3rdquarter.anatomiaFetal.fetos.label': 'Fetos',
    '2ndand3rdquarter.anatomiaFetal.fetos.feto$.label': 'Feto',
    '2ndand3rdquarter.avalBiofisicaFetal.label': 'AVALIAÇÃO BIOFÍSICA FETAL',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.label': 'Fetos',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.label': 'Feto',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.label': 'Movimento respiratório',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Presente.text': 'Presente',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Ausente.text': 'Ausente',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.label': 'Tônus Fetal',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Presente.text': 'Presente',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Ausente.text': 'Ausente',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.label': 'Líquido amniótico',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Normal.text': 'Normal',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Diminuído.text': 'Diminuído',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Aumentado.text': 'Aumentado',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.labelILA.label': 'ILA',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qse.label': 'QSE',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qie.label': 'QIE',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qsd.label': 'QSD',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qid.label': 'QID',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.ilaTotal.label': 'Total',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.maiorBolsao.label': 'Maior Bolsão',
    '2ndand3rdquarter.idadeGestacional.label': 'IDADE GESTACIONAL',
    '2ndand3rdquarter.idadeGestacional.calculada.label': 'Calculada',
    '2ndand3rdquarter.graph.label': 'Gráficos',
    '2ndand3rdquarter.graph.dbp.label': 'DBP',
    '2ndand3rdquarter.graph.cc.label': 'CC',
    '2ndand3rdquarter.graph.ca.label': 'CA',
    '2ndand3rdquarter.graph.cf.label': 'CF',
    '2ndand3rdquarter.graph.cu.label': 'UM',
    '2ndand3rdquarter.graph.pesoEstimado.label': 'Peso estimado',
    '2ndand3rdquarter.graph.ilaTotal.label': 'ILA',
    '2ndand3rdquarter.graph.maiorBolsao.label': 'Maior Bolsão',
    '2ndand3rdquarter.conclusao.label': 'Observações',
    '2ndand3rdquarter.conclusao.conclusao.label': 'Observações',
    'morphological.label': 'MORFOLÓGICO',
    'morphological.avaliacaoGestacao.label': 'AVALIAÇÃO GESTAÇÃO',
    'morphological.avaliacaoGestacao.fetos.label': 'Fetos',
    'morphological.avaliacaoGestacao.fetos.feto$.label': 'Feto',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.label': 'Corionicidade',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.1.text': 'Monocoriônico',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.2.text': 'Dicoriônico',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.3.text': 'Tricoriônico',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.label': 'Amniocidade',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.1.text': 'Monoamniótico',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.2.text': 'Diamniótico',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.3.text': 'Trioamniótico',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.label': 'Situação fetal',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Longitudinal.text': 'Longitudinal',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Transversal.text': 'Transversal',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Oblíqua.text': 'Oblíqua',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.label': 'Apresentação fetal',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Cefálica.text': 'Cefálica',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Pélvica.text': 'Pélvica',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Córmica.text': 'Córmica',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Outros.text': 'Outros',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.label': 'Dorso fetal',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Anterior.text': 'Anterior',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Posterior.text': 'Posterior',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral direita.text': 'Lateral direita',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral esquerda.text': 'Lateral esquerda',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Outros.text': 'Outros',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.label': 'Movimentos fetais',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Presente.text': 'Presente',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Ausente.text': 'Ausente',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.label': 'Batimentos fetais',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Presente.text': 'Presente',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Ausente.text': 'Ausente',
    'morphological.avaliacaoGestacao.fetos.feto$.bcf.label': 'BCF',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.label': 'Placenta',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Anterior.text': 'Anterior',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Posterior.text': 'Posterior',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral direita.text': 'Lateral direita',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral esquerda.text': 'Lateral esquerda',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia parcial.text': 'Prévia parcial',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia total.text': 'Prévia total',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Outros.text': 'Outros',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.label': 'Maturidade placentária(GRANUMM)',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.0.text': '0',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.I.text': 'I',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.II.text': 'II',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.III.text': 'III',
    'morphological.biometria.label': 'BIOMETRIA FETAL BÁSICA',
    'morphological.biometria.fetos.label': 'Fetos',
    'morphological.biometria.fetos.feto$.label': 'Feto',
    'morphological.biometria.fetos.feto$.dbp.label': 'DBP',
    'morphological.biometria.fetos.feto$.igDbp.label': 'DBP',
    'morphological.biometria.fetos.feto$.cc.label': 'CC',
    'morphological.biometria.fetos.feto$.igCC.label': 'CC',
    'morphological.biometria.fetos.feto$.ca.label': 'CA',
    'morphological.biometria.fetos.feto$.igCA.label': 'CA',
    'morphological.biometria.fetos.feto$.cf.label': 'CF',
    'morphological.biometria.fetos.feto$.igCF.label': 'CF',
    'morphological.biometria.fetos.feto$.cu.label': 'UM',
    'morphological.biometria.fetos.feto$.igCU.label': 'UM',
    'morphological.biometria.fetos.feto$.relacaoCCCA.label': 'Relação CC/CA',
    'morphological.biometria.fetos.feto$.relacaoCACF.label': 'Relação CA/CF',
    'morphological.biometria.fetos.feto$.relacaoBPDCF.label': 'Relação BPD/CF',
    'morphological.biometria.fetos.feto$.pesoEstimado.label': 'Peso estimado (± 15%)',
    'morphological.biometria.fetos.feto$.comprimentoEstimado.label': 'Comprimento estimado',
    'morphological.biometriaAvancada.label': 'BIOMETRIA FETAL AVANÇADA',
    'morphological.biometriaAvancada.fetos.label': 'Fetos',
    'morphological.biometriaAvancada.fetos.feto$.label': 'Feto',
    'morphological.biometriaAvancada.fetos.feto$.diametroCerebelar.label': 'Diâmetro cerebelar',
    'morphological.biometriaAvancada.fetos.feto$.cisternaMagna.label': 'Cisterna magna',
    'morphological.biometriaAvancada.fetos.feto$.atrioVentriculoLateral.label': 'Átrio do ventrículo lateral',
    'morphological.biometriaAvancada.fetos.feto$.diametroOcular.label': 'Diâmetro Ocular',
    'morphological.biometriaAvancada.fetos.feto$.distanciaInterocular.label': 'Distância interocular',
    'morphological.biometriaAvancada.fetos.feto$.distanciaBinocular.label': 'Distância Binocular',
    'morphological.biometriaAvancada.fetos.feto$.quintoDedoMao.label': 'Quinto dedo da mão',
    'morphological.biometriaAvancada.fetos.feto$.ossoNasal.label': 'Osso nasal',
    'morphological.biometriaAvancada.fetos.feto$.pe.label': 'Pé',
    'morphological.biometriaAvancada.fetos.feto$.diamPelvisRenalDir.label': 'Diâm. Pelvis renal dir',
    'morphological.biometriaAvancada.fetos.feto$.diamPelvisRenalEsq.label': 'Diâm. Pelvis renal esq',
    'morphological.anatomiaFetal.label': 'ANATOMIA FETAL',
    'morphological.anatomiaFetal.fetos.label': 'Fetos',
    'morphological.anatomiaFetal.fetos.feto$.label': 'Feto',
    'morphological.avalBiofisicaFetal.label': 'AVALIAÇÃO BIOFÍSICA FETAL',
    'morphological.avalBiofisicaFetal.fetos.label': 'Fetos',
    'morphological.avalBiofisicaFetal.fetos.feto$.label': 'Feto',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.label': 'Movimento respiratório',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Presente.text': 'Presente',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Ausente.text': 'Ausente',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.label': 'Tônus Fetal',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Presente.text': 'Presente',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Ausente.text': 'Ausente',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.label': 'Líquido amniótico',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Normal.text': 'Normal',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Diminuído.text': 'Diminuído',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Aumentado.text': 'Aumentado',
    'morphological.avalBiofisicaFetal.fetos.feto$.labelILA.label': 'ILA',
    'morphological.avalBiofisicaFetal.fetos.feto$.qse.label': 'QSE',
    'morphological.avalBiofisicaFetal.fetos.feto$.qie.label': 'QIE',
    'morphological.avalBiofisicaFetal.fetos.feto$.qsd.label': 'QSD',
    'morphological.avalBiofisicaFetal.fetos.feto$.qid.label': 'QID',
    'morphological.avalBiofisicaFetal.fetos.feto$.ilaTotal.label': 'Total',
    'morphological.avalBiofisicaFetal.fetos.feto$.maiorBolsao.label': 'Maior Bolsão',
    'morphological.graph.label': 'Gráficos',
    'morphological.graph.dbp.label': 'DBP',
    'morphological.graph.cc.label': 'CC',
    'morphological.graph.ca.label': 'CA',
    'morphological.graph.cf.label': 'CF',
    'morphological.graph.cu.label': 'UM',
    'morphological.graph.pesoEstimado.label': 'Peso estimado',
    'morphological.graph.ilaTotal.label': 'ILA',
    'morphological.graph.maiorBolsao.label': 'Maior Bolsão',
    'morphological.graph.ossoNasal.label': 'Osso Nasal',
    'morphological.graph.diamPelvisRenalEsq.label': 'Pelvis renal esquerda',
    'morphological.graph.diamPalvisRenalDir.label': 'Pelvis renal direita',
    'morphological.conclusao.label': 'Observações',
    'morphological.conclusao.conclusao.label': 'Observações',
    'obstetricdoppler.label': 'DOPPLER OBSTÉTRICO',
    'obstetricdoppler.uterinas.label': 'UTERINAS',
    'obstetricdoppler.uterinas.uterinaEsquerda.label': 'Uterina Esquerda',
    'obstetricdoppler.uterinas.piUterinaEsquerda.label': 'PI da uterina esquerda',
    'obstetricdoppler.uterinas.riUterinaEsquerda.label': 'RI da uterina esquerda',
    'obstetricdoppler.uterinas.uterinaDireita.label': 'Uterina Direita',
    'obstetricdoppler.uterinas.piUterinaDireita.label': 'PI da uterina direita',
    'obstetricdoppler.uterinas.riUterinaDireita.label': 'RI da uterina direita',
    'obstetricdoppler.uterinas.uterinaMedia.label': 'Uterina Média',
    'obstetricdoppler.uterinas.piUterinaMedia.label': 'PI da uterina (Média)',
    'obstetricdoppler.fetal.label': 'FETAL',
    'obstetricdoppler.fetal.fetos.label': 'Fetos',
    'obstetricdoppler.fetal.fetos.feto$.label': 'Feto',
    'obstetricdoppler.fetal.fetos.feto$.umbilical.label': 'Umbilical',
    'obstetricdoppler.fetal.fetos.feto$.piUmbilical.label': 'PI Umbilical',
    'obstetricdoppler.fetal.fetos.feto$.riUmbilical.label': 'RI Umbilical',
    'obstetricdoppler.fetal.fetos.feto$.diastole.label': 'Diástole',
    'obstetricdoppler.fetal.fetos.feto$.diastole.items.PRESENTE.text': 'Presente',
    'obstetricdoppler.fetal.fetos.feto$.diastole.items.AUSENTE.text': 'Ausente',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.label': 'Diástole Zero',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.items.PRESENTE.text': 'Presente',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.items.AUSENTE.text': 'Ausente',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.label': 'Diástole Reversa',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.items.PRESENTE.text': 'Presente',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.items.AUSENTE.text': 'Ausente',
    'obstetricdoppler.fetal.fetos.feto$.cerebral.label': 'Cerebral',
    'obstetricdoppler.fetal.fetos.feto$.piCerebral.label': 'PI Cerebral',
    'obstetricdoppler.fetal.fetos.feto$.velocSistolica.label': 'Veloc. Sistólica',
    'obstetricdoppler.fetal.fetos.feto$.relacaoCerebralPlacentariaLabel.label': 'Relação Cerebral / Placentária',
    'obstetricdoppler.fetal.fetos.feto$.relacaoCerebralPlacentaria.label': 'PI Cer. / PI Umb.',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.label': 'Centralização',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.items.SIM.text': 'Sim',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.items.NAO.text': 'Não',
    'obstetricdoppler.fetal.fetos.feto$.ductoVenoso.label': 'PI Ducto Venoso',
    'obstetricdoppler.fetal.fetos.feto$.piDuctoVenoso.label': 'PI Ducto Venoso',
    'obstetricdoppler.fetal.fetos.feto$.saDuctoVenoso.label': 'S/A Ducto Venoso',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.label': 'Onda A',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.Positivo.text': 'Positivo',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.Zero.text': 'Zero',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.FluxoReverso.text': 'Fluxo Reverso',
    'obstetricdoppler.conclusao.label': 'Observações',
    'obstetricdoppler.conclusao.conclusao.label': 'Observações',
    'conclusion.label': 'Conclusão',
    'conclusion.text.label': 'Conclusão',
    'Nodulos': 'Nodulos',
    'ecocardiogramafetal': 'Ecocardiograma Fetal',
    'examemama.label': 'Exame Mama',
    'examemama.esquerda.label': 'mama esquerda',
    'examemame.direita.label': 'mama direita',
    'ecocardiogramafetal.label': 'Ecocardiograma Fetal',
    'ecocardiogramafetal.informacoes.label': 'Informacoes'
  },
  'en': {
    'gestationalAge.label': 'Informations',
    'gestationalAge.info.label': 'Gestation',
    'gestationalAge.info.interationDate.label': 'Exam Date',
    'gestationalAge.info.dateBirthMother.label': "Mother's Date of Birth",
    'gestationalAge.info.via.label': 'Examination route',
    'gestationalAge.info.via.items.abdominal.text': 'Abdominal',
    'gestationalAge.info.via.items.transvaginal.text': 'Transvaginal',
    'gestationalAge.info.indicacao.label': 'Exam indication',
    'gestationalAge.info.indicacao.items.Datar gestação.text': 'Dating pregnancy',
    'gestationalAge.info.indicacao.items.Rastreio de aneuploidias.text': 'Aneuploidy Screening',
    'gestationalAge.info.indicacao.items.Sangramento.text': 'Bleeding',
    'gestationalAge.info.indicacao.items.Diagnosticar gestação.text': 'Diagnose pregnancy',
    'gestationalAge.info.qualidade.label': 'Exam Quality',
    'gestationalAge.info.qualidade.items.Satisfatória.text': 'Satisfactory',
    'gestationalAge.info.qualidade.items.Prejudicado pela adiposidade materna.text': 'Harmed by maternal adiposity',
    'gestationalAge.info.qualidade.items.Prejudicado pela estática fetal.text': 'Harmed by fetal static',
    'gestationalAge.info.qualidade.items.Prejudicado pela movimentação fetal.text': 'Harmed by fetal movement',
    'gestationalAge.info.calculo.label': 'Calculation of gestational age',
    'gestationalAge.info.calculo.items.DUM.text': 'Last period',
    'gestationalAge.info.calculo.items.exame-anterior.text': 'Previous exam',
    'gestationalAge.info.calculo.items.informada.text': 'Patient informed',
    'gestationalAge.info.calculo.items.data-parto.text': 'Probable date of delivery',
    'gestationalAge.info.calculo.items.desconhecido.text': 'Unknown',
    'gestationalAge.info.calculo.items.manual.text': 'Manual',
    'gestationalAge.info.date.label': 'Date',
    'gestationalAge.info.dateTest.label': 'Date',
    'gestationalAge.info.weeks.label': 'Weeks',
    'gestationalAge.info.days.label': 'Days',
    'gestationalAge.info.calculada.label': 'Calculated',
    'gestationalAge.info.concepcao.label': 'Design method',
    'gestationalAge.info.concepcao.items.Espontânea.text': 'Spontaneous',
    'gestationalAge.info.concepcao.items.Indução da ovulação.text': 'Ovulation Induction',
    'gestationalAge.info.concepcao.items.Fertilização in vitro.text': 'In vitro fertilization',
    'gestationalAge.info.fertilizacaoInVitro.label': 'In vitro fertilization',
    'gestationalAge.info.fertilizacaoInVitro.items.Normal.text': 'Normal',
    'gestationalAge.info.fertilizacaoInVitro.items.Doação de óvulo.text': 'Egg Donation',
    'gestationalAge.info.fertilizacaoInVitro.items.Óvulo congelado.text': 'Frozen egg',
    'gestationalAge.info.dateDoadora.label': "Donor's Date of Birth",
    'gestationalAge.info.dateCongelamento.label': 'Freeze Date',
    'gestationalAge.info.qtdSacoGestacional.label': 'Number of gestational sacs',
    'gestationalAge.info.qtdSacoGestacional.items.1.text': 'a',
    'gestationalAge.info.qtdSacoGestacional.items.2.text': 'Two',
    'gestationalAge.info.qtdSacoGestacional.items.3.text': 'Three',
    'gestationalAge.info.qtdSacoGestacional.items.4.text': 'Four',
    'gestationalAge.info.fetos.label': 'Embryos / Fetuses',
    'gestationalAge.info.fetos.items.0.text': 'Anembrionada',
    'gestationalAge.info.fetos.items.1.text': 'Single',
    'gestationalAge.info.fetos.items.2.text': 'Moaning',
    'gestationalAge.info.fetos.items.3.text': 'Triple',
    'gestationalAge.info.fetos.items.4.text': 'Quadruple',
    'gestationalAge.info.fetos.items.Não visto.text': 'Not seen',
    'gestationalAge.info.movimentosFetais.label': 'Fetal movements',
    'gestationalAge.info.movimentosFetais.items.presente.text': 'Gift',
    'gestationalAge.info.movimentosFetais.items.ausente.text': 'Absent',
    '1stinitialquarter.label': '1st QUARTER',
    '1stinitialquarter.exame.label': 'INFORMATION',
    '1stinitialquarter.exame.sacoGestacional.label': 'Gestational sac',
    '1stinitialquarter.exame.sacoGestacional.items.regular.text': 'Regular',
    '1stinitialquarter.exame.sacoGestacional.items.irregular.text': 'Irregular',
    '1stinitialquarter.exame.localizacao.label': 'Location',
    '1stinitialquarter.exame.localizacao.items.fundo uterino.text': 'Uterine background',
    '1stinitialquarter.exame.localizacao.items.corporal.text': 'Corporal',
    '1stinitialquarter.exame.localizacao.items.colo.text': 'Lap',
    '1stinitialquarter.exame.localizacao.items.cicatriz cesariana.text': 'Caesarean section scar',
    '1stinitialquarter.exame.deslocamentoOvular.label': 'Ovular detachment',
    '1stinitialquarter.exame.deslocamentoOvular.items.presente.text': 'Gift',
    '1stinitialquarter.exame.deslocamentoOvular.items.ausente.text': 'Absent',
    '1stinitialquarter.exame.hematoma.label': 'Bruise',
    '1stinitialquarter.exame.hematoma.items.corion frondoso.text': 'Leafy Corion',
    '1stinitialquarter.exame.hematoma.items.corion liso.text': 'Smooth Corion',
    '1stinitialquarter.exame.hematoma.items.ausente.text': 'Absent',
    '1stinitialquarter.biometria.label': 'EMBRYO',
    '1stinitialquarter.biometria.sacos.label': 'Bags',
    '1stinitialquarter.biometria.sacos.saco$.label': 'Bag',
    '1stinitialquarter.biometria.sacos.saco$.long.label': 'Long',
    '1stinitialquarter.biometria.sacos.saco$.ap.label': 'Ap.',
    '1stinitialquarter.biometria.sacos.saco$.transv.label': 'Transv.',
    '1stinitialquarter.biometria.sacos.saco$.measure.label': 'Average',
    '1stinitialquarter.biometria.sacos.saco$.idadeGestaSaco.label': 'Bag',
    '1stinitialquarter.biometria.fetos.label': 'Fetus',
    '1stinitialquarter.biometria.fetos.feto$.label': 'Fetus',
    '1stinitialquarter.biometria.fetos.feto$.saco.label': 'Bag',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.1.text': 'Bag 1',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.2.text': 'Bag 2',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.3.text': 'Bag 3',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.4.text': 'Bag 4',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.5.text': 'Bag 5',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.6.text': 'Bag 6',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.7.text': 'Bag 7',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.8.text': 'Bag 8',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.label': 'Embryonic movements',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.items.presente.text': 'Gift',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.items.ausente.text': 'Absent',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.label': 'Embryonic / fetal beats',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.items.presente.text': 'Gift',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.items.ausente.text': 'Absent',
    '1stinitialquarter.biometria.fetos.feto$.visiculaVitelinia.label': 'Vitelline gall',
    '1stinitialquarter.biometria.fetos.feto$.bcf.label': 'BCF',
    '1stinitialquarter.biometria.fetos.feto$.ccn.label': 'CCN',
    '1stinitialquarter.biometria.fetos.feto$.igCCN.label': 'CCN',
    '1stinitialquarter.ovarios.label': 'OVARIES AND ATTACHMENTS',
    '1stinitialquarter.ovarios.direito.label': 'Right',
    '1stinitialquarter.ovarios.direitoAspecto.label': 'Aspect',
    '1stinitialquarter.ovarios.direitoAspecto.items.normal.text': 'Normal',
    '1stinitialquarter.ovarios.direitoAspecto.items.alterado.text': 'Changed',
    '1stinitialquarter.ovarios.direitoAspecto.items.não visto.text': 'Not seen',
    '1stinitialquarter.ovarios.direitoLong.label': 'Longitudinal',
    '1stinitialquarter.ovarios.direitoAnte.label': 'Anterior Posterior',
    '1stinitialquarter.ovarios.direitoTransv.label': 'Transverse',
    '1stinitialquarter.ovarios.direitoVolume.label': 'Volume',
    '1stinitialquarter.ovarios.esquerdo.label': 'Left',
    '1stinitialquarter.ovarios.esquerdoAspecto.label': 'Aspect',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.normal.text': 'Normal',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.alterado.text': 'Changed',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.não visto.text': 'Not seen',
    '1stinitialquarter.ovarios.esquerdoLong.label': 'Longitudinal',
    '1stinitialquarter.ovarios.esquerdoAnte.label': 'Anterior Posterior',
    '1stinitialquarter.ovarios.esquerdoTransv.label': 'Transverse',
    '1stinitialquarter.ovarios.esquerdoVolume.label': 'Volume',
    '1stinitialquarter.ovarios.anexos.label': 'Attachments',
    '1stinitialquarter.ovarios.anexos.items.normal.text': 'Normal',
    '1stinitialquarter.ovarios.anexos.items.alterado.text': 'Changed',
    '1stinitialquarter.ovarios.corpoluteo.label': 'Luteo body',
    '1stinitialquarter.ovarios.corpoluteo.items.direito.text': 'Right',
    '1stinitialquarter.ovarios.corpoluteo.items.esquerdo.text': 'Left',
    '1stinitialquarter.ovarios.corpoluteo.items.naovisto.text': 'Not seen',
    '1stinitialquarter.graph.label': 'Graphics',
    '1stinitialquarter.graph.sacoGestacional.label': 'Gestational sac',
    '1stinitialquarter.graph.ccn.label': 'CCN',
    '1stinitialquarter.conclusao.label': 'Observations',
    '1stinitialquarter.conclusao.conclusao.label': 'Observations',
    '1stinitialtracking.label': '1st QUARTER TRACK',
    '1stinitialtracking.biometria.label': 'FETAL BIOMETRY',
    '1stinitialtracking.biometria.fetos.label': 'Fetus',
    '1stinitialtracking.biometria.fetos.feto$.label': 'Fetus',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.label': 'Chorionicity',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.1.text': 'Monochorionic',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.2.text': 'Dichorionic',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.3.text': 'Trichorionic',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.label': 'Amniocity',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.1.text': 'Monoamniotic',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.2.text': 'Diamniotic',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.3.text': 'Trioamniotic',
    '1stinitialtracking.biometria.fetos.feto$.ccn.label': 'CCN',
    '1stinitialtracking.biometria.fetos.feto$.idadeGestaCCN.label': 'CCN',
    '1stinitialtracking.biometria.fetos.feto$.dbp.label': 'DBP',
    '1stinitialtracking.biometria.fetos.feto$.igDbp.label': 'DBP',
    '1stinitialtracking.biometria.fetos.feto$.cc.label': 'CC',
    '1stinitialtracking.biometria.fetos.feto$.igCC.label': 'CC',
    '1stinitialtracking.biometria.fetos.feto$.ca.label': 'HERE',
    '1stinitialtracking.biometria.fetos.feto$.igCA.label': 'HERE',
    '1stinitialtracking.biometria.fetos.feto$.cf.label': 'CF',
    '1stinitialtracking.biometria.fetos.feto$.igCF.label': 'CF',
    '1stinitialtracking.biometria.fetos.feto$.cu.label': 'ASS',
    '1stinitialtracking.biometria.fetos.feto$.igCU.label': 'ASS',
    '1stinitialtracking.biometria.fetos.feto$.ductoVenoso.label': 'Venous Duct',
    '1stinitialtracking.biometria.fetos.feto$.ductoVenosoIG.label': 'DV',
    '1stinitialtracking.biometria.fetos.feto$.tn.label': 'TN',
    '1stinitialtracking.biometria.fetos.feto$.igTN.label': 'TN',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.label': 'Nasal Bone',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.items.Presente.text': 'Gift',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.items.Ausente.text': 'Absent',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.label': 'Tricuspid Regurgitation',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.items.Presente.text': 'Gift',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.items.Ausente.text': 'Absent',
    '1stinitialtracking.biometria.fetos.feto$.visiculaVitelinia.label': 'Vitelline gall',
    '1stinitialtracking.biometria.fetos.feto$.bcf.label': 'BCF',
    '1stinitialtracking.biometria.fetos.feto$.dopplerUtirinas.label': 'Uterine Doppler',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaEsquerda.label': 'PI of the left uterine',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaDireita.label': 'Right uterine PI',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaMedia.label': 'Uterine PI (Average)',
    '1stinitialtracking.anatomiaFetal.label': 'FETAL ANATOMY',
    '1stinitialtracking.anatomiaFetal.fetos.label': 'Fetus',
    '1stinitialtracking.anatomiaFetal.fetos.feto$.label': 'Fetus',
    '1stinitialtracking.avalRiscoTrissomia.label': 'RISK ASSESSMENT FOR TRISSOMY',
    '1stinitialtracking.avalRiscoTrissomia.labelIncid.label': 'Incidence of trisomy in previous pregnancy',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.label': 'T21',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.items.1.text': 'Yes',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.items.0.text': 'Not',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.label': 'T18',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.items.1.text': 'Yes',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.items.0.text': 'Not',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.label': 'T13',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.items.1.text': 'Yes',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.items.0.text': 'Not',
    '1stinitialtracking.avalRiscoTrissomia.fetos.label': 'Fetus',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.label': 'Fetus',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia21.label': 'Risk of trisomy 21 by maternal age',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia21Corrigido.label': 'adjusted',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia18.label': 'Risk of trisomy 18 by maternal age',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia18Corrigido.label': 'adjusted',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia13.label': 'Risk of trisomy 13 by maternal age',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia13Corrigido.label': 'adjusted',
    '1stinitialtracking.graph.label': 'Graphics',
    '1stinitialtracking.graph.ccn.label': 'CCN',
    '1stinitialtracking.graph.dbp.label': 'DBP',
    '1stinitialtracking.graph.cc.label': 'CC',
    '1stinitialtracking.graph.ca.label': 'HERE',
    '1stinitialtracking.graph.cf.label': 'CF',
    '1stinitialtracking.graph.cu.label': 'ASS',
    '1stinitialtracking.graph.tn.label': 'TN',
    '1stinitialtracking.conclusao.label': 'Observations',
    '1stinitialtracking.conclusao.conclusao.label': 'Observations',
    '2ndand3rdquarter.label': '2nd and 3rd QUARTER',
    '2ndand3rdquarter.avaliacaoGestacao.label': 'EVALUATION MANAGEMENT',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.label': 'Fetus',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.label': 'Fetus',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.label': 'Chorionicity',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.1.text': 'Monochorionic',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.2.text': 'Dichorionic',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.3.text': 'Trichorionic',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.label': 'Amniocity',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.1.text': 'Monoamniotic',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.2.text': 'Diamniotic',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.3.text': 'Trioamniotic',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.label': 'Fetal situation',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Longitudinal.text': 'Longitudinal',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Transversal.text': 'Crosscutting',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Oblíqua.text': 'Oblique',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.label': 'Fetal presentation',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Cefálica.text': 'Cephalic',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Pélvica.text': 'Pelvic',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Córmica.text': 'Formica',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Outros.text': 'Others',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.label': 'Fetal back',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Anterior.text': 'Previous',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Posterior.text': 'Later',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral direita.text': 'Right side',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral esquerda.text': 'Left side',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Outros.text': 'Others',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.label': 'Fetal movements',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Presente.text': 'Gift',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Ausente.text': 'Absent',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.label': 'Fetal beats',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Presente.text': 'Gift',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Ausente.text': 'Absent',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.bcf.label': 'BCF',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.label': 'Placenta',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Anterior.text': 'Previous',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Posterior.text': 'Later',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral direita.text': 'Right side',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral esquerda.text': 'Left side',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia parcial.text': 'Partial preview',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia total.text': 'Total preview',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Outros.text': 'Others',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.label': 'Placental Maturity (GRANUMM)',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.0.text': '0',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.I.text': 'I',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.II.text': 'II',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.III.text': 'III',
    '2ndand3rdquarter.biometria.label': 'FETAL BIOMETRY',
    '2ndand3rdquarter.biometria.fetos.label': 'Fetus',
    '2ndand3rdquarter.biometria.fetos.feto$.label': 'Fetus',
    '2ndand3rdquarter.biometria.fetos.feto$.dbp.label': 'DBP',
    '2ndand3rdquarter.biometria.fetos.feto$.igDbp.label': 'DBP',
    '2ndand3rdquarter.biometria.fetos.feto$.cc.label': 'CC',
    '2ndand3rdquarter.biometria.fetos.feto$.igCC.label': 'CC',
    '2ndand3rdquarter.biometria.fetos.feto$.ca.label': 'HERE',
    '2ndand3rdquarter.biometria.fetos.feto$.igCA.label': 'HERE',
    '2ndand3rdquarter.biometria.fetos.feto$.cf.label': 'CF',
    '2ndand3rdquarter.biometria.fetos.feto$.igCF.label': 'CF',
    '2ndand3rdquarter.biometria.fetos.feto$.cu.label': 'ASS',
    '2ndand3rdquarter.biometria.fetos.feto$.igCU.label': 'ASS',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoCCCA.label': 'DC / AC Ratio',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoCACF.label': 'AC / CF ratio',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoBPDCF.label': 'BPD / CF Ratio',
    '2ndand3rdquarter.biometria.fetos.feto$.pesoEstimado.label': 'Estimated Weight (± 15%)',
    '2ndand3rdquarter.biometria.fetos.feto$.comprimentoEstimado.label': 'Estimated Length',
    '2ndand3rdquarter.anatomiaFetal.label': 'FETAL ANATOMY',
    '2ndand3rdquarter.anatomiaFetal.fetos.label': 'Fetus',
    '2ndand3rdquarter.anatomiaFetal.fetos.feto$.label': 'Fetus',
    '2ndand3rdquarter.avalBiofisicaFetal.label': 'FETAL BIOPHYSICAL EVALUATION',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.label': 'Fetus',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.label': 'Fetus',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.label': 'Breathing movement',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Presente.text': 'Gift',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Ausente.text': 'Absent',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.label': 'Fetal tone',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Presente.text': 'Gift',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Ausente.text': 'Absent',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.label': 'Amniotic fluid',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Normal.text': 'Normal',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Diminuído.text': 'Diminished',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Aumentado.text': 'Increased',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.labelILA.label': 'ILA',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qse.label': 'QSE',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qie.label': 'QIE',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qsd.label': 'QSD',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qid.label': 'QID',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.ilaTotal.label': 'Total',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.maiorBolsao.label': 'Biggest Pocket',
    '2ndand3rdquarter.idadeGestacional.label': 'Gestational age',
    '2ndand3rdquarter.idadeGestacional.calculada.label': 'Calculated',
    '2ndand3rdquarter.graph.label': 'Graphics',
    '2ndand3rdquarter.graph.dbp.label': 'DBP',
    '2ndand3rdquarter.graph.cc.label': 'CC',
    '2ndand3rdquarter.graph.ca.label': 'HERE',
    '2ndand3rdquarter.graph.cf.label': 'CF',
    '2ndand3rdquarter.graph.cu.label': 'ASS',
    '2ndand3rdquarter.graph.pesoEstimado.label': 'Estimated weight',
    '2ndand3rdquarter.graph.ilaTotal.label': 'ILA',
    '2ndand3rdquarter.graph.maiorBolsao.label': 'Biggest Pocket',
    '2ndand3rdquarter.conclusao.label': 'Observations',
    '2ndand3rdquarter.conclusao.conclusao.label': 'Observations',
    'morphological.label': 'MORPHOLOGICAL',
    'morphological.avaliacaoGestacao.label': 'EVALUATION MANAGEMENT',
    'morphological.avaliacaoGestacao.fetos.label': 'Fetus',
    'morphological.avaliacaoGestacao.fetos.feto$.label': 'Fetus',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.label': 'Chorionicity',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.1.text': 'Monochorionic',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.2.text': 'Dichorionic',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.3.text': 'Trichorionic',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.label': 'Amniocity',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.1.text': 'Monoamniotic',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.2.text': 'Diamniotic',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.3.text': 'Trioamniotic',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.label': 'Fetal situation',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Longitudinal.text': 'Longitudinal',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Transversal.text': 'Crosscutting',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Oblíqua.text': 'Oblique',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.label': 'Fetal presentation',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Cefálica.text': 'Cephalic',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Pélvica.text': 'Pelvic',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Córmica.text': 'Formica',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Outros.text': 'Others',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.label': 'Fetal back',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Anterior.text': 'Previous',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Posterior.text': 'Later',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral direita.text': 'Right side',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral esquerda.text': 'Left side',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Outros.text': 'Others',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.label': 'Fetal movements',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Presente.text': 'Gift',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Ausente.text': 'Absent',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.label': 'Fetal beats',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Presente.text': 'Gift',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Ausente.text': 'Absent',
    'morphological.avaliacaoGestacao.fetos.feto$.bcf.label': 'BCF',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.label': 'Placenta',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Anterior.text': 'Previous',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Posterior.text': 'Later',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral direita.text': 'Right side',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral esquerda.text': 'Left side',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia parcial.text': 'Partial preview',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia total.text': 'Total preview',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Outros.text': 'Others',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.label': 'Placental Maturity (GRANUMM)',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.0.text': '0',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.I.text': 'I',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.II.text': 'II',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.III.text': 'III',
    'morphological.biometria.label': 'BASIC FETAL BIOMETRY',
    'morphological.biometria.fetos.label': 'Fetus',
    'morphological.biometria.fetos.feto$.label': 'Fetus',
    'morphological.biometria.fetos.feto$.dbp.label': 'DBP',
    'morphological.biometria.fetos.feto$.igDbp.label': 'DBP',
    'morphological.biometria.fetos.feto$.cc.label': 'CC',
    'morphological.biometria.fetos.feto$.igCC.label': 'CC',
    'morphological.biometria.fetos.feto$.ca.label': 'HERE',
    'morphological.biometria.fetos.feto$.igCA.label': 'HERE',
    'morphological.biometria.fetos.feto$.cf.label': 'CF',
    'morphological.biometria.fetos.feto$.igCF.label': 'CF',
    'morphological.biometria.fetos.feto$.cu.label': 'ASS',
    'morphological.biometria.fetos.feto$.igCU.label': 'ASS',
    'morphological.biometria.fetos.feto$.relacaoCCCA.label': 'DC / AC Ratio',
    'morphological.biometria.fetos.feto$.relacaoCACF.label': 'AC / CF ratio',
    'morphological.biometria.fetos.feto$.relacaoBPDCF.label': 'BPD / CF Ratio',
    'morphological.biometria.fetos.feto$.pesoEstimado.label': 'Estimated Weight (± 15%)',
    'morphological.biometria.fetos.feto$.comprimentoEstimado.label': 'Estimated Length',
    'morphological.biometriaAvancada.label': 'ADVANCED FETAL BIOMETRY',
    'morphological.biometriaAvancada.fetos.label': 'Fetus',
    'morphological.biometriaAvancada.fetos.feto$.label': 'Fetus',
    'morphological.biometriaAvancada.fetos.feto$.diametroCerebelar.label': 'Cerebellar diameter',
    'morphological.biometriaAvancada.fetos.feto$.diametroCerebelarIG.label': 'Percentile',
    'morphological.biometriaAvancada.fetos.feto$.cisternaMagna.label': 'Magna Cistern',
    'morphological.biometriaAvancada.fetos.feto$.cisternaMagnaIG.label': 'Percentile',
    'morphological.biometriaAvancada.fetos.feto$.atrioVentriculoLateral.label': 'Lateral ventricle atrium',
    'morphological.biometriaAvancada.fetos.feto$.atrioVentriculoLateralIG.label': 'Percentile',
    'morphological.biometriaAvancada.fetos.feto$.diametroOcular.label': 'Eye Diameter',
    'morphological.biometriaAvancada.fetos.feto$.diametroOcularIG.label': 'Percentile',
    'morphological.biometriaAvancada.fetos.feto$.distanciaInterocular.label': 'Interocular distance',
    'morphological.biometriaAvancada.fetos.feto$.distanciaInterocularIG.label': 'Percentile',
    'morphological.biometriaAvancada.fetos.feto$.distanciaBinocular.label': 'Binocular Distance',
    'morphological.biometriaAvancada.fetos.feto$.distanciaBinocularIG.label': 'Percentile',
    'morphological.biometriaAvancada.fetos.feto$.quintoDedoMao.label': 'Fifth finger',
    'morphological.biometriaAvancada.fetos.feto$.quintoDedoMaoIG.label': 'Percentile',
    'morphological.biometriaAvancada.fetos.feto$.ossoNasal.label': 'Nasal bone',
    'morphological.biometriaAvancada.fetos.feto$.pe.label': 'Foot',
    'morphological.biometriaAvancada.fetos.feto$.diamPelvisRenalDir.label': 'Dia. Renal pelvis dir',
    'morphological.biometriaAvancada.fetos.feto$.diamPelvisRenalEsq.label': 'Dia. Left renal pelvis',
    'morphological.anatomiaFetal.label': 'FETAL ANATOMY',
    'morphological.anatomiaFetal.fetos.label': 'Fetus',
    'morphological.anatomiaFetal.fetos.feto$.label': 'Fetus',
    'morphological.avalBiofisicaFetal.label': 'FETAL BIOPHYSICAL EVALUATION',
    'morphological.avalBiofisicaFetal.fetos.label': 'Fetus',
    'morphological.avalBiofisicaFetal.fetos.feto$.label': 'Fetus',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.label': 'Breathing movement',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Presente.text': 'Gift',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Ausente.text': 'Absent',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.label': 'Fetal tone',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Presente.text': 'Gift',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Ausente.text': 'Absent',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.label': 'Amniotic fluid',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Normal.text': 'Normal',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Diminuído.text': 'Diminished',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Aumentado.text': 'Increased',
    'morphological.avalBiofisicaFetal.fetos.feto$.labelILA.label': 'ILA',
    'morphological.avalBiofisicaFetal.fetos.feto$.qse.label': 'QSE',
    'morphological.avalBiofisicaFetal.fetos.feto$.qie.label': 'QIE',
    'morphological.avalBiofisicaFetal.fetos.feto$.qsd.label': 'QSD',
    'morphological.avalBiofisicaFetal.fetos.feto$.qid.label': 'QID',
    'morphological.avalBiofisicaFetal.fetos.feto$.ilaTotal.label': 'Total',
    'morphological.avalBiofisicaFetal.fetos.feto$.maiorBolsao.label': 'Biggest Pocket',
    'morphological.graph.label': 'Graphics',
    'morphological.graph.dbp.label': 'DBP',
    'morphological.graph.cc.label': 'CC',
    'morphological.graph.ca.label': 'HERE',
    'morphological.graph.cf.label': 'CF',
    'morphological.graph.cu.label': 'ASS',
    'morphological.graph.pesoEstimado.label': 'Estimated weight',
    'morphological.graph.ilaTotal.label': 'ILA',
    'morphological.graph.maiorBolsao.label': 'Biggest Pocket',
    'morphological.graph.ossoNasal.label': 'Nasal Bone',
    'morphological.graph.diamPelvisRenalEsq.label': 'Left renal pelvis',
    'morphological.graph.diamPalvisRenalDir.label': 'Right renal pelvis',
    'morphological.conclusao.label': 'Observations',
    'morphological.conclusao.conclusao.label': 'Observations',
    'obstetricdoppler.label': 'Obstetric DOPPLER',
    'obstetricdoppler.uterinas.label': 'Uterines',
    'obstetricdoppler.uterinas.uterinaEsquerda.label': 'Left Uterine',
    'obstetricdoppler.uterinas.piUterinaEsquerda.label': 'PI of the left uterine',
    'obstetricdoppler.uterinas.riUterinaEsquerda.label': 'Left uterine IR',
    'obstetricdoppler.uterinas.uterinaDireita.label': 'Right Uterine',
    'obstetricdoppler.uterinas.piUterinaDireita.label': 'Right uterine PI',
    'obstetricdoppler.uterinas.riUterinaDireita.label': 'Right uterine IR',
    'obstetricdoppler.uterinas.uterinaMedia.label': 'Medium Uterine',
    'obstetricdoppler.uterinas.piUterinaMedia.label': 'Uterine PI (Average)',
    'obstetricdoppler.fetal.label': 'FETAL',
    'obstetricdoppler.fetal.fetos.label': 'Fetus',
    'obstetricdoppler.fetal.fetos.feto$.label': 'Fetus',
    'obstetricdoppler.fetal.fetos.feto$.umbilical.label': 'Umbilical',
    'obstetricdoppler.fetal.fetos.feto$.piUmbilical.label': 'PI',
    'obstetricdoppler.fetal.fetos.feto$.riUmbilical.label': 'IR',
    'obstetricdoppler.fetal.fetos.feto$.diastole.label': 'Diastole',
    'obstetricdoppler.fetal.fetos.feto$.diastole.items.PRESENTE.text': 'Gift',
    'obstetricdoppler.fetal.fetos.feto$.diastole.items.AUSENTE.text': 'Absent',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.label': 'Diastole Zero',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.items.PRESENTE.text': 'Gift',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.items.AUSENTE.text': 'Absent',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.label': 'Reverse Diastole',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.items.PRESENTE.text': 'Gift',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.items.AUSENTE.text': 'Absent',
    'obstetricdoppler.fetal.fetos.feto$.cerebral.label': 'Brain',
    'obstetricdoppler.fetal.fetos.feto$.piCerebral.label': 'PI',
    'obstetricdoppler.fetal.fetos.feto$.velocSistolica.label': 'Speed Systolic',
    'obstetricdoppler.fetal.fetos.feto$.relacaoCerebralPlacentariaLabel.label': 'Brain / Placental Relationship',
    'obstetricdoppler.fetal.fetos.feto$.relacaoCerebralPlacentaria.label': 'Cerebral PI / Umbilical PI',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.label': 'Centralization',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.items.SIM.text': 'Yes',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.items.NAO.text': 'Not',
    'obstetricdoppler.fetal.fetos.feto$.ductoVenoso.label': 'Venous Duct',
    'obstetricdoppler.fetal.fetos.feto$.piDuctoVenoso.label': 'PI',
    'obstetricdoppler.fetal.fetos.feto$.ductoVenosoIG.label': 'DV',
    'obstetricdoppler.fetal.fetos.feto$.saDuctoVenoso.label': 'S / A',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.label': 'Wave A',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.Positivo.text': 'Positive',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.Zero.text': 'Zero',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.FluxoReverso.text': 'Reverse flow',
    'obstetricdoppler.conclusao.label': 'Observations',
    'obstetricdoppler.conclusao.conclusao.label': 'Observations',
    'conclusion.label': 'Conclusion',
    'conclusion.text.label': 'Conclusion'
  },
  'es': {
    'gestationalAge.label': 'Informaciones',
    'gestationalAge.info.label': 'Gestación',
    'gestationalAge.info.interationDate.label': 'Fecha de examen',
    'gestationalAge.info.dateBirthMother.label': 'Fecha de nacimiento de la madre',
    'gestationalAge.info.via.label': 'Ruta de examen',
    'gestationalAge.info.via.items.abdominal.text': 'Abdominal',
    'gestationalAge.info.via.items.transvaginal.text': 'Transvaginal',
    'gestationalAge.info.indicacao.label': 'Indicación de examen',
    'gestationalAge.info.indicacao.items.Datar gestação.text': 'Embarazo de citas',
    'gestationalAge.info.indicacao.items.Rastreio de aneuploidias.text': 'Detección de aneuploidía',
    'gestationalAge.info.indicacao.items.Sangramento.text': 'Sangrado',
    'gestationalAge.info.indicacao.items.Diagnosticar gestação.text': 'Diagnosticar el embarazo',
    'gestationalAge.info.qualidade.label': 'Examen de calidad',
    'gestationalAge.info.qualidade.items.Satisfatória.text': 'Satisfactorio',
    'gestationalAge.info.qualidade.items.Prejudicado pela adiposidade materna.text': 'Dañado por la adiposidad materna',
    'gestationalAge.info.qualidade.items.Prejudicado pela estática fetal.text': 'Dañado por la estática fetal',
    'gestationalAge.info.qualidade.items.Prejudicado pela movimentação fetal.text': 'Dañado por el movimiento fetal',
    'gestationalAge.info.calculo.label': 'Cálculo de la edad gestacional.',
    'gestationalAge.info.calculo.items.DUM.text': 'Último período menstrual',
    'gestationalAge.info.calculo.items.exame-anterior.text': 'Examen previo',
    'gestationalAge.info.calculo.items.informada.text': 'Paciente informado',
    'gestationalAge.info.calculo.items.data-parto.text': 'Fecha probable de entrega',
    'gestationalAge.info.calculo.items.desconhecido.text': 'Desconocido',
    'gestationalAge.info.calculo.items.manual.text': 'Manual',
    'gestationalAge.info.date.label': 'Fecha',
    'gestationalAge.info.dateTest.label': 'Fecha',
    'gestationalAge.info.weeks.label': 'Semanas',
    'gestationalAge.info.days.label': 'Días',
    'gestationalAge.info.calculada.label': 'Calculado',
    'gestationalAge.info.concepcao.label': 'Método de diseño',
    'gestationalAge.info.concepcao.items.Espontânea.text': 'Espontáneo',
    'gestationalAge.info.concepcao.items.Indução da ovulação.text': 'Inducción de la ovulación',
    'gestationalAge.info.concepcao.items.Fertilização in vitro.text': 'Fertilización in vitro',
    'gestationalAge.info.fertilizacaoInVitro.label': 'Fertilización In Vitro',
    'gestationalAge.info.fertilizacaoInVitro.items.Normal.text': 'Normal',
    'gestationalAge.info.fertilizacaoInVitro.items.Doação de óvulo.text': 'Donación de óvulos',
    'gestationalAge.info.fertilizacaoInVitro.items.Óvulo congelado.text': 'Huevo congelado',
    'gestationalAge.info.dateDoadora.label': 'Fecha de nacimiento del donante',
    'gestationalAge.info.dateCongelamento.label': 'Fecha de congelamiento',
    'gestationalAge.info.qtdSacoGestacional.label': 'Número de sacos gestacionales',
    'gestationalAge.info.qtdSacoGestacional.items.1.text': 'Uno',
    'gestationalAge.info.qtdSacoGestacional.items.2.text': 'Dos',
    'gestationalAge.info.qtdSacoGestacional.items.3.text': 'Tres',
    'gestationalAge.info.qtdSacoGestacional.items.4.text': 'Cuatro',
    'gestationalAge.info.fetos.label': 'Embriones / Fetos',
    'gestationalAge.info.fetos.items.0.text': 'Anembrionada',
    'gestationalAge.info.fetos.items.1.text': 'Único',
    'gestationalAge.info.fetos.items.2.text': 'Gimiendo',
    'gestationalAge.info.fetos.items.3.text': 'Triples',
    'gestationalAge.info.fetos.items.4.text': 'Cuádruple',
    'gestationalAge.info.fetos.items.Não visto.text': 'No visto',
    'gestationalAge.info.movimentosFetais.label': 'Movimientos fetales',
    'gestationalAge.info.movimentosFetais.items.presente.text': 'Regalo',
    'gestationalAge.info.movimentosFetais.items.ausente.text': 'Desaparecido',
    '1stinitialquarter.label': '1er TRIMESTRE',
    '1stinitialquarter.exame.label': 'INFORMACIÓN',
    '1stinitialquarter.exame.sacoGestacional.label': 'Saco gestacional',
    '1stinitialquarter.exame.sacoGestacional.items.regular.text': 'Para regular',
    '1stinitialquarter.exame.sacoGestacional.items.irregular.text': 'Manchado',
    '1stinitialquarter.exame.localizacao.label': 'Ubicación',
    '1stinitialquarter.exame.localizacao.items.fundo uterino.text': 'Fondo uterino',
    '1stinitialquarter.exame.localizacao.items.corporal.text': 'Cabo',
    '1stinitialquarter.exame.localizacao.items.colo.text': 'Vuelta',
    '1stinitialquarter.exame.localizacao.items.cicatriz cesariana.text': 'Cicatriz de cesárea',
    '1stinitialquarter.exame.deslocamentoOvular.label': 'Desprendimiento ovular',
    '1stinitialquarter.exame.deslocamentoOvular.items.presente.text': 'Regalo',
    '1stinitialquarter.exame.deslocamentoOvular.items.ausente.text': 'Desaparecido',
    '1stinitialquarter.exame.hematoma.label': 'Hematoma',
    '1stinitialquarter.exame.hematoma.items.corion frondoso.text': 'Frondoso Corion',
    '1stinitialquarter.exame.hematoma.items.corion liso.text': 'Corion liso',
    '1stinitialquarter.exame.hematoma.items.ausente.text': 'Desaparecido',
    '1stinitialquarter.biometria.label': 'Embrión',
    '1stinitialquarter.biometria.sacos.label': 'Bolsos',
    '1stinitialquarter.biometria.sacos.saco$.label': 'Saco',
    '1stinitialquarter.biometria.sacos.saco$.long.label': 'Largo',
    '1stinitialquarter.biometria.sacos.saco$.ap.label': 'Ap.',
    '1stinitialquarter.biometria.sacos.saco$.transv.label': 'Transv.',
    '1stinitialquarter.biometria.sacos.saco$.measure.label': 'Media',
    '1stinitialquarter.biometria.sacos.saco$.idadeGestaSaco.label': 'Saco',
    '1stinitialquarter.biometria.fetos.label': 'Feto',
    '1stinitialquarter.biometria.fetos.feto$.label': 'Feto',
    '1stinitialquarter.biometria.fetos.feto$.saco.label': 'Saco',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.1.text': 'Bolsa 1',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.2.text': 'Bolsa 2',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.3.text': 'Bolsa 3',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.4.text': 'Bolsa 4',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.5.text': 'Bolsa 5',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.6.text': 'Bolsa 6',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.7.text': 'Bolsa 7',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.8.text': 'Bolsa 8',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.label': 'Movimientos embrionarios',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.items.presente.text': 'Regalo',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.items.ausente.text': 'Desaparecido',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.label': 'Latidos embrionarios / fetales',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.items.presente.text': 'Regalo',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.items.ausente.text': 'Desaparecido',
    '1stinitialquarter.biometria.fetos.feto$.visiculaVitelinia.label': 'Vesícula biliar',
    '1stinitialquarter.biometria.fetos.feto$.bcf.label': 'BCF',
    '1stinitialquarter.biometria.fetos.feto$.ccn.label': 'CCN',
    '1stinitialquarter.biometria.fetos.feto$.igCCN.label': 'CCN',
    '1stinitialquarter.ovarios.label': 'OVARIOS Y ACCESORIOS',
    '1stinitialquarter.ovarios.direito.label': 'Ley',
    '1stinitialquarter.ovarios.direitoAspecto.label': 'Aspecto',
    '1stinitialquarter.ovarios.direitoAspecto.items.normal.text': 'Normal',
    '1stinitialquarter.ovarios.direitoAspecto.items.alterado.text': 'Cambiado',
    '1stinitialquarter.ovarios.direitoAspecto.items.não visto.text': 'No visto',
    '1stinitialquarter.ovarios.direitoLong.label': 'Longitudinal',
    '1stinitialquarter.ovarios.direitoAnte.label': 'Anterior Posterior',
    '1stinitialquarter.ovarios.direitoTransv.label': 'Transversal',
    '1stinitialquarter.ovarios.direitoVolume.label': 'Volumen',
    '1stinitialquarter.ovarios.esquerdo.label': 'Izquierda',
    '1stinitialquarter.ovarios.esquerdoAspecto.label': 'Aspecto',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.normal.text': 'Normal',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.alterado.text': 'Cambiado',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.não visto.text': 'No visto',
    '1stinitialquarter.ovarios.esquerdoLong.label': 'Longitudinal',
    '1stinitialquarter.ovarios.esquerdoAnte.label': 'Anterior Posterior',
    '1stinitialquarter.ovarios.esquerdoTransv.label': 'Transversal',
    '1stinitialquarter.ovarios.esquerdoVolume.label': 'Volumen',
    '1stinitialquarter.ovarios.anexos.label': 'Archivos adjuntos',
    '1stinitialquarter.ovarios.anexos.items.normal.text': 'Normal',
    '1stinitialquarter.ovarios.anexos.items.alterado.text': 'Cambiado',
    '1stinitialquarter.ovarios.corpoluteo.label': 'Cuerpo luteo',
    '1stinitialquarter.ovarios.corpoluteo.items.direito.text': 'Ley',
    '1stinitialquarter.ovarios.corpoluteo.items.esquerdo.text': 'Izquierda',
    '1stinitialquarter.ovarios.corpoluteo.items.naovisto.text': 'No visto',
    '1stinitialquarter.graph.label': 'Gráficos',
    '1stinitialquarter.graph.sacoGestacional.label': 'Saco gestacional',
    '1stinitialquarter.graph.ccn.label': 'CCN',
    '1stinitialquarter.conclusao.label': 'Observaciones',
    '1stinitialquarter.conclusao.conclusao.label': 'Observaciones',
    '1stinitialtracking.label': 'PISTA DEL 1er TRIMESTRE',
    '1stinitialtracking.biometria.label': 'BIOMETRIA FETAL',
    '1stinitialtracking.biometria.fetos.label': 'Feto',
    '1stinitialtracking.biometria.fetos.feto$.label': 'Feto',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.label': 'Corionicidad',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.1.text': 'Monocoriónico',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.2.text': 'Dicloriónico',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.3.text': 'Tricoriónico',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.label': 'Amniocity',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.1.text': 'Monoamniótico',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.2.text': 'Diamniótico',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.3.text': 'Trioamniótico',
    '1stinitialtracking.biometria.fetos.feto$.ccn.label': 'CCN',
    '1stinitialtracking.biometria.fetos.feto$.idadeGestaCCN.label': 'CCN',
    '1stinitialtracking.biometria.fetos.feto$.dbp.label': 'DBP',
    '1stinitialtracking.biometria.fetos.feto$.igDbp.label': 'DBP',
    '1stinitialtracking.biometria.fetos.feto$.cc.label': 'CC',
    '1stinitialtracking.biometria.fetos.feto$.igCC.label': 'CC',
    '1stinitialtracking.biometria.fetos.feto$.ca.label': 'CA',
    '1stinitialtracking.biometria.fetos.feto$.igCA.label': 'CA',
    '1stinitialtracking.biometria.fetos.feto$.cf.label': 'CF',
    '1stinitialtracking.biometria.fetos.feto$.igCF.label': 'CF',
    '1stinitialtracking.biometria.fetos.feto$.cu.label': 'UM',
    '1stinitialtracking.biometria.fetos.feto$.igCU.label': 'UM',
    '1stinitialtracking.biometria.fetos.feto$.ductoVenoso.label': 'PI Conducto venoso',
    '1stinitialtracking.biometria.fetos.feto$.ductoVenosoIG.label': 'DV',
    '1stinitialtracking.biometria.fetos.feto$.tn.label': 'TN',
    '1stinitialtracking.biometria.fetos.feto$.igTN.label': 'TN',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.label': 'Hueso nasal',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.items.Presente.text': 'Regalo',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.items.Ausente.text': 'Desaparecido',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.label': 'Regurgitación tricuspídea',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.items.Presente.text': 'Regalo',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.items.Ausente.text': 'Desaparecido',
    '1stinitialtracking.biometria.fetos.feto$.visiculaVitelinia.label': 'Vesícula biliar',
    '1stinitialtracking.biometria.fetos.feto$.bcf.label': 'BCF',
    '1stinitialtracking.biometria.fetos.feto$.dopplerUtirinas.label': 'Doppler uterino',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaEsquerda.label': 'PI del útero izquierdo',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaDireita.label': 'PI uterina derecha',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaMedia.label': 'PI uterino (promedio)',
    '1stinitialtracking.anatomiaFetal.label': 'Anatomía fetal',
    '1stinitialtracking.anatomiaFetal.fetos.label': 'Feto',
    '1stinitialtracking.anatomiaFetal.fetos.feto$.label': 'Feto',
    '1stinitialtracking.avalRiscoTrissomia.label': 'EVALUACIÓN DE RIESGOS PARA LA TRISOMÍA',
    '1stinitialtracking.avalRiscoTrissomia.labelIncid.label': 'Incidencia de trisomía en embarazos anteriores',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.label': 'T21',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.items.1.text': 'Si',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.items.0.text': 'No',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.label': 'T18',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.items.1.text': 'Si',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.items.0.text': 'No',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.label': 'T13',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.items.1.text': 'Si',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.items.0.text': 'No',
    '1stinitialtracking.avalRiscoTrissomia.fetos.label': 'Feto',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.label': 'Feto',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia21.label': 'Riesgo de trisomía 21 por edad materna',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia21Corrigido.label': 'Fijo',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia18.label': 'Riesgo de trisomía 18 por edad materna',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia18Corrigido.label': 'Fijo',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia13.label': 'Riesgo de trisomía 13 por edad materna',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia13Corrigido.label': 'Fijo',
    '1stinitialtracking.graph.label': 'Gráficos',
    '1stinitialtracking.graph.ccn.label': 'CCN',
    '1stinitialtracking.graph.dbp.label': 'DBP',
    '1stinitialtracking.graph.cc.label': 'CC',
    '1stinitialtracking.graph.ca.label': 'CA',
    '1stinitialtracking.graph.cf.label': 'CF',
    '1stinitialtracking.graph.cu.label': 'UM',
    '1stinitialtracking.graph.tn.label': 'TN',
    '1stinitialtracking.conclusao.label': 'Observaciones',
    '1stinitialtracking.conclusao.conclusao.label': 'Observaciones',
    '2ndand3rdquarter.label': '2do y 3er TRIMESTRE',
    '2ndand3rdquarter.avaliacaoGestacao.label': 'GESTIÓN DE EVALUACIÓN',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.label': 'Feto',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.label': 'Feto',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.label': 'Corionicidad',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.1.text': 'Monocoriónico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.2.text': 'Dicloriónico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.3.text': 'Tricoriónico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.label': 'Amniocity',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.1.text': 'Monoamniótico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.2.text': 'Diamniótico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.3.text': 'Trioamniótico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.label': 'Situación fetal',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Longitudinal.text': 'Longitudinal',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Transversal.text': 'Corte transversal',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Oblíqua.text': 'Oblicuo',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.label': 'Presentación fetal',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Cefálica.text': 'Cefálica',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Pélvica.text': 'Pélvica',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Córmica.text': 'Formica',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Outros.text': 'Otros',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.label': 'Espalda fetal',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Anterior.text': 'Anterior',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Posterior.text': 'Despues',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral direita.text': 'Lado derecho',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral esquerda.text': 'Lado izquierdo',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Outros.text': 'Otros',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.label': 'Movimientos fetales',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Presente.text': 'Regalo',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Ausente.text': 'Desaparecido',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.label': 'Latidos fetales',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Presente.text': 'Regalo',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Ausente.text': 'Desaparecido',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.bcf.label': 'BCF',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.label': 'Placenta',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Anterior.text': 'Anterior',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Posterior.text': 'Despues',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral direita.text': 'Lado derecho',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral esquerda.text': 'Lado izquierdo',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia parcial.text': 'Vista previa parcial',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia total.text': 'Vista previa total',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Outros.text': 'Otros',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.label': 'Madurez Placentaria (GRANUMM)',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.0.text': '0 0',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.I.text': 'Yo',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.II.text': 'II',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.III.text': 'III',
    '2ndand3rdquarter.biometria.label': 'BIOMETRIA FETAL',
    '2ndand3rdquarter.biometria.fetos.label': 'Feto',
    '2ndand3rdquarter.biometria.fetos.feto$.label': 'Feto',
    '2ndand3rdquarter.biometria.fetos.feto$.dbp.label': 'DBP',
    '2ndand3rdquarter.biometria.fetos.feto$.igDbp.label': 'DBP',
    '2ndand3rdquarter.biometria.fetos.feto$.cc.label': 'CC',
    '2ndand3rdquarter.biometria.fetos.feto$.igCC.label': 'CC',
    '2ndand3rdquarter.biometria.fetos.feto$.ca.label': 'CA',
    '2ndand3rdquarter.biometria.fetos.feto$.igCA.label': 'CA',
    '2ndand3rdquarter.biometria.fetos.feto$.cf.label': 'CF',
    '2ndand3rdquarter.biometria.fetos.feto$.igCF.label': 'CF',
    '2ndand3rdquarter.biometria.fetos.feto$.cu.label': 'UM',
    '2ndand3rdquarter.biometria.fetos.feto$.igCU.label': 'UM',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoCCCA.label': 'DC / AC Ratio',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoCACF.label': 'Relación AC / CF',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoBPDCF.label': 'Relación BPD / CF',
    '2ndand3rdquarter.biometria.fetos.feto$.pesoEstimado.label': 'Peso estimado (± 15%)',
    '2ndand3rdquarter.biometria.fetos.feto$.comprimentoEstimado.label': 'Longitud estimada',
    '2ndand3rdquarter.anatomiaFetal.label': 'Anatomía fetal',
    '2ndand3rdquarter.anatomiaFetal.fetos.label': 'Feto',
    '2ndand3rdquarter.anatomiaFetal.fetos.feto$.label': 'Feto',
    '2ndand3rdquarter.avalBiofisicaFetal.label': 'EVALUACIÓN BIOFÍSICA FETAL',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.label': 'Feto',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.label': 'Feto',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.label': 'Movimiento de respiración',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Presente.text': 'Regalo',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Ausente.text': 'Desaparecido',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.label': 'Tono fetal',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Presente.text': 'Regalo',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Ausente.text': 'Desaparecido',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.label': 'Líquido amniótico',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Normal.text': 'Normal',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Diminuído.text': 'Disminuido',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Aumentado.text': 'Aumentado',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.labelILA.label': 'ILA',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qse.label': 'QSE',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qie.label': 'QIE',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qsd.label': 'QSD',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qid.label': 'QID',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.ilaTotal.label': 'Total',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.maiorBolsao.label': 'El bolsillo más grande',
    '2ndand3rdquarter.idadeGestacional.label': 'Edad gestacional',
    '2ndand3rdquarter.idadeGestacional.calculada.label': 'Calculado',
    '2ndand3rdquarter.graph.label': 'Gráficos',
    '2ndand3rdquarter.graph.dbp.label': 'DBP',
    '2ndand3rdquarter.graph.cc.label': 'CC',
    '2ndand3rdquarter.graph.ca.label': 'CA',
    '2ndand3rdquarter.graph.cf.label': 'CF',
    '2ndand3rdquarter.graph.cu.label': 'UM',
    '2ndand3rdquarter.graph.pesoEstimado.label': 'Peso estimado',
    '2ndand3rdquarter.graph.ilaTotal.label': 'ILA',
    '2ndand3rdquarter.graph.maiorBolsao.label': 'El bolsillo más grande',
    '2ndand3rdquarter.conclusao.label': 'Observaciones',
    '2ndand3rdquarter.conclusao.conclusao.label': 'Observaciones',
    'morphological.label': 'MORFOLÓGICO',
    'morphological.avaliacaoGestacao.label': 'GESTIÓN DE EVALUACIÓN',
    'morphological.avaliacaoGestacao.fetos.label': 'Feto',
    'morphological.avaliacaoGestacao.fetos.feto$.label': 'Feto',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.label': 'Corionicidad',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.1.text': 'Monocoriónico',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.2.text': 'Dicloriónico',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.3.text': 'Tricoriónico',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.label': 'Amniocity',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.1.text': 'Monoamniótico',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.2.text': 'Diamniótico',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.3.text': 'Trioamniótico',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.label': 'Situación fetal',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Longitudinal.text': 'Longitudinal',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Transversal.text': 'Corte transversal',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Oblíqua.text': 'Oblicuo',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.label': 'Presentación fetal',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Cefálica.text': 'Cefálica',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Pélvica.text': 'Pélvica',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Córmica.text': 'Formica',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Outros.text': 'Otros',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.label': 'Espalda fetal',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Anterior.text': 'Anterior',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Posterior.text': 'Despues',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral direita.text': 'Lado derecho',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral esquerda.text': 'Lado izquierdo',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Outros.text': 'Otros',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.label': 'Movimientos fetales',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Presente.text': 'Regalo',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Ausente.text': 'Desaparecido',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.label': 'Latidos fetales',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Presente.text': 'Regalo',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Ausente.text': 'Desaparecido',
    'morphological.avaliacaoGestacao.fetos.feto$.bcf.label': 'BCF',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.label': 'Placenta',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Anterior.text': 'Anterior',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Posterior.text': 'Despues',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral direita.text': 'Lado derecho',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral esquerda.text': 'Lado izquierdo',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia parcial.text': 'Vista previa parcial',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia total.text': 'Vista previa total',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Outros.text': 'Otros',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.label': 'Madurez Placentaria (GRANUMM)',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.0.text': '0 0',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.I.text': 'Yo',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.II.text': 'II',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.III.text': 'III',
    'morphological.biometria.label': 'BIOMETRÍA FETAL BÁSICA',
    'morphological.biometria.fetos.label': 'Feto',
    'morphological.biometria.fetos.feto$.label': 'Feto',
    'morphological.biometria.fetos.feto$.dbp.label': 'DBP',
    'morphological.biometria.fetos.feto$.igDbp.label': 'DBP',
    'morphological.biometria.fetos.feto$.cc.label': 'CC',
    'morphological.biometria.fetos.feto$.igCC.label': 'CC',
    'morphological.biometria.fetos.feto$.ca.label': 'CA',
    'morphological.biometria.fetos.feto$.igCA.label': 'CA',
    'morphological.biometria.fetos.feto$.cf.label': 'CF',
    'morphological.biometria.fetos.feto$.igCF.label': 'CF',
    'morphological.biometria.fetos.feto$.cu.label': 'UM',
    'morphological.biometria.fetos.feto$.igCU.label': 'UM',
    'morphological.biometria.fetos.feto$.relacaoCCCA.label': 'DC / AC Ratio',
    'morphological.biometria.fetos.feto$.relacaoCACF.label': 'Relación AC / CF',
    'morphological.biometria.fetos.feto$.relacaoBPDCF.label': 'Relación BPD / CF',
    'morphological.biometria.fetos.feto$.pesoEstimado.label': 'Peso estimado (± 15%)',
    'morphological.biometria.fetos.feto$.comprimentoEstimado.label': 'Longitud estimada',
    'morphological.biometriaAvancada.label': 'BIOMETRÍA FETAL AVANZADA',
    'morphological.biometriaAvancada.fetos.label': 'Feto',
    'morphological.biometriaAvancada.fetos.feto$.label': 'Feto',
    'morphological.biometriaAvancada.fetos.feto$.diametroCerebelar.label': 'Diámetro cerebeloso',
    'morphological.biometriaAvancada.fetos.feto$.diametroCerebelarIG.label': 'Percentil',
    'morphological.biometriaAvancada.fetos.feto$.cisternaMagna.label': 'Cisterna Magna',
    'morphological.biometriaAvancada.fetos.feto$.cisternaMagnaIG.label': 'Percentil',
    'morphological.biometriaAvancada.fetos.feto$.atrioVentriculoLateral.label': 'Aurícula ventricular lateral',
    'morphological.biometriaAvancada.fetos.feto$.atrioVentriculoLateralIG.label': 'Percentil',
    'morphological.biometriaAvancada.fetos.feto$.diametroOcular.label': 'Diámetro del ojo',
    'morphological.biometriaAvancada.fetos.feto$.diametroOcularIG.label': 'Percentil',
    'morphological.biometriaAvancada.fetos.feto$.distanciaInterocular.label': 'Distancia interocular',
    'morphological.biometriaAvancada.fetos.feto$.distanciaInterocularIG.label': 'Percentil',
    'morphological.biometriaAvancada.fetos.feto$.distanciaBinocular.label': 'Distancia binocular',
    'morphological.biometriaAvancada.fetos.feto$.distanciaBinocularIG.label': 'Percentil',
    'morphological.biometriaAvancada.fetos.feto$.quintoDedoMao.label': 'Quinto dedo',
    'morphological.biometriaAvancada.fetos.feto$.quintoDedoMaoIG.label': 'Percentil',
    'morphological.biometriaAvancada.fetos.feto$.ossoNasal.label': 'Hueso nasal',
    'morphological.biometriaAvancada.fetos.feto$.pe.label': 'Pie',
    'morphological.biometriaAvancada.fetos.feto$.diamPelvisRenalDir.label': 'Dia. Dir. De pelvis renal',
    'morphological.biometriaAvancada.fetos.feto$.diamPelvisRenalEsq.label': 'Dia. Pelvis renal izquierda',
    'morphological.anatomiaFetal.label': 'Anatomía fetal',
    'morphological.anatomiaFetal.fetos.label': 'Feto',
    'morphological.anatomiaFetal.fetos.feto$.label': 'Feto',
    'morphological.avalBiofisicaFetal.label': 'EVALUACIÓN BIOFÍSICA FETAL',
    'morphological.avalBiofisicaFetal.fetos.label': 'Feto',
    'morphological.avalBiofisicaFetal.fetos.feto$.label': 'Feto',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.label': 'Movimiento de respiración',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Presente.text': 'Regalo',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Ausente.text': 'Desaparecido',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.label': 'Tono fetal',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Presente.text': 'Regalo',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Ausente.text': 'Desaparecido',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.label': 'Líquido amniótico',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Normal.text': 'Normal',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Diminuído.text': 'Disminuido',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Aumentado.text': 'Aumentado',
    'morphological.avalBiofisicaFetal.fetos.feto$.labelILA.label': 'ILA',
    'morphological.avalBiofisicaFetal.fetos.feto$.qse.label': 'QSE',
    'morphological.avalBiofisicaFetal.fetos.feto$.qie.label': 'QIE',
    'morphological.avalBiofisicaFetal.fetos.feto$.qsd.label': 'QSD',
    'morphological.avalBiofisicaFetal.fetos.feto$.qid.label': 'QID',
    'morphological.avalBiofisicaFetal.fetos.feto$.ilaTotal.label': 'Total',
    'morphological.avalBiofisicaFetal.fetos.feto$.maiorBolsao.label': 'El bolsillo más grande',
    'morphological.graph.label': 'Gráficos',
    'morphological.graph.dbp.label': 'DBP',
    'morphological.graph.cc.label': 'CC',
    'morphological.graph.ca.label': 'CA',
    'morphological.graph.cf.label': 'CF',
    'morphological.graph.cu.label': 'UM',
    'morphological.graph.pesoEstimado.label': 'Peso estimado',
    'morphological.graph.ilaTotal.label': 'ILA',
    'morphological.graph.maiorBolsao.label': 'El bolsillo más grande',
    'morphological.graph.ossoNasal.label': 'Hueso nasal',
    'morphological.graph.diamPelvisRenalEsq.label': 'Pelvis renal izquierda',
    'morphological.graph.diamPalvisRenalDir.label': 'Pelvis renal derecha',
    'morphological.conclusao.label': 'Observaciones',
    'morphological.conclusao.conclusao.label': 'Observaciones',
    'obstetricdoppler.label': 'DOPPLER obstétrico',
    'obstetricdoppler.uterinas.label': 'Uterinas',
    'obstetricdoppler.uterinas.uterinaEsquerda.label': 'Izquierda uterina',
    'obstetricdoppler.uterinas.piUterinaEsquerda.label': 'PI del útero izquierdo',
    'obstetricdoppler.uterinas.riUterinaEsquerda.label': 'IR uterino izquierdo',
    'obstetricdoppler.uterinas.uterinaDireita.label': 'Derecho uterino',
    'obstetricdoppler.uterinas.piUterinaDireita.label': 'PI uterina derecha',
    'obstetricdoppler.uterinas.riUterinaDireita.label': 'IR uterino derecho',
    'obstetricdoppler.uterinas.uterinaMedia.label': 'Uterino medio',
    'obstetricdoppler.uterinas.piUterinaMedia.label': 'PI uterino (promedio)',
    'obstetricdoppler.fetal.label': 'Fetal',
    'obstetricdoppler.fetal.fetos.label': 'Feto',
    'obstetricdoppler.fetal.fetos.feto$.label': 'Feto',
    'obstetricdoppler.fetal.fetos.feto$.umbilical.label': 'Umbilical',
    'obstetricdoppler.fetal.fetos.feto$.piUmbilical.label': 'PI',
    'obstetricdoppler.fetal.fetos.feto$.riUmbilical.label': 'IR',
    'obstetricdoppler.fetal.fetos.feto$.diastole.label': 'Diástole',
    'obstetricdoppler.fetal.fetos.feto$.diastole.items.PRESENTE.text': 'Regalo',
    'obstetricdoppler.fetal.fetos.feto$.diastole.items.AUSENTE.text': 'Desaparecido',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.label': 'Diástole cero',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.items.PRESENTE.text': 'Regalo',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.items.AUSENTE.text': 'Desaparecido',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.label': 'Diástole inversa',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.items.PRESENTE.text': 'Regalo',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.items.AUSENTE.text': 'Desaparecido',
    'obstetricdoppler.fetal.fetos.feto$.cerebral.label': 'Cerebro',
    'obstetricdoppler.fetal.fetos.feto$.piCerebral.label': 'PI',
    'obstetricdoppler.fetal.fetos.feto$.velocSistolica.label': 'Velocidad Sistólica',
    'obstetricdoppler.fetal.fetos.feto$.relacaoCerebralPlacentariaLabel.label': 'Cerebro / relación placentaria',
    'obstetricdoppler.fetal.fetos.feto$.relacaoCerebralPlacentaria.label': 'PI cer. / PI umb.',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.label': 'Centralizacion',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.items.SIM.text': 'Si',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.items.NAO.text': 'No',
    'obstetricdoppler.fetal.fetos.feto$.ductoVenoso.label': 'PI Conducto venoso',
    'obstetricdoppler.fetal.fetos.feto$.piDuctoVenoso.label': 'PI',
    'obstetricdoppler.fetal.fetos.feto$.ductoVenosoIG.label': 'DV',
    'obstetricdoppler.fetal.fetos.feto$.saDuctoVenoso.label': 'S / A',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.label': 'Ola A',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.Positivo.text': 'Positivo',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.Zero.text': 'Cero',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.FluxoReverso.text': 'Flujo inverso',
    'obstetricdoppler.conclusao.label': 'Observaciones',
    'obstetricdoppler.conclusao.conclusao.label': 'Observaciones',
    'conclusion.label': 'Conclusión',
    'conclusion.text.label': 'Conclusión'
  },
  'it': {
    'gestationalAge.label': 'informazioni',
    'gestationalAge.info.label': 'gestazione',
    'gestationalAge.info.interationDate.label': "Data dell'esame",
    'gestationalAge.info.dateBirthMother.label': 'Data di nascita della madre',
    'gestationalAge.info.via.label': 'Percorso di esame',
    'gestationalAge.info.via.items.abdominal.text': 'addominale',
    'gestationalAge.info.via.items.transvaginal.text': 'transvaginale',
    'gestationalAge.info.indicacao.label': "Indicazione dell'esame",
    'gestationalAge.info.indicacao.items.Datar gestação.text': 'Incontri gravidanza',
    'gestationalAge.info.indicacao.items.Rastreio de aneuploidias.text': 'Screening aneuploidia',
    'gestationalAge.info.indicacao.items.Sangramento.text': 'emorragia',
    'gestationalAge.info.indicacao.items.Diagnosticar gestação.text': 'Diagnosticare la gravidanza',
    'gestationalAge.info.qualidade.label': "Qualità dell'esame",
    'gestationalAge.info.qualidade.items.Satisfatória.text': 'soddisfacente',
    'gestationalAge.info.qualidade.items.Prejudicado pela adiposidade materna.text': "Danneggiato dall'adiposità materna",
    'gestationalAge.info.qualidade.items.Prejudicado pela estática fetal.text': 'Danneggiato da elettricità fetale',
    'gestationalAge.info.qualidade.items.Prejudicado pela movimentação fetal.text': 'Danneggiato dal movimento fetale',
    'gestationalAge.info.calculo.label': "Calcolo dell'età gestazionale",
    'gestationalAge.info.calculo.items.DUM.text': 'Ultimo periodo',
    'gestationalAge.info.calculo.items.exame-anterior.text': 'Esame precedente',
    'gestationalAge.info.calculo.items.informada.text': 'Paziente informato',
    'gestationalAge.info.calculo.items.data-parto.text': 'Probabile data di consegna',
    'gestationalAge.info.calculo.items.desconhecido.text': 'sconosciuto',
    'gestationalAge.info.calculo.items.manual.text': 'manuale',
    'gestationalAge.info.date.label': 'data',
    'gestationalAge.info.dateTest.label': 'data',
    'gestationalAge.info.weeks.label': 'settimane',
    'gestationalAge.info.days.label': 'giorni',
    'gestationalAge.info.calculada.label': 'calcolato',
    'gestationalAge.info.concepcao.label': 'Metodo di progettazione',
    'gestationalAge.info.concepcao.items.Espontânea.text': 'spontaneo',
    'gestationalAge.info.concepcao.items.Indução da ovulação.text': "Induzione dell'ovulazione",
    'gestationalAge.info.concepcao.items.Fertilização in vitro.text': 'Fecondazione in vitro',
    'gestationalAge.info.fertilizacaoInVitro.label': 'Fecondazione in vitro',
    'gestationalAge.info.fertilizacaoInVitro.items.Normal.text': 'normale',
    'gestationalAge.info.fertilizacaoInVitro.items.Doação de óvulo.text': 'Donazione di uova',
    'gestationalAge.info.fertilizacaoInVitro.items.Óvulo congelado.text': 'Uovo Congelato',
    'gestationalAge.info.dateDoadora.label': 'Data di nascita del donatore',
    'gestationalAge.info.dateCongelamento.label': 'Data di congelamento',
    'gestationalAge.info.qtdSacoGestacional.label': 'Numero di sacche gestazionali',
    'gestationalAge.info.qtdSacoGestacional.items.1.text': 'un',
    'gestationalAge.info.qtdSacoGestacional.items.2.text': 'due',
    'gestationalAge.info.qtdSacoGestacional.items.3.text': 'tre',
    'gestationalAge.info.qtdSacoGestacional.items.4.text': 'quattro',
    'gestationalAge.info.fetos.label': 'Embrioni / Feti',
    'gestationalAge.info.fetos.items.0.text': 'anembryonic',
    'gestationalAge.info.fetos.items.1.text': 'solo',
    'gestationalAge.info.fetos.items.2.text': 'gemello',
    'gestationalAge.info.fetos.items.3.text': 'triplo',
    'gestationalAge.info.fetos.items.4.text': 'quadruplo',
    'gestationalAge.info.fetos.items.Não visto.text': 'Non visto',
    'gestationalAge.info.movimentosFetais.label': 'Movimenti fetali',
    'gestationalAge.info.movimentosFetais.items.presente.text': 'presente',
    'gestationalAge.info.movimentosFetais.items.ausente.text': 'assente',
    '1stinitialquarter.label': '1 ° trimestre',
    '1stinitialquarter.exame.label': 'INFORMAZIONI',
    '1stinitialquarter.exame.sacoGestacional.label': 'Sac gestazionale',
    '1stinitialquarter.exame.sacoGestacional.items.regular.text': 'Per regolare',
    '1stinitialquarter.exame.sacoGestacional.items.irregular.text': 'irregolare',
    '1stinitialquarter.exame.localizacao.label': 'posizione',
    '1stinitialquarter.exame.localizacao.items.fundo uterino.text': 'Sfondo uterino',
    '1stinitialquarter.exame.localizacao.items.corporal.text': 'caporale',
    '1stinitialquarter.exame.localizacao.items.colo.text': 'grembo',
    '1stinitialquarter.exame.localizacao.items.cicatriz cesariana.text': 'Cicatrice del taglio cesareo',
    '1stinitialquarter.exame.deslocamentoOvular.label': 'Distacco ovulare',
    '1stinitialquarter.exame.deslocamentoOvular.items.presente.text': 'presente',
    '1stinitialquarter.exame.deslocamentoOvular.items.ausente.text': 'assente',
    '1stinitialquarter.exame.hematoma.label': 'ematoma',
    '1stinitialquarter.exame.hematoma.items.corion frondoso.text': 'Corion frondoso',
    '1stinitialquarter.exame.hematoma.items.corion liso.text': 'Corion liscio',
    '1stinitialquarter.exame.hematoma.items.ausente.text': 'assente',
    '1stinitialquarter.biometria.label': 'EMBRIONE',
    '1stinitialquarter.biometria.sacos.label': 'borse',
    '1stinitialquarter.biometria.sacos.saco$.label': 'borsa',
    '1stinitialquarter.biometria.sacos.saco$.long.label': 'Long.',
    '1stinitialquarter.biometria.sacos.saco$.ap.label': 'Ap.',
    '1stinitialquarter.biometria.sacos.saco$.transv.label': 'Trasv.',
    '1stinitialquarter.biometria.sacos.saco$.measure.label': 'media',
    '1stinitialquarter.biometria.sacos.saco$.idadeGestaSaco.label': 'borsa',
    '1stinitialquarter.biometria.fetos.label': 'feti',
    '1stinitialquarter.biometria.fetos.feto$.label': 'feto',
    '1stinitialquarter.biometria.fetos.feto$.saco.label': 'borsa',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.1.text': 'Borsa 1',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.2.text': 'Borsa 2',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.3.text': 'Borsa 3',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.4.text': 'Borsa 4',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.5.text': 'Borsa 5',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.6.text': 'Borsa 6',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.7.text': 'Borsa 7',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.8.text': 'Borsa 8',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.label': 'Movimenti embrionali',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.items.presente.text': 'presente',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.items.ausente.text': 'assente',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.label': 'Battiti embrionali / fetali',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.items.presente.text': 'presente',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.items.ausente.text': 'assente',
    '1stinitialquarter.biometria.fetos.feto$.visiculaVitelinia.label': 'Vitamina gall',
    '1stinitialquarter.biometria.fetos.feto$.bcf.label': 'BCF',
    '1stinitialquarter.biometria.fetos.feto$.ccn.label': 'CCN',
    '1stinitialquarter.biometria.fetos.feto$.igCCN.label': 'CCN',
    '1stinitialquarter.ovarios.label': 'OVARI E ALLEGATI',
    '1stinitialquarter.ovarios.direito.label': 'destra',
    '1stinitialquarter.ovarios.direitoAspecto.label': 'aspetto',
    '1stinitialquarter.ovarios.direitoAspecto.items.normal.text': 'normale',
    '1stinitialquarter.ovarios.direitoAspecto.items.alterado.text': 'cambiato',
    '1stinitialquarter.ovarios.direitoAspecto.items.não visto.text': 'Non visto',
    '1stinitialquarter.ovarios.direitoLong.label': 'longitudinale',
    '1stinitialquarter.ovarios.direitoAnte.label': 'Anteriore posteriore',
    '1stinitialquarter.ovarios.direitoTransv.label': 'trasversale',
    '1stinitialquarter.ovarios.direitoVolume.label': 'volume',
    '1stinitialquarter.ovarios.esquerdo.label': 'sinistra',
    '1stinitialquarter.ovarios.esquerdoAspecto.label': 'aspetto',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.normal.text': 'normale',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.alterado.text': 'cambiato',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.não visto.text': 'Non visto',
    '1stinitialquarter.ovarios.esquerdoLong.label': 'longitudinale',
    '1stinitialquarter.ovarios.esquerdoAnte.label': 'Anteriore posteriore',
    '1stinitialquarter.ovarios.esquerdoTransv.label': 'trasversale',
    '1stinitialquarter.ovarios.esquerdoVolume.label': 'volume',
    '1stinitialquarter.ovarios.anexos.label': 'allegati',
    '1stinitialquarter.ovarios.anexos.items.normal.text': 'normale',
    '1stinitialquarter.ovarios.anexos.items.alterado.text': 'cambiato',
    '1stinitialquarter.ovarios.corpoluteo.label': 'Corpo luteo',
    '1stinitialquarter.ovarios.corpoluteo.items.direito.text': 'destra',
    '1stinitialquarter.ovarios.corpoluteo.items.esquerdo.text': 'sinistra',
    '1stinitialquarter.ovarios.corpoluteo.items.naovisto.text': 'Non visto',
    '1stinitialquarter.graph.label': 'grafica',
    '1stinitialquarter.graph.sacoGestacional.label': 'Sac gestazionale',
    '1stinitialquarter.graph.ccn.label': 'CCN',
    '1stinitialquarter.conclusao.label': 'Osservazioni',
    '1stinitialquarter.conclusao.conclusao.label': 'Osservazioni',
    '1stinitialtracking.label': 'TRACCIA DEL 1 ° TRIMESTRE',
    '1stinitialtracking.biometria.label': 'BIOMETRIA FETALE',
    '1stinitialtracking.biometria.fetos.label': 'feti',
    '1stinitialtracking.biometria.fetos.feto$.label': 'feto',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.label': 'corionicità',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.1.text': 'Monocoriônico',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.2.text': 'Dicoriônico',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.3.text': 'Tricoriônico',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.label': 'Amniocidade',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.1.text': 'Monoamniótico',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.2.text': 'Diamniótico',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.3.text': 'Trioamniótico',
    '1stinitialtracking.biometria.fetos.feto$.ccn.label': 'CCN',
    '1stinitialtracking.biometria.fetos.feto$.idadeGestaCCN.label': 'CCN',
    '1stinitialtracking.biometria.fetos.feto$.dbp.label': 'DBP',
    '1stinitialtracking.biometria.fetos.feto$.igDbp.label': 'DBP',
    '1stinitialtracking.biometria.fetos.feto$.cc.label': 'CC',
    '1stinitialtracking.biometria.fetos.feto$.igCC.label': 'CC',
    '1stinitialtracking.biometria.fetos.feto$.ca.label': 'AC',
    '1stinitialtracking.biometria.fetos.feto$.igCA.label': 'AC',
    '1stinitialtracking.biometria.fetos.feto$.cf.label': 'CF',
    '1stinitialtracking.biometria.fetos.feto$.igCF.label': 'CF',
    '1stinitialtracking.biometria.fetos.feto$.cu.label': 'UM',
    '1stinitialtracking.biometria.fetos.feto$.igCU.label': 'UM',
    '1stinitialtracking.biometria.fetos.feto$.ductoVenoso.label': 'Dotto venoso',
    '1stinitialtracking.biometria.fetos.feto$.ductoVenosoIG.label': 'DV',
    '1stinitialtracking.biometria.fetos.feto$.tn.label': 'TN',
    '1stinitialtracking.biometria.fetos.feto$.igTN.label': 'TN',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.label': 'Osso nasale',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.items.Presente.text': 'presente',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.items.Ausente.text': 'assente',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.label': 'Rigurgito tricuspide',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.items.Presente.text': 'presente',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.items.Ausente.text': 'assente',
    '1stinitialtracking.biometria.fetos.feto$.visiculaVitelinia.label': 'Vitamina gall',
    '1stinitialtracking.biometria.fetos.feto$.bcf.label': 'BCF',
    '1stinitialtracking.biometria.fetos.feto$.dopplerUtirinas.label': 'Doppler uterino',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaEsquerda.label': "PI dell'utero sinistro",
    '1stinitialtracking.biometria.fetos.feto$.piUterinaDireita.label': 'PI uterino destro',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaMedia.label': 'PI uterino (medio)',
    '1stinitialtracking.anatomiaFetal.label': 'ANATOMIA FETALE',
    '1stinitialtracking.anatomiaFetal.fetos.label': 'feti',
    '1stinitialtracking.anatomiaFetal.fetos.feto$.label': 'feto',
    '1stinitialtracking.avalRiscoTrissomia.label': 'VALUTAZIONE DEL RISCHIO PER LA TRISSOMIA',
    '1stinitialtracking.avalRiscoTrissomia.labelIncid.label': 'Incidenza della trisomia nella precedente gravidanza',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.label': 'T21',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.items.1.text': 'sì',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.items.0.text': 'non',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.label': 'T18',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.items.1.text': 'sì',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.items.0.text': 'non',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.label': 'T13',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.items.1.text': 'sì',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.items.0.text': 'non',
    '1stinitialtracking.avalRiscoTrissomia.fetos.label': 'feti',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.label': 'feto',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia21.label': 'Rischio di trisomia 21 per età materna',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia21Corrigido.label': 'fisso',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia18.label': 'Rischio di trisomia 18 per età materna',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia18Corrigido.label': 'fisso',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia13.label': 'Rischio di trisomia 13 per età materna',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia13Corrigido.label': 'fisso',
    '1stinitialtracking.graph.label': 'grafica',
    '1stinitialtracking.graph.ccn.label': 'CCN',
    '1stinitialtracking.graph.dbp.label': 'DBP',
    '1stinitialtracking.graph.cc.label': 'CC',
    '1stinitialtracking.graph.ca.label': 'AC',
    '1stinitialtracking.graph.cf.label': 'CF',
    '1stinitialtracking.graph.cu.label': 'UM',
    '1stinitialtracking.graph.tn.label': 'TN',
    '1stinitialtracking.conclusao.label': 'Osservazioni',
    '1stinitialtracking.conclusao.conclusao.label': 'Osservazioni',
    '2ndand3rdquarter.label': '2 ° e 3 ° trimestre',
    '2ndand3rdquarter.avaliacaoGestacao.label': 'GESTIONE DELLA VALUTAZIONE',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.label': 'feti',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.label': 'feto',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.label': 'corionicità',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.1.text': 'Monocoriônico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.2.text': 'Dicoriônico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.3.text': 'Tricoriônico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.label': 'Amniocidade',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.1.text': 'Monoamniótico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.2.text': 'Diamniótico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.3.text': 'Trioamniótico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.label': 'Situazione fetale',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Longitudinal.text': 'longitudinale',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Transversal.text': 'trasversale',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Oblíqua.text': 'obliquo',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.label': 'Presentazione fetale',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Cefálica.text': 'cefalico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Pélvica.text': 'pelvico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Córmica.text': 'Córmica',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Outros.text': 'altro',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.label': 'Ritorno fetale',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Anterior.text': 'precedente',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Posterior.text': 'posteriore',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral direita.text': 'Lato destro',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral esquerda.text': 'Lato sinistro',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Outros.text': 'altro',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.label': 'Movimenti fetali',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Presente.text': 'presente',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Ausente.text': 'assente',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.label': 'Battiti fetali',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Presente.text': 'presente',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Ausente.text': 'assente',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.bcf.label': 'BCF',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.label': 'placenta',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Anterior.text': 'precedente',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Posterior.text': 'posteriore',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral direita.text': 'Lato destro',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral esquerda.text': 'Lato sinistro',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia parcial.text': 'Anteprima parziale',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia total.text': 'Anteprima totale',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Outros.text': 'altro',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.label': 'Placental Maturity (GRANUMM)',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.0.text': '0',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.I.text': 'io',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.II.text': 'II',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.III.text': 'III',
    '2ndand3rdquarter.biometria.label': 'BIOMETRIA FETALE',
    '2ndand3rdquarter.biometria.fetos.label': 'feti',
    '2ndand3rdquarter.biometria.fetos.feto$.label': 'feto',
    '2ndand3rdquarter.biometria.fetos.feto$.dbp.label': 'DBP',
    '2ndand3rdquarter.biometria.fetos.feto$.igDbp.label': 'DBP',
    '2ndand3rdquarter.biometria.fetos.feto$.cc.label': 'CC',
    '2ndand3rdquarter.biometria.fetos.feto$.igCC.label': 'CC',
    '2ndand3rdquarter.biometria.fetos.feto$.ca.label': 'AC',
    '2ndand3rdquarter.biometria.fetos.feto$.igCA.label': 'AC',
    '2ndand3rdquarter.biometria.fetos.feto$.cf.label': 'CF',
    '2ndand3rdquarter.biometria.fetos.feto$.igCF.label': 'CF',
    '2ndand3rdquarter.biometria.fetos.feto$.cu.label': 'UM',
    '2ndand3rdquarter.biometria.fetos.feto$.igCU.label': 'UM',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoCCCA.label': 'Rapporto CC / CA.',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoCACF.label': 'Rapporto AC / CF',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoBPDCF.label': 'Rapporto BPD / CF.',
    '2ndand3rdquarter.biometria.fetos.feto$.pesoEstimado.label': 'Peso stimato (± 15%)',
    '2ndand3rdquarter.biometria.fetos.feto$.comprimentoEstimado.label': 'Lunghezza stimata',
    '2ndand3rdquarter.anatomiaFetal.label': 'ANATOMIA FETALE',
    '2ndand3rdquarter.anatomiaFetal.fetos.label': 'feti',
    '2ndand3rdquarter.anatomiaFetal.fetos.feto$.label': 'feto',
    '2ndand3rdquarter.avalBiofisicaFetal.label': 'VALUTAZIONE BIOFISICA FETALE',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.label': 'feti',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.label': 'feto',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.label': 'Movimento respiratorio',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Presente.text': 'presente',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Ausente.text': 'assente',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.label': 'Tono fetale',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Presente.text': 'presente',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Ausente.text': 'assente',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.label': 'Liquido amniotico',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Normal.text': 'normale',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Diminuído.text': 'diminuita',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Aumentado.text': 'esteso',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.labelILA.label': 'ILA',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qse.label': 'QSE',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qie.label': 'LL',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qsd.label': 'DSF',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qid.label': 'QID',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.ilaTotal.label': 'totale',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.maiorBolsao.label': 'Tasca più grande',
    '2ndand3rdquarter.idadeGestacional.label': 'Età gestazionale',
    '2ndand3rdquarter.idadeGestacional.calculada.label': 'calcolato',
    '2ndand3rdquarter.graph.label': 'grafica',
    '2ndand3rdquarter.graph.dbp.label': 'DBP',
    '2ndand3rdquarter.graph.cc.label': 'CC',
    '2ndand3rdquarter.graph.ca.label': 'AC',
    '2ndand3rdquarter.graph.cf.label': 'CF',
    '2ndand3rdquarter.graph.cu.label': 'UM',
    '2ndand3rdquarter.graph.pesoEstimado.label': 'Peso stimato',
    '2ndand3rdquarter.graph.ilaTotal.label': 'ILA',
    '2ndand3rdquarter.graph.maiorBolsao.label': 'Tasca più grande',
    '2ndand3rdquarter.conclusao.label': 'Osservazioni',
    '2ndand3rdquarter.conclusao.conclusao.label': 'Osservazioni',
    'morphological.label': 'MORFOLOGICO',
    'morphological.avaliacaoGestacao.label': 'GESTIONE DELLA VALUTAZIONE',
    'morphological.avaliacaoGestacao.fetos.label': 'feti',
    'morphological.avaliacaoGestacao.fetos.feto$.label': 'feto',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.label': 'corionicità',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.1.text': 'Monocoriônico',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.2.text': 'Dicoriônico',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.3.text': 'Tricoriônico',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.label': 'Amniocidade',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.1.text': 'Monoamniótico',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.2.text': 'Diamniótico',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.3.text': 'Trioamniótico',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.label': 'Situazione fetale',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Longitudinal.text': 'longitudinale',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Transversal.text': 'trasversale',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Oblíqua.text': 'obliquo',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.label': 'Presentazione fetale',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Cefálica.text': 'cefalico',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Pélvica.text': 'pelvico',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Córmica.text': 'Córmica',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Outros.text': 'altro',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.label': 'Ritorno fetale',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Anterior.text': 'precedente',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Posterior.text': 'posteriore',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral direita.text': 'Lato destro',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral esquerda.text': 'Lato sinistro',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Outros.text': 'altro',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.label': 'Movimenti fetali',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Presente.text': 'presente',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Ausente.text': 'assente',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.label': 'Battiti fetali',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Presente.text': 'presente',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Ausente.text': 'assente',
    'morphological.avaliacaoGestacao.fetos.feto$.bcf.label': 'BCF',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.label': 'placenta',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Anterior.text': 'precedente',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Posterior.text': 'posteriore',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral direita.text': 'Lato destro',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral esquerda.text': 'Lato sinistro',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia parcial.text': 'Anteprima parziale',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia total.text': 'Anteprima totale',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Outros.text': 'altro',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.label': 'Placental Maturity (GRANUMM)',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.0.text': '0',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.I.text': 'io',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.II.text': 'II',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.III.text': 'III',
    'morphological.biometria.label': 'BIOMETRIA FETALE DI BASE',
    'morphological.biometria.fetos.label': 'feti',
    'morphological.biometria.fetos.feto$.label': 'feto',
    'morphological.biometria.fetos.feto$.dbp.label': 'DBP',
    'morphological.biometria.fetos.feto$.igDbp.label': 'DBP',
    'morphological.biometria.fetos.feto$.cc.label': 'CC',
    'morphological.biometria.fetos.feto$.igCC.label': 'CC',
    'morphological.biometria.fetos.feto$.ca.label': 'AC',
    'morphological.biometria.fetos.feto$.igCA.label': 'AC',
    'morphological.biometria.fetos.feto$.cf.label': 'CF',
    'morphological.biometria.fetos.feto$.igCF.label': 'CF',
    'morphological.biometria.fetos.feto$.cu.label': 'UM',
    'morphological.biometria.fetos.feto$.igCU.label': 'UM',
    'morphological.biometria.fetos.feto$.relacaoCCCA.label': 'Rapporto CC / CA.',
    'morphological.biometria.fetos.feto$.relacaoCACF.label': 'Rapporto AC / CF',
    'morphological.biometria.fetos.feto$.relacaoBPDCF.label': 'Rapporto BPD / CF.',
    'morphological.biometria.fetos.feto$.pesoEstimado.label': 'Peso stimato (± 15%)',
    'morphological.biometria.fetos.feto$.comprimentoEstimado.label': 'Lunghezza stimata',
    'morphological.biometriaAvancada.label': 'BIOMETRIA FETALE AVANZATA',
    'morphological.biometriaAvancada.fetos.label': 'feti',
    'morphological.biometriaAvancada.fetos.feto$.label': 'feto',
    'morphological.biometriaAvancada.fetos.feto$.diametroCerebelar.label': 'Diametro cerebellare',
    'morphological.biometriaAvancada.fetos.feto$.diametroCerebelarIG.label': 'percentile',
    'morphological.biometriaAvancada.fetos.feto$.cisternaMagna.label': 'Cisterna Magna',
    'morphological.biometriaAvancada.fetos.feto$.cisternaMagnaIG.label': 'percentile',
    'morphological.biometriaAvancada.fetos.feto$.atrioVentriculoLateral.label': 'Atrio del ventricolo laterale',
    'morphological.biometriaAvancada.fetos.feto$.atrioVentriculoLateralIG.label': 'percentile',
    'morphological.biometriaAvancada.fetos.feto$.diametroOcular.label': "Diametro dell'occhio",
    'morphological.biometriaAvancada.fetos.feto$.diametroOcularIG.label': 'percentile',
    'morphological.biometriaAvancada.fetos.feto$.distanciaInterocular.label': 'Distanza interoculare',
    'morphological.biometriaAvancada.fetos.feto$.distanciaInterocularIG.label': 'percentile',
    'morphological.biometriaAvancada.fetos.feto$.distanciaBinocular.label': 'Distanza binoculare',
    'morphological.biometriaAvancada.fetos.feto$.distanciaBinocularIG.label': 'percentile',
    'morphological.biometriaAvancada.fetos.feto$.quintoDedoMao.label': 'Quinto dito',
    'morphological.biometriaAvancada.fetos.feto$.quintoDedoMaoIG.label': 'percentile',
    'morphological.biometriaAvancada.fetos.feto$.ossoNasal.label': 'Osso nasale',
    'morphological.biometriaAvancada.fetos.feto$.pe.label': 'piede',
    'morphological.biometriaAvancada.fetos.feto$.diamPelvisRenalDir.label': 'Dia. Bacino renale dir',
    'morphological.biometriaAvancada.fetos.feto$.diamPelvisRenalEsq.label': 'Dia. Bacino renale sinistro',
    'morphological.anatomiaFetal.label': 'ANATOMIA FETALE',
    'morphological.anatomiaFetal.fetos.label': 'feti',
    'morphological.anatomiaFetal.fetos.feto$.label': 'feto',
    'morphological.avalBiofisicaFetal.label': 'VALUTAZIONE BIOFISICA FETALE',
    'morphological.avalBiofisicaFetal.fetos.label': 'feti',
    'morphological.avalBiofisicaFetal.fetos.feto$.label': 'feto',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.label': 'Movimento respiratorio',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Presente.text': 'presente',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Ausente.text': 'assente',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.label': 'Tono fetale',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Presente.text': 'presente',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Ausente.text': 'assente',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.label': 'Liquido amniotico',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Normal.text': 'normale',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Diminuído.text': 'diminuita',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Aumentado.text': 'esteso',
    'morphological.avalBiofisicaFetal.fetos.feto$.labelILA.label': 'ILA',
    'morphological.avalBiofisicaFetal.fetos.feto$.qse.label': 'QSE',
    'morphological.avalBiofisicaFetal.fetos.feto$.qie.label': 'LL',
    'morphological.avalBiofisicaFetal.fetos.feto$.qsd.label': 'DSF',
    'morphological.avalBiofisicaFetal.fetos.feto$.qid.label': 'QID',
    'morphological.avalBiofisicaFetal.fetos.feto$.ilaTotal.label': 'totale',
    'morphological.avalBiofisicaFetal.fetos.feto$.maiorBolsao.label': 'Tasca più grande',
    'morphological.graph.label': 'grafica',
    'morphological.graph.dbp.label': 'DBP',
    'morphological.graph.cc.label': 'CC',
    'morphological.graph.ca.label': 'AC',
    'morphological.graph.cf.label': 'CF',
    'morphological.graph.cu.label': 'UM',
    'morphological.graph.pesoEstimado.label': 'Peso stimato',
    'morphological.graph.ilaTotal.label': 'ILA',
    'morphological.graph.maiorBolsao.label': 'Tasca più grande',
    'morphological.graph.ossoNasal.label': 'Osso nasale',
    'morphological.graph.diamPelvisRenalEsq.label': 'Bacino renale sinistro',
    'morphological.graph.diamPalvisRenalDir.label': 'Bacino renale destro',
    'morphological.conclusao.label': 'Osservazioni',
    'morphological.conclusao.conclusao.label': 'Osservazioni',
    'obstetricdoppler.label': 'DOPPLER ostetrico',
    'obstetricdoppler.uterinas.label': 'UTERINO',
    'obstetricdoppler.uterinas.uterinaEsquerda.label': 'Uterina sinistra',
    'obstetricdoppler.uterinas.piUterinaEsquerda.label': "PI dell'utero sinistro",
    'obstetricdoppler.uterinas.riUterinaEsquerda.label': 'IR uterino sinistro',
    'obstetricdoppler.uterinas.uterinaDireita.label': 'Uterina destra',
    'obstetricdoppler.uterinas.piUterinaDireita.label': 'PI uterino destro',
    'obstetricdoppler.uterinas.riUterinaDireita.label': 'IR uterino destro',
    'obstetricdoppler.uterinas.uterinaMedia.label': 'Uterina media',
    'obstetricdoppler.uterinas.piUterinaMedia.label': 'PI uterino (medio)',
    'obstetricdoppler.fetal.label': 'FETALE',
    'obstetricdoppler.fetal.fetos.label': 'feti',
    'obstetricdoppler.fetal.fetos.feto$.label': 'feto',
    'obstetricdoppler.fetal.fetos.feto$.umbilical.label': 'ombelicale',
    'obstetricdoppler.fetal.fetos.feto$.piUmbilical.label': 'PI',
    'obstetricdoppler.fetal.fetos.feto$.riUmbilical.label': 'RI',
    'obstetricdoppler.fetal.fetos.feto$.diastole.label': 'diastole',
    'obstetricdoppler.fetal.fetos.feto$.diastole.items.PRESENTE.text': 'presente',
    'obstetricdoppler.fetal.fetos.feto$.diastole.items.AUSENTE.text': 'assente',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.label': 'Diastole Zero',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.items.PRESENTE.text': 'presente',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.items.AUSENTE.text': 'assente',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.label': 'Diastole inversa',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.items.PRESENTE.text': 'presente',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.items.AUSENTE.text': 'assente',
    'obstetricdoppler.fetal.fetos.feto$.cerebral.label': 'cerebrale',
    'obstetricdoppler.fetal.fetos.feto$.piCerebral.label': 'PI',
    'obstetricdoppler.fetal.fetos.feto$.velocSistolica.label': 'Velocità. sistolica',
    'obstetricdoppler.fetal.fetos.feto$.relacaoCerebralPlacentariaLabel.label': 'Cervello / relazione placentare',
    'obstetricdoppler.fetal.fetos.feto$.relacaoCerebralPlacentaria.label': 'PI cerebrale / PI ombelicale',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.label': 'centralizzazione',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.items.SIM.text': 'sì',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.items.NAO.text': 'non',
    'obstetricdoppler.fetal.fetos.feto$.ductoVenoso.label': 'Dotto venoso',
    'obstetricdoppler.fetal.fetos.feto$.piDuctoVenoso.label': 'PI',
    'obstetricdoppler.fetal.fetos.feto$.ductoVenosoIG.label': 'DV',
    'obstetricdoppler.fetal.fetos.feto$.saDuctoVenoso.label': 'S / A',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.label': 'Onda A',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.Positivo.text': 'positivo',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.Zero.text': 'zero',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.FluxoReverso.text': 'Flusso inverso',
    'obstetricdoppler.conclusao.label': 'Osservazioni',
    'obstetricdoppler.conclusao.conclusao.label': 'Osservazioni',
    'conclusion.label': 'conclusione',
    'conclusion.text.label': 'conclusione'
  },
  'fr': {
    'gestationalAge.label': 'Les informations',
    'gestationalAge.info.label': 'La gestation',
    'gestationalAge.info.interationDate.label': "Date de l'examen",
    'gestationalAge.info.dateBirthMother.label': 'Date de naissance de la mère',
    'gestationalAge.info.via.label': "Itinéraire d'examen",
    'gestationalAge.info.via.items.abdominal.text': 'Abdominale',
    'gestationalAge.info.via.items.transvaginal.text': 'Transvaginale',
    'gestationalAge.info.indicacao.label': "Indication d'examen",
    'gestationalAge.info.indicacao.items.Datar gestação.text': 'Rencontres de grossesse',
    'gestationalAge.info.indicacao.items.Rastreio de aneuploidias.text': "Dépistage de l'aneuploïdie",
    'gestationalAge.info.indicacao.items.Sangramento.text': 'Saignement',
    'gestationalAge.info.indicacao.items.Diagnosticar gestação.text': 'Diagnostiquer la grossesse',
    'gestationalAge.info.qualidade.label': "Qualité d'examen",
    'gestationalAge.info.qualidade.items.Satisfatória.text': 'Satisfaisant',
    'gestationalAge.info.qualidade.items.Prejudicado pela adiposidade materna.text': "Nuisible par l'adiposité maternelle",
    'gestationalAge.info.qualidade.items.Prejudicado pela estática fetal.text': 'Nocif par la statique fœtale',
    'gestationalAge.info.qualidade.items.Prejudicado pela movimentação fetal.text': 'Blessé par le mouvement fœtal',
    'gestationalAge.info.calculo.label': "Calcul de l'âge gestationnel",
    'gestationalAge.info.calculo.items.DUM.text': 'Dernière période',
    'gestationalAge.info.calculo.items.exame-anterior.text': 'Examen précédent',
    'gestationalAge.info.calculo.items.informada.text': 'Patient informé',
    'gestationalAge.info.calculo.items.data-parto.text': 'Date probable de livraison',
    'gestationalAge.info.calculo.items.desconhecido.text': 'Inconnu',
    'gestationalAge.info.calculo.items.manual.text': 'Manuel',
    'gestationalAge.info.date.label': 'Date',
    'gestationalAge.info.dateTest.label': 'Date',
    'gestationalAge.info.weeks.label': 'Semaines',
    'gestationalAge.info.days.label': 'Jours',
    'gestationalAge.info.calculada.label': 'Calculé',
    'gestationalAge.info.concepcao.label': 'Méthode de conception',
    'gestationalAge.info.concepcao.items.Espontânea.text': 'Spontané',
    'gestationalAge.info.concepcao.items.Indução da ovulação.text': "Induction d'ovulation",
    'gestationalAge.info.concepcao.items.Fertilização in vitro.text': 'Fécondation in vitro',
    'gestationalAge.info.fertilizacaoInVitro.label': 'Fertilisation In Vitro',
    'gestationalAge.info.fertilizacaoInVitro.items.Normal.text': 'Normal',
    'gestationalAge.info.fertilizacaoInVitro.items.Doação de óvulo.text': "Don d'oeufs",
    'gestationalAge.info.fertilizacaoInVitro.items.Óvulo congelado.text': 'Oeuf congelé',
    'gestationalAge.info.dateDoadora.label': 'Date de naissance du donneur',
    'gestationalAge.info.dateCongelamento.label': 'Date de gel',
    'gestationalAge.info.qtdSacoGestacional.label': 'Nombre de sacs de gestation',
    'gestationalAge.info.qtdSacoGestacional.items.1.text': 'Un',
    'gestationalAge.info.qtdSacoGestacional.items.2.text': 'Deux',
    'gestationalAge.info.qtdSacoGestacional.items.3.text': 'Trois',
    'gestationalAge.info.qtdSacoGestacional.items.4.text': 'Quatre',
    'gestationalAge.info.fetos.label': 'Embryons / Foetus',
    'gestationalAge.info.fetos.items.0.text': 'Anembrionada',
    'gestationalAge.info.fetos.items.1.text': 'Unique',
    'gestationalAge.info.fetos.items.2.text': 'Gémir',
    'gestationalAge.info.fetos.items.3.text': 'Triple',
    'gestationalAge.info.fetos.items.4.text': 'Quadruple',
    'gestationalAge.info.fetos.items.Não visto.text': 'Pas vu',
    'gestationalAge.info.movimentosFetais.label': 'Mouvements foetaux',
    'gestationalAge.info.movimentosFetais.items.presente.text': 'Cadeau',
    'gestationalAge.info.movimentosFetais.items.ausente.text': 'Manquant',
    '1stinitialquarter.label': '1er trimestre',
    '1stinitialquarter.exame.label': 'INFORMATION',
    '1stinitialquarter.exame.sacoGestacional.label': 'Sac gestationnel',
    '1stinitialquarter.exame.sacoGestacional.items.regular.text': 'Pour réguler',
    '1stinitialquarter.exame.sacoGestacional.items.irregular.text': 'Tacheté',
    '1stinitialquarter.exame.localizacao.label': 'Emplacement',
    '1stinitialquarter.exame.localizacao.items.fundo uterino.text': 'Fond utérin',
    '1stinitialquarter.exame.localizacao.items.corporal.text': 'Caporal',
    '1stinitialquarter.exame.localizacao.items.colo.text': 'Tour',
    '1stinitialquarter.exame.localizacao.items.cicatriz cesariana.text': 'Cicatrice césarienne',
    '1stinitialquarter.exame.deslocamentoOvular.label': 'Détachement ovulaire',
    '1stinitialquarter.exame.deslocamentoOvular.items.presente.text': 'Cadeau',
    '1stinitialquarter.exame.deslocamentoOvular.items.ausente.text': 'Manquant',
    '1stinitialquarter.exame.hematoma.label': 'Ecchymose',
    '1stinitialquarter.exame.hematoma.items.corion frondoso.text': 'Corion feuillu',
    '1stinitialquarter.exame.hematoma.items.corion liso.text': 'Corion lisse',
    '1stinitialquarter.exame.hematoma.items.ausente.text': 'Manquant',
    '1stinitialquarter.biometria.label': 'Embryon',
    '1stinitialquarter.biometria.sacos.label': 'Les sacs',
    '1stinitialquarter.biometria.sacos.saco$.label': 'Sac',
    '1stinitialquarter.biometria.sacos.saco$.long.label': 'Long',
    '1stinitialquarter.biometria.sacos.saco$.ap.label': 'Ap.',
    '1stinitialquarter.biometria.sacos.saco$.transv.label': 'Transv.',
    '1stinitialquarter.biometria.sacos.saco$.measure.label': 'Moyenne',
    '1stinitialquarter.biometria.sacos.saco$.idadeGestaSaco.label': 'Sac',
    '1stinitialquarter.biometria.fetos.label': 'Foetus',
    '1stinitialquarter.biometria.fetos.feto$.label': 'Foetus',
    '1stinitialquarter.biometria.fetos.feto$.saco.label': 'Sac',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.1.text': 'Sac 1',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.2.text': 'Sac 2',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.3.text': 'Sac 3',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.4.text': 'Sac 4',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.5.text': 'Sac 5',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.6.text': 'Sac 6',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.7.text': 'Sac 7',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.8.text': 'Sac 8',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.label': 'Mouvements embryonnaires',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.items.presente.text': 'Cadeau',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.items.ausente.text': 'Manquant',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.label': 'Battements embryonnaires / foetaux',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.items.presente.text': 'Cadeau',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.items.ausente.text': 'Manquant',
    '1stinitialquarter.biometria.fetos.feto$.visiculaVitelinia.label': 'Galle de vitelline',
    '1stinitialquarter.biometria.fetos.feto$.bcf.label': 'BCF',
    '1stinitialquarter.biometria.fetos.feto$.ccn.label': 'CCN',
    '1stinitialquarter.biometria.fetos.feto$.igCCN.label': 'CCN',
    '1stinitialquarter.ovarios.label': 'OVARIES ET ATTACHEMENTS',
    '1stinitialquarter.ovarios.direito.label': 'Loi',
    '1stinitialquarter.ovarios.direitoAspecto.label': 'Aspect',
    '1stinitialquarter.ovarios.direitoAspecto.items.normal.text': 'Normal',
    '1stinitialquarter.ovarios.direitoAspecto.items.alterado.text': 'Changé',
    '1stinitialquarter.ovarios.direitoAspecto.items.não visto.text': 'Pas vu',
    '1stinitialquarter.ovarios.direitoLong.label': 'Longitudinal',
    '1stinitialquarter.ovarios.direitoAnte.label': 'Antérieur postérieur',
    '1stinitialquarter.ovarios.direitoTransv.label': 'Transversal',
    '1stinitialquarter.ovarios.direitoVolume.label': 'Volume',
    '1stinitialquarter.ovarios.esquerdo.label': 'Gauche',
    '1stinitialquarter.ovarios.esquerdoAspecto.label': 'Aspect',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.normal.text': 'Normal',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.alterado.text': 'Changé',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.não visto.text': 'Pas vu',
    '1stinitialquarter.ovarios.esquerdoLong.label': 'Longitudinal',
    '1stinitialquarter.ovarios.esquerdoAnte.label': 'Antérieur postérieur',
    '1stinitialquarter.ovarios.esquerdoTransv.label': 'Transversal',
    '1stinitialquarter.ovarios.esquerdoVolume.label': 'Volume',
    '1stinitialquarter.ovarios.anexos.label': 'Les pièces jointes',
    '1stinitialquarter.ovarios.anexos.items.normal.text': 'Normal',
    '1stinitialquarter.ovarios.anexos.items.alterado.text': 'Changé',
    '1stinitialquarter.ovarios.corpoluteo.label': 'Corps luth',
    '1stinitialquarter.ovarios.corpoluteo.items.direito.text': 'Loi',
    '1stinitialquarter.ovarios.corpoluteo.items.esquerdo.text': 'Gauche',
    '1stinitialquarter.ovarios.corpoluteo.items.naovisto.text': 'Pas vu',
    '1stinitialquarter.graph.label': 'Graphiques',
    '1stinitialquarter.graph.sacoGestacional.label': 'Sac gestationnel',
    '1stinitialquarter.graph.ccn.label': 'CCN',
    '1stinitialquarter.conclusao.label': 'Observations',
    '1stinitialquarter.conclusao.conclusao.label': 'Observations',
    '1stinitialtracking.label': 'VOLET DU 1ER TRIMESTRE',
    '1stinitialtracking.biometria.label': 'BIOMETRIE FOETALE',
    '1stinitialtracking.biometria.fetos.label': 'Foetus',
    '1stinitialtracking.biometria.fetos.feto$.label': 'Foetus',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.label': 'Chorionicité',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.1.text': 'Monochorionique',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.2.text': 'Dichorionique',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.3.text': 'Trichorionique',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.label': 'Amniocité',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.1.text': 'Monoamniotique',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.2.text': 'Diamniotic',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.3.text': 'Trioamniotique',
    '1stinitialtracking.biometria.fetos.feto$.ccn.label': 'CCN',
    '1stinitialtracking.biometria.fetos.feto$.idadeGestaCCN.label': 'CCN',
    '1stinitialtracking.biometria.fetos.feto$.dbp.label': 'DBP',
    '1stinitialtracking.biometria.fetos.feto$.igDbp.label': 'DBP',
    '1stinitialtracking.biometria.fetos.feto$.cc.label': 'CC',
    '1stinitialtracking.biometria.fetos.feto$.igCC.label': 'CC',
    '1stinitialtracking.biometria.fetos.feto$.ca.label': 'CA',
    '1stinitialtracking.biometria.fetos.feto$.igCA.label': 'CA',
    '1stinitialtracking.biometria.fetos.feto$.cf.label': 'CF',
    '1stinitialtracking.biometria.fetos.feto$.igCF.label': 'CF',
    '1stinitialtracking.biometria.fetos.feto$.cu.label': 'UM',
    '1stinitialtracking.biometria.fetos.feto$.igCU.label': 'UM',
    '1stinitialtracking.biometria.fetos.feto$.ductoVenoso.label': 'Conduit veineux',
    '1stinitialtracking.biometria.fetos.feto$.ductoVenosoIG.label': 'DV',
    '1stinitialtracking.biometria.fetos.feto$.tn.label': 'TN',
    '1stinitialtracking.biometria.fetos.feto$.igTN.label': 'TN',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.label': 'Os nasal',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.items.Presente.text': 'Cadeau',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.items.Ausente.text': 'Manquant',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.label': 'Régurgitation tricuspide',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.items.Presente.text': 'Cadeau',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.items.Ausente.text': 'Manquant',
    '1stinitialtracking.biometria.fetos.feto$.visiculaVitelinia.label': 'Galle de vitelline',
    '1stinitialtracking.biometria.fetos.feto$.bcf.label': 'BCF',
    '1stinitialtracking.biometria.fetos.feto$.dopplerUtirinas.label': 'Doppler utérin',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaEsquerda.label': "PI de l'utérus gauche",
    '1stinitialtracking.biometria.fetos.feto$.piUterinaDireita.label': 'PI utérin droit',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaMedia.label': 'PI utérin (moyenne)',
    '1stinitialtracking.anatomiaFetal.label': 'ANATOMIE FOETALE',
    '1stinitialtracking.anatomiaFetal.fetos.label': 'Foetus',
    '1stinitialtracking.anatomiaFetal.fetos.feto$.label': 'Foetus',
    '1stinitialtracking.avalRiscoTrissomia.label': 'ÉVALUATION DES RISQUES LIÉS À LA TRISSOMIE',
    '1stinitialtracking.avalRiscoTrissomia.labelIncid.label': 'Incidence de la trisomie dans la grossesse précédente',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.label': 'T21',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.items.1.text': 'Oui',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.items.0.text': 'Non',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.label': 'T18',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.items.1.text': 'Oui',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.items.0.text': 'Non',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.label': 'T13',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.items.1.text': 'Oui',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.items.0.text': 'Non',
    '1stinitialtracking.avalRiscoTrissomia.fetos.label': 'Foetus',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.label': 'Foetus',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia21.label': "Risque de trisomie 21 selon l'âge de la mère",
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia21Corrigido.label': 'Fixe',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia18.label': "Risque de trisomie 18 selon l'âge de la mère",
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia18Corrigido.label': 'Fixe',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia13.label': "Risque de trisomie 13 selon l'âge de la mère",
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia13Corrigido.label': 'Fixe',
    '1stinitialtracking.graph.label': 'Graphiques',
    '1stinitialtracking.graph.ccn.label': 'CCN',
    '1stinitialtracking.graph.dbp.label': 'DBP',
    '1stinitialtracking.graph.cc.label': 'CC',
    '1stinitialtracking.graph.ca.label': 'CA',
    '1stinitialtracking.graph.cf.label': 'CF',
    '1stinitialtracking.graph.cu.label': 'UM',
    '1stinitialtracking.graph.tn.label': 'TN',
    '1stinitialtracking.conclusao.label': 'Observations',
    '1stinitialtracking.conclusao.conclusao.label': 'Observations',
    '2ndand3rdquarter.label': '2ème et 3ème trimestre',
    '2ndand3rdquarter.avaliacaoGestacao.label': "GESTION D'EVALUATION",
    '2ndand3rdquarter.avaliacaoGestacao.fetos.label': 'Foetus',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.label': 'Foetus',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.label': 'Chorionicité',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.1.text': 'Monochorionique',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.2.text': 'Dichorionique',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.3.text': 'Trichorionique',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.label': 'Amniocité',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.1.text': 'Monoamniotique',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.2.text': 'Diamniotic',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.3.text': 'Trioamniotique',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.label': 'Situation foetale',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Longitudinal.text': 'Longitudinal',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Transversal.text': 'Coupe transversale',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Oblíqua.text': 'Oblique',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.label': 'Présentation fœtale',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Cefálica.text': 'Céphalique',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Pélvica.text': 'Pelvien',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Córmica.text': 'Formica',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Outros.text': 'Autre',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.label': 'Dos fœtal',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Anterior.text': 'Précédent',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Posterior.text': 'Plus tard',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral direita.text': 'Côté droit',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral esquerda.text': 'Côté gauche',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Outros.text': 'Autre',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.label': 'Mouvements foetaux',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Presente.text': 'Cadeau',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Ausente.text': 'Manquant',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.label': 'Battements foetaux',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Presente.text': 'Cadeau',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Ausente.text': 'Manquant',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.bcf.label': 'BCF',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.label': 'Placenta',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Anterior.text': 'Précédent',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Posterior.text': 'Plus tard',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral direita.text': 'Côté droit',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral esquerda.text': 'Côté gauche',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia parcial.text': 'Aperçu partiel',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia total.text': 'Aperçu total',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Outros.text': 'Autre',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.label': 'Maturité placentaire (GRANUMM)',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.0.text': '0',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.I.text': 'Je',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.II.text': 'II',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.III.text': 'III',
    '2ndand3rdquarter.biometria.label': 'BIOMETRIE FOETALE',
    '2ndand3rdquarter.biometria.fetos.label': 'Foetus',
    '2ndand3rdquarter.biometria.fetos.feto$.label': 'Foetus',
    '2ndand3rdquarter.biometria.fetos.feto$.dbp.label': 'DBP',
    '2ndand3rdquarter.biometria.fetos.feto$.igDbp.label': 'DBP',
    '2ndand3rdquarter.biometria.fetos.feto$.cc.label': 'CC',
    '2ndand3rdquarter.biometria.fetos.feto$.igCC.label': 'CC',
    '2ndand3rdquarter.biometria.fetos.feto$.ca.label': 'CA',
    '2ndand3rdquarter.biometria.fetos.feto$.igCA.label': 'CA',
    '2ndand3rdquarter.biometria.fetos.feto$.cf.label': 'CF',
    '2ndand3rdquarter.biometria.fetos.feto$.igCF.label': 'CF',
    '2ndand3rdquarter.biometria.fetos.feto$.cu.label': 'UM',
    '2ndand3rdquarter.biometria.fetos.feto$.igCU.label': 'UM',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoCCCA.label': 'Ratio DC / AC',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoCACF.label': 'Ratio AC / CF',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoBPDCF.label': 'Ratio BPD / FC',
    '2ndand3rdquarter.biometria.fetos.feto$.pesoEstimado.label': 'Poids estimé (± 15%)',
    '2ndand3rdquarter.biometria.fetos.feto$.comprimentoEstimado.label': 'Longueur estimée',
    '2ndand3rdquarter.anatomiaFetal.label': 'ANATOMIE FOETALE',
    '2ndand3rdquarter.anatomiaFetal.fetos.label': 'Foetus',
    '2ndand3rdquarter.anatomiaFetal.fetos.feto$.label': 'Foetus',
    '2ndand3rdquarter.avalBiofisicaFetal.label': 'EVALUATION BIOPHYSIQUE DU FOET',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.label': 'Foetus',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.label': 'Foetus',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.label': 'Mouvement de respiration',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Presente.text': 'Cadeau',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Ausente.text': 'Manquant',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.label': 'Tonus fœtal',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Presente.text': 'Cadeau',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Ausente.text': 'Manquant',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.label': 'Liquide amniotique',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Normal.text': 'Normal',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Diminuído.text': 'Diminué',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Aumentado.text': 'Augmenté',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.labelILA.label': 'ILA',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qse.label': 'QSE',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qie.label': 'QIE',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qsd.label': 'QSD',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qid.label': 'QID',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.ilaTotal.label': 'Total',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.maiorBolsao.label': 'La plus grande poche',
    '2ndand3rdquarter.idadeGestacional.label': 'Âge gestationnel',
    '2ndand3rdquarter.idadeGestacional.calculada.label': 'Calculé',
    '2ndand3rdquarter.graph.label': 'Graphiques',
    '2ndand3rdquarter.graph.dbp.label': 'DBP',
    '2ndand3rdquarter.graph.cc.label': 'CC',
    '2ndand3rdquarter.graph.ca.label': 'CA',
    '2ndand3rdquarter.graph.cf.label': 'CF',
    '2ndand3rdquarter.graph.cu.label': 'UM',
    '2ndand3rdquarter.graph.pesoEstimado.label': 'Poids estimé',
    '2ndand3rdquarter.graph.ilaTotal.label': 'ILA',
    '2ndand3rdquarter.graph.maiorBolsao.label': 'La plus grande poche',
    '2ndand3rdquarter.conclusao.label': 'Observations',
    '2ndand3rdquarter.conclusao.conclusao.label': 'Observations',
    'morphological.label': 'MORPHOLOGIQUE',
    'morphological.avaliacaoGestacao.label': "GESTION D'EVALUATION",
    'morphological.avaliacaoGestacao.fetos.label': 'Foetus',
    'morphological.avaliacaoGestacao.fetos.feto$.label': 'Foetus',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.label': 'Chorionicité',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.1.text': 'Monochorionique',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.2.text': 'Dichorionique',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.3.text': 'Trichorionique',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.label': 'Amniocité',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.1.text': 'Monoamniotique',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.2.text': 'Diamniotic',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.3.text': 'Trioamniotique',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.label': 'Situation foetale',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Longitudinal.text': 'Longitudinal',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Transversal.text': 'Coupe transversale',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Oblíqua.text': 'Oblique',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.label': 'Présentation fœtale',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Cefálica.text': 'Céphalique',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Pélvica.text': 'Pelvien',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Córmica.text': 'Formica',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Outros.text': 'Autre',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.label': 'Dos fœtal',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Anterior.text': 'Précédent',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Posterior.text': 'Plus tard',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral direita.text': 'Côté droit',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral esquerda.text': 'Côté gauche',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Outros.text': 'Autre',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.label': 'Mouvements foetaux',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Presente.text': 'Cadeau',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Ausente.text': 'Manquant',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.label': 'Battements foetaux',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Presente.text': 'Cadeau',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Ausente.text': 'Manquant',
    'morphological.avaliacaoGestacao.fetos.feto$.bcf.label': 'BCF',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.label': 'Placenta',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Anterior.text': 'Précédent',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Posterior.text': 'Plus tard',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral direita.text': 'Côté droit',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral esquerda.text': 'Côté gauche',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia parcial.text': 'Aperçu partiel',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia total.text': 'Aperçu total',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Outros.text': 'Autre',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.label': 'Maturité placentaire (GRANUMM)',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.0.text': '0',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.I.text': 'Je',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.II.text': 'II',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.III.text': 'III',
    'morphological.biometria.label': 'BIOMÉTRIE FŒTALE DE BASE',
    'morphological.biometria.fetos.label': 'Foetus',
    'morphological.biometria.fetos.feto$.label': 'Foetus',
    'morphological.biometria.fetos.feto$.dbp.label': 'DBP',
    'morphological.biometria.fetos.feto$.igDbp.label': 'DBP',
    'morphological.biometria.fetos.feto$.cc.label': 'CC',
    'morphological.biometria.fetos.feto$.igCC.label': 'CC',
    'morphological.biometria.fetos.feto$.ca.label': 'CA',
    'morphological.biometria.fetos.feto$.igCA.label': 'CA',
    'morphological.biometria.fetos.feto$.cf.label': 'CF',
    'morphological.biometria.fetos.feto$.igCF.label': 'CF',
    'morphological.biometria.fetos.feto$.cu.label': 'UM',
    'morphological.biometria.fetos.feto$.igCU.label': 'UM',
    'morphological.biometria.fetos.feto$.relacaoCCCA.label': 'Ratio DC / AC',
    'morphological.biometria.fetos.feto$.relacaoCACF.label': 'Ratio AC / CF',
    'morphological.biometria.fetos.feto$.relacaoBPDCF.label': 'Ratio BPD / FC',
    'morphological.biometria.fetos.feto$.pesoEstimado.label': 'Poids estimé (± 15%)',
    'morphological.biometria.fetos.feto$.comprimentoEstimado.label': 'Longueur estimée',
    'morphological.biometriaAvancada.label': 'BIOMÉTRIE FŒTALE AVANCÉE',
    'morphological.biometriaAvancada.fetos.label': 'Foetus',
    'morphological.biometriaAvancada.fetos.feto$.label': 'Foetus',
    'morphological.biometriaAvancada.fetos.feto$.diametroCerebelar.label': 'Diamètre cérébelleux',
    'morphological.biometriaAvancada.fetos.feto$.diametroCerebelarIG.label': 'Centile',
    'morphological.biometriaAvancada.fetos.feto$.cisternaMagna.label': 'Magna Cistern',
    'morphological.biometriaAvancada.fetos.feto$.cisternaMagnaIG.label': 'Centile',
    'morphological.biometriaAvancada.fetos.feto$.atrioVentriculoLateral.label': 'Oreillette ventricule latéral',
    'morphological.biometriaAvancada.fetos.feto$.atrioVentriculoLateralIG.label': 'Centile',
    'morphological.biometriaAvancada.fetos.feto$.diametroOcular.label': "Diamètre de l'oeil",
    'morphological.biometriaAvancada.fetos.feto$.diametroOcularIG.label': 'Centile',
    'morphological.biometriaAvancada.fetos.feto$.distanciaInterocular.label': 'Distance interoculaire',
    'morphological.biometriaAvancada.fetos.feto$.distanciaInterocularIG.label': 'Centile',
    'morphological.biometriaAvancada.fetos.feto$.distanciaBinocular.label': 'Distance binoculaire',
    'morphological.biometriaAvancada.fetos.feto$.distanciaBinocularIG.label': 'Centile',
    'morphological.biometriaAvancada.fetos.feto$.quintoDedoMao.label': 'Cinquième doigt',
    'morphological.biometriaAvancada.fetos.feto$.quintoDedoMaoIG.label': 'Centile',
    'morphological.biometriaAvancada.fetos.feto$.ossoNasal.label': 'Os nasal',
    'morphological.biometriaAvancada.fetos.feto$.pe.label': 'Pied',
    'morphological.biometriaAvancada.fetos.feto$.diamPelvisRenalDir.label': 'Dia. Bassin rénal',
    'morphological.biometriaAvancada.fetos.feto$.diamPelvisRenalEsq.label': 'Dia. Bassin rénal gauche',
    'morphological.anatomiaFetal.label': 'ANATOMIE FOETALE',
    'morphological.anatomiaFetal.fetos.label': 'Foetus',
    'morphological.anatomiaFetal.fetos.feto$.label': 'Foetus',
    'morphological.avalBiofisicaFetal.label': 'EVALUATION BIOPHYSIQUE DU FOET',
    'morphological.avalBiofisicaFetal.fetos.label': 'Foetus',
    'morphological.avalBiofisicaFetal.fetos.feto$.label': 'Foetus',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.label': 'Mouvement de respiration',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Presente.text': 'Cadeau',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Ausente.text': 'Manquant',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.label': 'Tonus fœtal',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Presente.text': 'Cadeau',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Ausente.text': 'Manquant',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.label': 'Liquide amniotique',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Normal.text': 'Normal',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Diminuído.text': 'Diminué',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Aumentado.text': 'Augmenté',
    'morphological.avalBiofisicaFetal.fetos.feto$.labelILA.label': 'ILA',
    'morphological.avalBiofisicaFetal.fetos.feto$.qse.label': 'QSE',
    'morphological.avalBiofisicaFetal.fetos.feto$.qie.label': 'QIE',
    'morphological.avalBiofisicaFetal.fetos.feto$.qsd.label': 'QSD',
    'morphological.avalBiofisicaFetal.fetos.feto$.qid.label': 'QID',
    'morphological.avalBiofisicaFetal.fetos.feto$.ilaTotal.label': 'Total',
    'morphological.avalBiofisicaFetal.fetos.feto$.maiorBolsao.label': 'La plus grande poche',
    'morphological.graph.label': 'Graphiques',
    'morphological.graph.dbp.label': 'DBP',
    'morphological.graph.cc.label': 'CC',
    'morphological.graph.ca.label': 'CA',
    'morphological.graph.cf.label': 'CF',
    'morphological.graph.cu.label': 'UM',
    'morphological.graph.pesoEstimado.label': 'Poids estimé',
    'morphological.graph.ilaTotal.label': 'ILA',
    'morphological.graph.maiorBolsao.label': 'La plus grande poche',
    'morphological.graph.ossoNasal.label': 'Os nasal',
    'morphological.graph.diamPelvisRenalEsq.label': 'Bassin rénal gauche',
    'morphological.graph.diamPalvisRenalDir.label': 'Bassin rénal droit',
    'morphological.conclusao.label': 'Observations',
    'morphological.conclusao.conclusao.label': 'Observations',
    'obstetricdoppler.label': 'DOPPLER obstétrique',
    'obstetricdoppler.uterinas.label': 'Les utérins',
    'obstetricdoppler.uterinas.uterinaEsquerda.label': 'Utérin gauche',
    'obstetricdoppler.uterinas.piUterinaEsquerda.label': "PI de l'utérus gauche",
    'obstetricdoppler.uterinas.riUterinaEsquerda.label': 'IR utérin gauche',
    'obstetricdoppler.uterinas.uterinaDireita.label': 'Utérin droit',
    'obstetricdoppler.uterinas.piUterinaDireita.label': 'PI utérin droit',
    'obstetricdoppler.uterinas.riUterinaDireita.label': 'IR utérin droit',
    'obstetricdoppler.uterinas.uterinaMedia.label': 'Utérin moyen',
    'obstetricdoppler.uterinas.piUterinaMedia.label': 'PI utérin (moyenne)',
    'obstetricdoppler.fetal.label': 'FŒTAL',
    'obstetricdoppler.fetal.fetos.label': 'Foetus',
    'obstetricdoppler.fetal.fetos.feto$.label': 'Foetus',
    'obstetricdoppler.fetal.fetos.feto$.umbilical.label': 'Ombilical',
    'obstetricdoppler.fetal.fetos.feto$.piUmbilical.label': 'PI',
    'obstetricdoppler.fetal.fetos.feto$.riUmbilical.label': 'IR',
    'obstetricdoppler.fetal.fetos.feto$.diastole.label': 'Diastole',
    'obstetricdoppler.fetal.fetos.feto$.diastole.items.PRESENTE.text': 'Cadeau',
    'obstetricdoppler.fetal.fetos.feto$.diastole.items.AUSENTE.text': 'Manquant',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.label': 'Diastole Zéro',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.items.PRESENTE.text': 'Cadeau',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.items.AUSENTE.text': 'Manquant',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.label': 'Diastole Inverse',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.items.PRESENTE.text': 'Cadeau',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.items.AUSENTE.text': 'Manquant',
    'obstetricdoppler.fetal.fetos.feto$.cerebral.label': 'Cerveau',
    'obstetricdoppler.fetal.fetos.feto$.piCerebral.label': 'PI',
    'obstetricdoppler.fetal.fetos.feto$.velocSistolica.label': 'La vitesse Systolique',
    'obstetricdoppler.fetal.fetos.feto$.relacaoCerebralPlacentariaLabel.label': 'Relation cerveau / placenta',
    'obstetricdoppler.fetal.fetos.feto$.relacaoCerebralPlacentaria.label': 'PI cérébral / PI ombilical',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.label': 'La centralisation',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.items.SIM.text': 'Oui',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.items.NAO.text': 'Non',
    'obstetricdoppler.fetal.fetos.feto$.ductoVenoso.label': 'Conduit veineux',
    'obstetricdoppler.fetal.fetos.feto$.piDuctoVenoso.label': 'PI',
    'obstetricdoppler.fetal.fetos.feto$.ductoVenosoIG.label': 'DV',
    'obstetricdoppler.fetal.fetos.feto$.saDuctoVenoso.label': 'S / A',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.label': 'Vague a',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.Positivo.text': 'Positif',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.Zero.text': 'Zéro',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.FluxoReverso.text': 'Flux inversé',
    'obstetricdoppler.conclusao.label': 'Observations',
    'obstetricdoppler.conclusao.conclusao.label': 'Observations',
    'conclusion.label': 'Conclusion',
    'conclusion.text.label': 'Conclusion'
  },
  'de': {
    'gestationalAge.label': 'Informationen',
    'gestationalAge.info.label': 'Schwangerschaft',
    'gestationalAge.info.interationDate.label': 'Prüfungsdatum',
    'gestationalAge.info.dateBirthMother.label': 'Geburtsdatum der Mutter',
    'gestationalAge.info.via.label': 'Untersuchungsroute',
    'gestationalAge.info.via.items.abdominal.text': 'Bauchmuskeln',
    'gestationalAge.info.via.items.transvaginal.text': 'Transvaginal',
    'gestationalAge.info.indicacao.label': 'Untersuchungsanzeige',
    'gestationalAge.info.indicacao.items.Datar gestação.text': 'Dating Schwangerschaft',
    'gestationalAge.info.indicacao.items.Rastreio de aneuploidias.text': 'Aneuploidie-Screening',
    'gestationalAge.info.indicacao.items.Sangramento.text': 'Blutung',
    'gestationalAge.info.indicacao.items.Diagnosticar gestação.text': 'Schwangerschaft diagnostizieren',
    'gestationalAge.info.qualidade.label': 'Prüfungsqualität',
    'gestationalAge.info.qualidade.items.Satisfatória.text': 'Zufriedenstellend',
    'gestationalAge.info.qualidade.items.Prejudicado pela adiposidade materna.text': 'Durch mütterliche Adipositas geschädigt',
    'gestationalAge.info.qualidade.items.Prejudicado pela estática fetal.text': 'Durch fetale Statik geschädigt',
    'gestationalAge.info.qualidade.items.Prejudicado pela movimentação fetal.text': 'Durch die Bewegung des Fötus geschädigt',
    'gestationalAge.info.calculo.label': 'Berechnung des Gestationsalters',
    'gestationalAge.info.calculo.items.DUM.text': 'Letzte Periode',
    'gestationalAge.info.calculo.items.exame-anterior.text': 'Vorherige Prüfung',
    'gestationalAge.info.calculo.items.informada.text': 'Patient informiert',
    'gestationalAge.info.calculo.items.data-parto.text': 'Voraussichtlicher Liefertermin',
    'gestationalAge.info.calculo.items.desconhecido.text': 'Unbekannt',
    'gestationalAge.info.calculo.items.manual.text': 'Handbuch',
    'gestationalAge.info.date.label': 'Datum',
    'gestationalAge.info.dateTest.label': 'Datum',
    'gestationalAge.info.weeks.label': 'Wochen',
    'gestationalAge.info.days.label': 'Tage',
    'gestationalAge.info.calculada.label': 'Berechnet',
    'gestationalAge.info.concepcao.label': 'Entwurfsmethode',
    'gestationalAge.info.concepcao.items.Espontânea.text': 'Spontan',
    'gestationalAge.info.concepcao.items.Indução da ovulação.text': 'Induktion des Eisprungs',
    'gestationalAge.info.concepcao.items.Fertilização in vitro.text': 'In-vitro-Fertilisation',
    'gestationalAge.info.fertilizacaoInVitro.label': 'In-Vitro-Fertilisation',
    'gestationalAge.info.fertilizacaoInVitro.items.Normal.text': 'Normal',
    'gestationalAge.info.fertilizacaoInVitro.items.Doação de óvulo.text': 'Eizellspende',
    'gestationalAge.info.fertilizacaoInVitro.items.Óvulo congelado.text': 'Gefrorenes Ei',
    'gestationalAge.info.dateDoadora.label': 'Geburtsdatum des Spenders',
    'gestationalAge.info.dateCongelamento.label': 'Datum einfrieren',
    'gestationalAge.info.qtdSacoGestacional.label': 'Anzahl der Schwangerschaftssäcke',
    'gestationalAge.info.qtdSacoGestacional.items.1.text': 'Eins',
    'gestationalAge.info.qtdSacoGestacional.items.2.text': 'Zwei',
    'gestationalAge.info.qtdSacoGestacional.items.3.text': 'Drei',
    'gestationalAge.info.qtdSacoGestacional.items.4.text': 'Vier',
    'gestationalAge.info.fetos.label': 'Embryonen / Feten',
    'gestationalAge.info.fetos.items.0.text': 'Anembrionada',
    'gestationalAge.info.fetos.items.1.text': 'Einzigartig',
    'gestationalAge.info.fetos.items.2.text': 'Stöhnen',
    'gestationalAge.info.fetos.items.3.text': 'Triple',
    'gestationalAge.info.fetos.items.4.text': 'Vierfach',
    'gestationalAge.info.fetos.items.Não visto.text': 'Nicht gesehen',
    'gestationalAge.info.movimentosFetais.label': 'Fetale Bewegungen',
    'gestationalAge.info.movimentosFetais.items.presente.text': 'Geschenk',
    'gestationalAge.info.movimentosFetais.items.ausente.text': 'Fehlt',
    '1stinitialquarter.label': '1. QUARTAL',
    '1stinitialquarter.exame.label': 'INFORMATION',
    '1stinitialquarter.exame.sacoGestacional.label': 'Schwangerschaftssack',
    '1stinitialquarter.exame.sacoGestacional.items.regular.text': 'Zu regulieren',
    '1stinitialquarter.exame.sacoGestacional.items.irregular.text': 'Fleckig',
    '1stinitialquarter.exame.localizacao.label': 'Lage',
    '1stinitialquarter.exame.localizacao.items.fundo uterino.text': 'Uterus Hintergrund',
    '1stinitialquarter.exame.localizacao.items.corporal.text': 'Unteroffizier',
    '1stinitialquarter.exame.localizacao.items.colo.text': 'Runde',
    '1stinitialquarter.exame.localizacao.items.cicatriz cesariana.text': 'Kaiserschnitt Narbe',
    '1stinitialquarter.exame.deslocamentoOvular.label': 'Ovuläre Ablösung',
    '1stinitialquarter.exame.deslocamentoOvular.items.presente.text': 'Geschenk',
    '1stinitialquarter.exame.deslocamentoOvular.items.ausente.text': 'Fehlt',
    '1stinitialquarter.exame.hematoma.label': 'Bluterguss',
    '1stinitialquarter.exame.hematoma.items.corion frondoso.text': 'Belaubtes Corion',
    '1stinitialquarter.exame.hematoma.items.corion liso.text': 'Glattes Corion',
    '1stinitialquarter.exame.hematoma.items.ausente.text': 'Fehlt',
    '1stinitialquarter.biometria.label': 'EMBRYO',
    '1stinitialquarter.biometria.sacos.label': 'Taschen',
    '1stinitialquarter.biometria.sacos.saco$.label': 'Sack',
    '1stinitialquarter.biometria.sacos.saco$.long.label': 'Lange',
    '1stinitialquarter.biometria.sacos.saco$.ap.label': 'Ap.',
    '1stinitialquarter.biometria.sacos.saco$.transv.label': 'Transv.',
    '1stinitialquarter.biometria.sacos.saco$.measure.label': 'Durchschnitt',
    '1stinitialquarter.biometria.sacos.saco$.idadeGestaSaco.label': 'Sack',
    '1stinitialquarter.biometria.fetos.label': 'Fötus',
    '1stinitialquarter.biometria.fetos.feto$.label': 'Fötus',
    '1stinitialquarter.biometria.fetos.feto$.saco.label': 'Sack',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.1.text': 'Tasche 1',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.2.text': 'Tasche 2',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.3.text': 'Tasche 3',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.4.text': 'Tasche 4',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.5.text': 'Tasche 5',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.6.text': 'Tasche 6',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.7.text': 'Tasche 7',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.8.text': 'Tasche 8',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.label': 'Embryonale Bewegungen',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.items.presente.text': 'Geschenk',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.items.ausente.text': 'Fehlt',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.label': 'Embryonale / fetale Schläge',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.items.presente.text': 'Geschenk',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.items.ausente.text': 'Fehlt',
    '1stinitialquarter.biometria.fetos.feto$.visiculaVitelinia.label': 'Vitelline Gall',
    '1stinitialquarter.biometria.fetos.feto$.bcf.label': 'BCF',
    '1stinitialquarter.biometria.fetos.feto$.ccn.label': 'CCN',
    '1stinitialquarter.biometria.fetos.feto$.igCCN.label': 'CCN',
    '1stinitialquarter.ovarios.label': 'OVARIEN UND ANHÄNGE',
    '1stinitialquarter.ovarios.direito.label': 'Gesetz',
    '1stinitialquarter.ovarios.direitoAspecto.label': 'Aspekt',
    '1stinitialquarter.ovarios.direitoAspecto.items.normal.text': 'Normal',
    '1stinitialquarter.ovarios.direitoAspecto.items.alterado.text': 'Geändert',
    '1stinitialquarter.ovarios.direitoAspecto.items.não visto.text': 'Nicht gesehen',
    '1stinitialquarter.ovarios.direitoLong.label': 'Längsrichtung',
    '1stinitialquarter.ovarios.direitoAnte.label': 'Anterior posterior',
    '1stinitialquarter.ovarios.direitoTransv.label': 'Quer',
    '1stinitialquarter.ovarios.direitoVolume.label': 'Lautstärke',
    '1stinitialquarter.ovarios.esquerdo.label': 'Links',
    '1stinitialquarter.ovarios.esquerdoAspecto.label': 'Aspekt',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.normal.text': 'Normal',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.alterado.text': 'Geändert',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.não visto.text': 'Nicht gesehen',
    '1stinitialquarter.ovarios.esquerdoLong.label': 'Längsrichtung',
    '1stinitialquarter.ovarios.esquerdoAnte.label': 'Anterior posterior',
    '1stinitialquarter.ovarios.esquerdoTransv.label': 'Quer',
    '1stinitialquarter.ovarios.esquerdoVolume.label': 'Lautstärke',
    '1stinitialquarter.ovarios.anexos.label': 'Anhänge',
    '1stinitialquarter.ovarios.anexos.items.normal.text': 'Normal',
    '1stinitialquarter.ovarios.anexos.items.alterado.text': 'Geändert',
    '1stinitialquarter.ovarios.corpoluteo.label': 'Luteo Körper',
    '1stinitialquarter.ovarios.corpoluteo.items.direito.text': 'Gesetz',
    '1stinitialquarter.ovarios.corpoluteo.items.esquerdo.text': 'Links',
    '1stinitialquarter.ovarios.corpoluteo.items.naovisto.text': 'Nicht gesehen',
    '1stinitialquarter.graph.label': 'Grafik',
    '1stinitialquarter.graph.sacoGestacional.label': 'Schwangerschaftssack',
    '1stinitialquarter.graph.ccn.label': 'CCN',
    '1stinitialquarter.conclusao.label': 'Beobachtungen',
    '1stinitialquarter.conclusao.conclusao.label': 'Beobachtungen',
    '1stinitialtracking.label': '1. QUARTAL TRACK',
    '1stinitialtracking.biometria.label': 'FETALE BIOMETRIE',
    '1stinitialtracking.biometria.fetos.label': 'Fötus',
    '1stinitialtracking.biometria.fetos.feto$.label': 'Fötus',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.label': 'Chorionizität',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.1.text': 'Monochorionisch',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.2.text': 'Dichorionisch',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.3.text': 'Trichorionic',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.label': 'Amniocity',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.1.text': 'Monoamniotisch',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.2.text': 'Diamniotic',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.3.text': 'Trioamniotic',
    '1stinitialtracking.biometria.fetos.feto$.ccn.label': 'CCN',
    '1stinitialtracking.biometria.fetos.feto$.idadeGestaCCN.label': 'CCN',
    '1stinitialtracking.biometria.fetos.feto$.dbp.label': 'DBP',
    '1stinitialtracking.biometria.fetos.feto$.igDbp.label': 'DBP',
    '1stinitialtracking.biometria.fetos.feto$.cc.label': 'CC',
    '1stinitialtracking.biometria.fetos.feto$.igCC.label': 'CC',
    '1stinitialtracking.biometria.fetos.feto$.ca.label': 'CA.',
    '1stinitialtracking.biometria.fetos.feto$.igCA.label': 'CA.',
    '1stinitialtracking.biometria.fetos.feto$.cf.label': 'CF.',
    '1stinitialtracking.biometria.fetos.feto$.igCF.label': 'CF.',
    '1stinitialtracking.biometria.fetos.feto$.cu.label': 'UM',
    '1stinitialtracking.biometria.fetos.feto$.igCU.label': 'UM',
    '1stinitialtracking.biometria.fetos.feto$.ductoVenoso.label': 'Venenkanal',
    '1stinitialtracking.biometria.fetos.feto$.ductoVenosoIG.label': 'DV',
    '1stinitialtracking.biometria.fetos.feto$.tn.label': 'TN',
    '1stinitialtracking.biometria.fetos.feto$.igTN.label': 'TN',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.label': 'Nasenknochen',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.items.Presente.text': 'Geschenk',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.items.Ausente.text': 'Fehlt',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.label': 'Trikuspidalinsuffizienz',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.items.Presente.text': 'Geschenk',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.items.Ausente.text': 'Fehlt',
    '1stinitialtracking.biometria.fetos.feto$.visiculaVitelinia.label': 'Vitelline Gall',
    '1stinitialtracking.biometria.fetos.feto$.bcf.label': 'BCF',
    '1stinitialtracking.biometria.fetos.feto$.dopplerUtirinas.label': 'Uterus-Doppler',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaEsquerda.label': 'PI der linken Gebärmutter',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaDireita.label': 'Rechter Uterus PI',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaMedia.label': 'Uterus-PI (Durchschnitt)',
    '1stinitialtracking.anatomiaFetal.label': 'FETALE ANATOMIE',
    '1stinitialtracking.anatomiaFetal.fetos.label': 'Fötus',
    '1stinitialtracking.anatomiaFetal.fetos.feto$.label': 'Fötus',
    '1stinitialtracking.avalRiscoTrissomia.label': 'RISIKOBEWERTUNG FÜR TRISSOMY',
    '1stinitialtracking.avalRiscoTrissomia.labelIncid.label': 'Inzidenz der Trisomie in der vorangegangenen Schwangerschaft',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.label': 'T21',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.items.1.text': 'Ja',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.items.0.text': 'Nein',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.label': 'T18',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.items.1.text': 'Ja',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.items.0.text': 'Nein',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.label': 'T13',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.items.1.text': 'Ja',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.items.0.text': 'Nein',
    '1stinitialtracking.avalRiscoTrissomia.fetos.label': 'Fötus',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.label': 'Fötus',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia21.label': 'Trisomierisiko 21 nach Alter der Mutter',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia21Corrigido.label': 'Behoben',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia18.label': 'Trisomierisiko 18 nach Alter der Mutter',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia18Corrigido.label': 'Behoben',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia13.label': 'Trisomierisiko 13 nach Alter der Mutter',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia13Corrigido.label': 'Behoben',
    '1stinitialtracking.graph.label': 'Grafik',
    '1stinitialtracking.graph.ccn.label': 'CCN',
    '1stinitialtracking.graph.dbp.label': 'DBP',
    '1stinitialtracking.graph.cc.label': 'CC',
    '1stinitialtracking.graph.ca.label': 'CA.',
    '1stinitialtracking.graph.cf.label': 'CF.',
    '1stinitialtracking.graph.cu.label': 'UM',
    '1stinitialtracking.graph.tn.label': 'TN',
    '1stinitialtracking.conclusao.label': 'Beobachtungen',
    '1stinitialtracking.conclusao.conclusao.label': 'Beobachtungen',
    '2ndand3rdquarter.label': '2. und 3. QUARTAL',
    '2ndand3rdquarter.avaliacaoGestacao.label': 'BEWERTUNGSMANAGEMENT',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.label': 'Fötus',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.label': 'Fötus',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.label': 'Chorionizität',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.1.text': 'Monochorionisch',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.2.text': 'Dichorionisch',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.3.text': 'Trichorionic',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.label': 'Amniocity',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.1.text': 'Monoamniotisch',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.2.text': 'Diamniotic',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.3.text': 'Trioamniotic',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.label': 'Fetale Situation',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Longitudinal.text': 'Längsrichtung',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Transversal.text': 'Querschneiden',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Oblíqua.text': 'Oblique',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.label': 'Fetale Darstellung',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Cefálica.text': 'Cephalic',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Pélvica.text': 'Becken',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Córmica.text': 'Formica',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Outros.text': 'Andere',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.label': 'Fetaler Rücken',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Anterior.text': 'Zurück',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Posterior.text': 'Später',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral direita.text': 'Rechte Seite',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral esquerda.text': 'Linke Seite',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Outros.text': 'Andere',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.label': 'Fetale Bewegungen',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Presente.text': 'Geschenk',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Ausente.text': 'Fehlt',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.label': 'Fetale Schläge',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Presente.text': 'Geschenk',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Ausente.text': 'Fehlt',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.bcf.label': 'BCF',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.label': 'Plazenta',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Anterior.text': 'Zurück',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Posterior.text': 'Später',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral direita.text': 'Rechte Seite',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral esquerda.text': 'Linke Seite',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia parcial.text': 'Teilvorschau',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia total.text': 'Gesamtvorschau',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Outros.text': 'Andere',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.label': 'Plazentare Reife (GRANUMM)',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.0.text': '0',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.I.text': 'Ich',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.II.text': 'II',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.III.text': 'III',
    '2ndand3rdquarter.biometria.label': 'FETALE BIOMETRIE',
    '2ndand3rdquarter.biometria.fetos.label': 'Fötus',
    '2ndand3rdquarter.biometria.fetos.feto$.label': 'Fötus',
    '2ndand3rdquarter.biometria.fetos.feto$.dbp.label': 'DBP',
    '2ndand3rdquarter.biometria.fetos.feto$.igDbp.label': 'DBP',
    '2ndand3rdquarter.biometria.fetos.feto$.cc.label': 'CC',
    '2ndand3rdquarter.biometria.fetos.feto$.igCC.label': 'CC',
    '2ndand3rdquarter.biometria.fetos.feto$.ca.label': 'CA.',
    '2ndand3rdquarter.biometria.fetos.feto$.igCA.label': 'CA.',
    '2ndand3rdquarter.biometria.fetos.feto$.cf.label': 'CF.',
    '2ndand3rdquarter.biometria.fetos.feto$.igCF.label': 'CF.',
    '2ndand3rdquarter.biometria.fetos.feto$.cu.label': 'UM',
    '2ndand3rdquarter.biometria.fetos.feto$.igCU.label': 'UM',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoCCCA.label': 'DC / AC-Verhältnis',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoCACF.label': 'AC / CF-Verhältnis',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoBPDCF.label': 'BPD / CF-Verhältnis',
    '2ndand3rdquarter.biometria.fetos.feto$.pesoEstimado.label': 'Geschätztes Gewicht (± 15%)',
    '2ndand3rdquarter.biometria.fetos.feto$.comprimentoEstimado.label': 'Geschätzte Länge',
    '2ndand3rdquarter.anatomiaFetal.label': 'FETALE ANATOMIE',
    '2ndand3rdquarter.anatomiaFetal.fetos.label': 'Fötus',
    '2ndand3rdquarter.anatomiaFetal.fetos.feto$.label': 'Fötus',
    '2ndand3rdquarter.avalBiofisicaFetal.label': 'FETALE BIOPHYSIKALISCHE BEWERTUNG',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.label': 'Fötus',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.label': 'Fötus',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.label': 'Atembewegung',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Presente.text': 'Geschenk',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Ausente.text': 'Fehlt',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.label': 'Fötaler Ton',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Presente.text': 'Geschenk',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Ausente.text': 'Fehlt',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.label': 'Fruchtwasser',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Normal.text': 'Normal',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Diminuído.text': 'Vermindert',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Aumentado.text': 'Erhöht',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.labelILA.label': 'ILA',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qse.label': 'QSE',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qie.label': 'QIE',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qsd.label': 'QSD',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qid.label': 'QID',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.ilaTotal.label': 'Total',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.maiorBolsao.label': 'Größte Tasche',
    '2ndand3rdquarter.idadeGestacional.label': 'Gestationsalter',
    '2ndand3rdquarter.idadeGestacional.calculada.label': 'Berechnet',
    '2ndand3rdquarter.graph.label': 'Grafik',
    '2ndand3rdquarter.graph.dbp.label': 'DBP',
    '2ndand3rdquarter.graph.cc.label': 'CC',
    '2ndand3rdquarter.graph.ca.label': 'CA.',
    '2ndand3rdquarter.graph.cf.label': 'CF.',
    '2ndand3rdquarter.graph.cu.label': 'UM',
    '2ndand3rdquarter.graph.pesoEstimado.label': 'Geschätztes Gewicht',
    '2ndand3rdquarter.graph.ilaTotal.label': 'ILA',
    '2ndand3rdquarter.graph.maiorBolsao.label': 'Größte Tasche',
    '2ndand3rdquarter.conclusao.label': 'Beobachtungen',
    '2ndand3rdquarter.conclusao.conclusao.label': 'Beobachtungen',
    'morphological.label': 'MORPHOLOGISCH',
    'morphological.avaliacaoGestacao.label': 'BEWERTUNGSMANAGEMENT',
    'morphological.avaliacaoGestacao.fetos.label': 'Fötus',
    'morphological.avaliacaoGestacao.fetos.feto$.label': 'Fötus',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.label': 'Chorionizität',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.1.text': 'Monochorionisch',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.2.text': 'Dichorionisch',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.3.text': 'Trichorionic',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.label': 'Amniocity',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.1.text': 'Monoamniotisch',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.2.text': 'Diamniotic',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.3.text': 'Trioamniotic',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.label': 'Fetale Situation',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Longitudinal.text': 'Längsrichtung',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Transversal.text': 'Querschneiden',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Oblíqua.text': 'Oblique',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.label': 'Fetale Darstellung',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Cefálica.text': 'Cephalic',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Pélvica.text': 'Becken',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Córmica.text': 'Formica',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Outros.text': 'Andere',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.label': 'Fetaler Rücken',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Anterior.text': 'Zurück',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Posterior.text': 'Später',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral direita.text': 'Rechte Seite',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral esquerda.text': 'Linke Seite',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Outros.text': 'Andere',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.label': 'Fetale Bewegungen',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Presente.text': 'Geschenk',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Ausente.text': 'Fehlt',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.label': 'Fetale Schläge',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Presente.text': 'Geschenk',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Ausente.text': 'Fehlt',
    'morphological.avaliacaoGestacao.fetos.feto$.bcf.label': 'BCF',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.label': 'Plazenta',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Anterior.text': 'Zurück',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Posterior.text': 'Später',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral direita.text': 'Rechte Seite',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral esquerda.text': 'Linke Seite',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia parcial.text': 'Teilvorschau',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia total.text': 'Gesamtvorschau',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Outros.text': 'Andere',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.label': 'Plazentare Reife (GRANUMM)',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.0.text': '0',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.I.text': 'Ich',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.II.text': 'II',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.III.text': 'III',
    'morphological.biometria.label': 'BASIC FETAL BIOMETRY',
    'morphological.biometria.fetos.label': 'Fötus',
    'morphological.biometria.fetos.feto$.label': 'Fötus',
    'morphological.biometria.fetos.feto$.dbp.label': 'DBP',
    'morphological.biometria.fetos.feto$.igDbp.label': 'DBP',
    'morphological.biometria.fetos.feto$.cc.label': 'CC',
    'morphological.biometria.fetos.feto$.igCC.label': 'CC',
    'morphological.biometria.fetos.feto$.ca.label': 'CA.',
    'morphological.biometria.fetos.feto$.igCA.label': 'CA.',
    'morphological.biometria.fetos.feto$.cf.label': 'CF.',
    'morphological.biometria.fetos.feto$.igCF.label': 'CF.',
    'morphological.biometria.fetos.feto$.cu.label': 'UM',
    'morphological.biometria.fetos.feto$.igCU.label': 'UM',
    'morphological.biometria.fetos.feto$.relacaoCCCA.label': 'DC / AC-Verhältnis',
    'morphological.biometria.fetos.feto$.relacaoCACF.label': 'AC / CF-Verhältnis',
    'morphological.biometria.fetos.feto$.relacaoBPDCF.label': 'BPD / CF-Verhältnis',
    'morphological.biometria.fetos.feto$.pesoEstimado.label': 'Geschätztes Gewicht (± 15%)',
    'morphological.biometria.fetos.feto$.comprimentoEstimado.label': 'Geschätzte Länge',
    'morphological.biometriaAvancada.label': 'ERWEITERTE FETALE BIOMETRIE',
    'morphological.biometriaAvancada.fetos.label': 'Fötus',
    'morphological.biometriaAvancada.fetos.feto$.label': 'Fötus',
    'morphological.biometriaAvancada.fetos.feto$.diametroCerebelar.label': 'Kleinhirndurchmesser',
    'morphological.biometriaAvancada.fetos.feto$.diametroCerebelarIG.label': 'Perzentil',
    'morphological.biometriaAvancada.fetos.feto$.cisternaMagna.label': 'Magna-Zisterne',
    'morphological.biometriaAvancada.fetos.feto$.cisternaMagnaIG.label': 'Perzentil',
    'morphological.biometriaAvancada.fetos.feto$.atrioVentriculoLateral.label': 'Laterales Ventrikelatrium',
    'morphological.biometriaAvancada.fetos.feto$.atrioVentriculoLateralIG.label': 'Perzentil',
    'morphological.biometriaAvancada.fetos.feto$.diametroOcular.label': 'Augendurchmesser',
    'morphological.biometriaAvancada.fetos.feto$.diametroOcularIG.label': 'Perzentil',
    'morphological.biometriaAvancada.fetos.feto$.distanciaInterocular.label': 'Augenabstand',
    'morphological.biometriaAvancada.fetos.feto$.distanciaInterocularIG.label': 'Perzentil',
    'morphological.biometriaAvancada.fetos.feto$.distanciaBinocular.label': 'Fernglasabstand',
    'morphological.biometriaAvancada.fetos.feto$.distanciaBinocularIG.label': 'Perzentil',
    'morphological.biometriaAvancada.fetos.feto$.quintoDedoMao.label': 'Fünfter Finger',
    'morphological.biometriaAvancada.fetos.feto$.quintoDedoMaoIG.label': 'Perzentil',
    'morphological.biometriaAvancada.fetos.feto$.ossoNasal.label': 'Nasenknochen',
    'morphological.biometriaAvancada.fetos.feto$.pe.label': 'Fuß',
    'morphological.biometriaAvancada.fetos.feto$.diamPelvisRenalDir.label': 'Dia. Nierenbecken dir',
    'morphological.biometriaAvancada.fetos.feto$.diamPelvisRenalEsq.label': 'Dia. Linkes Nierenbecken',
    'morphological.anatomiaFetal.label': 'FETALE ANATOMIE',
    'morphological.anatomiaFetal.fetos.label': 'Fötus',
    'morphological.anatomiaFetal.fetos.feto$.label': 'Fötus',
    'morphological.avalBiofisicaFetal.label': 'FETALE BIOPHYSIKALISCHE BEWERTUNG',
    'morphological.avalBiofisicaFetal.fetos.label': 'Fötus',
    'morphological.avalBiofisicaFetal.fetos.feto$.label': 'Fötus',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.label': 'Atembewegung',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Presente.text': 'Geschenk',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Ausente.text': 'Fehlt',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.label': 'Fötaler Ton',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Presente.text': 'Geschenk',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Ausente.text': 'Fehlt',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.label': 'Fruchtwasser',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Normal.text': 'Normal',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Diminuído.text': 'Vermindert',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Aumentado.text': 'Erhöht',
    'morphological.avalBiofisicaFetal.fetos.feto$.labelILA.label': 'ILA',
    'morphological.avalBiofisicaFetal.fetos.feto$.qse.label': 'QSE',
    'morphological.avalBiofisicaFetal.fetos.feto$.qie.label': 'QIE',
    'morphological.avalBiofisicaFetal.fetos.feto$.qsd.label': 'QSD',
    'morphological.avalBiofisicaFetal.fetos.feto$.qid.label': 'QID',
    'morphological.avalBiofisicaFetal.fetos.feto$.ilaTotal.label': 'Total',
    'morphological.avalBiofisicaFetal.fetos.feto$.maiorBolsao.label': 'Größte Tasche',
    'morphological.graph.label': 'Grafik',
    'morphological.graph.dbp.label': 'DBP',
    'morphological.graph.cc.label': 'CC',
    'morphological.graph.ca.label': 'CA.',
    'morphological.graph.cf.label': 'CF.',
    'morphological.graph.cu.label': 'UM',
    'morphological.graph.pesoEstimado.label': 'Geschätztes Gewicht',
    'morphological.graph.ilaTotal.label': 'ILA',
    'morphological.graph.maiorBolsao.label': 'Größte Tasche',
    'morphological.graph.ossoNasal.label': 'Nasenknochen',
    'morphological.graph.diamPelvisRenalEsq.label': 'Linkes Nierenbecken',
    'morphological.graph.diamPalvisRenalDir.label': 'Rechtes Nierenbecken',
    'morphological.conclusao.label': 'Beobachtungen',
    'morphological.conclusao.conclusao.label': 'Beobachtungen',
    'obstetricdoppler.label': 'Geburtshilfe DOPPLER',
    'obstetricdoppler.uterinas.label': 'Uterine',
    'obstetricdoppler.uterinas.uterinaEsquerda.label': 'Linke Uterus',
    'obstetricdoppler.uterinas.piUterinaEsquerda.label': 'PI der linken Gebärmutter',
    'obstetricdoppler.uterinas.riUterinaEsquerda.label': 'Linke Gebärmutter IR',
    'obstetricdoppler.uterinas.uterinaDireita.label': 'Right Uterine',
    'obstetricdoppler.uterinas.piUterinaDireita.label': 'Rechter Uterus PI',
    'obstetricdoppler.uterinas.riUterinaDireita.label': 'Rechter Uterus IR',
    'obstetricdoppler.uterinas.uterinaMedia.label': 'Mittlere Uterus',
    'obstetricdoppler.uterinas.piUterinaMedia.label': 'Uterus-PI (Durchschnitt)',
    'obstetricdoppler.fetal.label': 'Fetisch',
    'obstetricdoppler.fetal.fetos.label': 'Fötus',
    'obstetricdoppler.fetal.fetos.feto$.label': 'Fötus',
    'obstetricdoppler.fetal.fetos.feto$.umbilical.label': 'Nabelschnur',
    'obstetricdoppler.fetal.fetos.feto$.piUmbilical.label': 'PI',
    'obstetricdoppler.fetal.fetos.feto$.riUmbilical.label': 'IR',
    'obstetricdoppler.fetal.fetos.feto$.diastole.label': 'Diastole',
    'obstetricdoppler.fetal.fetos.feto$.diastole.items.PRESENTE.text': 'Geschenk',
    'obstetricdoppler.fetal.fetos.feto$.diastole.items.AUSENTE.text': 'Fehlt',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.label': 'Diastole Zero',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.items.PRESENTE.text': 'Geschenk',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.items.AUSENTE.text': 'Fehlt',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.label': 'Reverse Diastole',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.items.PRESENTE.text': 'Geschenk',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.items.AUSENTE.text': 'Fehlt',
    'obstetricdoppler.fetal.fetos.feto$.cerebral.label': 'Gehirn',
    'obstetricdoppler.fetal.fetos.feto$.piCerebral.label': 'PI',
    'obstetricdoppler.fetal.fetos.feto$.velocSistolica.label': 'Geschwindigkeit Systolisch',
    'obstetricdoppler.fetal.fetos.feto$.relacaoCerebralPlacentariaLabel.label': 'Gehirn / Plazenta-Beziehung',
    'obstetricdoppler.fetal.fetos.feto$.relacaoCerebralPlacentaria.label': 'Zerebraler PI / Nabelschnur-PI',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.label': 'Zentralisierung',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.items.SIM.text': 'Ja',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.items.NAO.text': 'Nein',
    'obstetricdoppler.fetal.fetos.feto$.ductoVenoso.label': 'Venenkanal',
    'obstetricdoppler.fetal.fetos.feto$.piDuctoVenoso.label': 'PI',
    'obstetricdoppler.fetal.fetos.feto$.ductoVenosoIG.label': 'DV',
    'obstetricdoppler.fetal.fetos.feto$.saDuctoVenoso.label': 'S / A',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.label': 'Welle A',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.Positivo.text': 'Positiv',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.Zero.text': 'Null',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.FluxoReverso.text': 'Rückfluss',
    'obstetricdoppler.conclusao.label': 'Beobachtungen',
    'obstetricdoppler.conclusao.conclusao.label': 'Beobachtungen',
    'conclusion.label': 'Fazit',
    'conclusion.text.label': 'Fazit'
  },
  'ru': {
    'gestationalAge.label': 'информация',
    'gestationalAge.info.label': 'беременность',
    'gestationalAge.info.interationDate.label': 'Дата экзамена',
    'gestationalAge.info.dateBirthMother.label': 'Дата рождения матери',
    'gestationalAge.info.via.label': 'Экзаменационный маршрут',
    'gestationalAge.info.via.items.abdominal.text': 'абдоминальный',
    'gestationalAge.info.via.items.transvaginal.text': 'трансвагинальное',
    'gestationalAge.info.indicacao.label': 'Экзаменационная индикация',
    'gestationalAge.info.indicacao.items.Datar gestação.text': 'Знакомства с беременностью',
    'gestationalAge.info.indicacao.items.Rastreio de aneuploidias.text': 'Скрининг анеуплоидии',
    'gestationalAge.info.indicacao.items.Sangramento.text': 'кровотечение',
    'gestationalAge.info.indicacao.items.Diagnosticar gestação.text': 'Диагностировать беременность',
    'gestationalAge.info.qualidade.label': 'Качество экзамена',
    'gestationalAge.info.qualidade.items.Satisfatória.text': 'удовлетворительное',
    'gestationalAge.info.qualidade.items.Prejudicado pela adiposidade materna.text': 'Ущерб от материнского ожирения',
    'gestationalAge.info.qualidade.items.Prejudicado pela estática fetal.text': 'Вред статика плода',
    'gestationalAge.info.qualidade.items.Prejudicado pela movimentação fetal.text': 'Поврежден движением плода',
    'gestationalAge.info.calculo.label': 'Расчет гестационного возраста',
    'gestationalAge.info.calculo.items.DUM.text': 'Последний период',
    'gestationalAge.info.calculo.items.exame-anterior.text': 'Предыдущий экзамен',
    'gestationalAge.info.calculo.items.informada.text': 'Пациент проинформирован',
    'gestationalAge.info.calculo.items.data-parto.text': 'Возможная дата доставки',
    'gestationalAge.info.calculo.items.desconhecido.text': 'неизвестный',
    'gestationalAge.info.calculo.items.manual.text': 'руководство',
    'gestationalAge.info.date.label': 'дата',
    'gestationalAge.info.dateTest.label': 'дата',
    'gestationalAge.info.weeks.label': 'недель',
    'gestationalAge.info.days.label': 'дней',
    'gestationalAge.info.calculada.label': 'вычисленный',
    'gestationalAge.info.concepcao.label': 'Метод проектирования',
    'gestationalAge.info.concepcao.items.Espontânea.text': 'спонтанный',
    'gestationalAge.info.concepcao.items.Indução da ovulação.text': 'Индукция овуляции',
    'gestationalAge.info.concepcao.items.Fertilização in vitro.text': 'Экстракорпоральное оплодотворение',
    'gestationalAge.info.fertilizacaoInVitro.label': 'Оплодотворение in vitro',
    'gestationalAge.info.fertilizacaoInVitro.items.Normal.text': 'нормальный',
    'gestationalAge.info.fertilizacaoInVitro.items.Doação de óvulo.text': 'Донорство яйцеклеток',
    'gestationalAge.info.fertilizacaoInVitro.items.Óvulo congelado.text': 'Замороженное яйцо',
    'gestationalAge.info.dateDoadora.label': 'Дата рождения донора',
    'gestationalAge.info.dateCongelamento.label': 'Дата замораживания',
    'gestationalAge.info.qtdSacoGestacional.label': 'Количество гестационных мешков',
    'gestationalAge.info.qtdSacoGestacional.items.1.text': '',
    'gestationalAge.info.qtdSacoGestacional.items.2.text': 'два',
    'gestationalAge.info.qtdSacoGestacional.items.3.text': 'три',
    'gestationalAge.info.qtdSacoGestacional.items.4.text': 'четыре',
    'gestationalAge.info.fetos.label': 'Эмбрионы / Плоды',
    'gestationalAge.info.fetos.items.0.text': 'anembryonic',
    'gestationalAge.info.fetos.items.1.text': 'только',
    'gestationalAge.info.fetos.items.2.text': 'сдвоенный',
    'gestationalAge.info.fetos.items.3.text': 'тройной',
    'gestationalAge.info.fetos.items.4.text': 'четверной',
    'gestationalAge.info.fetos.items.Não visto.text': 'Не видел',
    'gestationalAge.info.movimentosFetais.label': 'Движения плода',
    'gestationalAge.info.movimentosFetais.items.presente.text': 'настоящее время',
    'gestationalAge.info.movimentosFetais.items.ausente.text': 'отсутствующий',
    '1stinitialquarter.label': '1-й квартал',
    '1stinitialquarter.exame.label': 'ИНФОРМАЦИЯ',
    '1stinitialquarter.exame.sacoGestacional.label': 'Гестационный мешок',
    '1stinitialquarter.exame.sacoGestacional.items.regular.text': 'Регулировать',
    '1stinitialquarter.exame.sacoGestacional.items.irregular.text': 'нерегулярный',
    '1stinitialquarter.exame.localizacao.label': 'место',
    '1stinitialquarter.exame.localizacao.items.fundo uterino.text': 'Маточный фон',
    '1stinitialquarter.exame.localizacao.items.corporal.text': 'телесный',
    '1stinitialquarter.exame.localizacao.items.colo.text': 'круг',
    '1stinitialquarter.exame.localizacao.items.cicatriz cesariana.text': 'Рубец кесарева сечения',
    '1stinitialquarter.exame.deslocamentoOvular.label': 'Отслойка яичка',
    '1stinitialquarter.exame.deslocamentoOvular.items.presente.text': 'настоящее время',
    '1stinitialquarter.exame.deslocamentoOvular.items.ausente.text': 'отсутствующий',
    '1stinitialquarter.exame.hematoma.label': 'гематома',
    '1stinitialquarter.exame.hematoma.items.corion frondoso.text': 'Лиственный Корион',
    '1stinitialquarter.exame.hematoma.items.corion liso.text': 'Гладкий Корион',
    '1stinitialquarter.exame.hematoma.items.ausente.text': 'отсутствующий',
    '1stinitialquarter.biometria.label': 'ЗАРОДЫШ',
    '1stinitialquarter.biometria.sacos.label': 'мешки',
    '1stinitialquarter.biometria.sacos.saco$.label': 'сумка',
    '1stinitialquarter.biometria.sacos.saco$.long.label': 'Long.',
    '1stinitialquarter.biometria.sacos.saco$.ap.label': 'Ар.',
    '1stinitialquarter.biometria.sacos.saco$.transv.label': 'Transv.',
    '1stinitialquarter.biometria.sacos.saco$.measure.label': 'средний',
    '1stinitialquarter.biometria.sacos.saco$.idadeGestaSaco.label': 'сумка',
    '1stinitialquarter.biometria.fetos.label': 'зародыши',
    '1stinitialquarter.biometria.fetos.feto$.label': 'плод',
    '1stinitialquarter.biometria.fetos.feto$.saco.label': 'сумка',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.1.text': 'Сумка 1',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.2.text': 'Сумка 2',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.3.text': 'Сумка 3',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.4.text': 'Сумка 4',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.5.text': 'Сумка 5',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.6.text': 'Сумка 6',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.7.text': 'Сумка 7',
    '1stinitialquarter.biometria.fetos.feto$.saco.items.8.text': 'Сумка 8',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.label': 'Эмбриональные движения',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.items.presente.text': 'настоящее время',
    '1stinitialquarter.biometria.fetos.feto$.movimentosEmbrioes.items.ausente.text': 'отсутствующий',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.label': 'Эмбриональные / эмбриональные ритмы',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.items.presente.text': 'настоящее время',
    '1stinitialquarter.biometria.fetos.feto$.batimentosEmbrioes.items.ausente.text': 'отсутствующий',
    '1stinitialquarter.biometria.fetos.feto$.visiculaVitelinia.label': 'Вителиново-желчный',
    '1stinitialquarter.biometria.fetos.feto$.bcf.label': 'BCF',
    '1stinitialquarter.biometria.fetos.feto$.ccn.label': 'CCN',
    '1stinitialquarter.biometria.fetos.feto$.igCCN.label': 'CCN',
    '1stinitialquarter.ovarios.label': 'ЯИЧНИКИ И НАЛОЖЕНИЯ',
    '1stinitialquarter.ovarios.direito.label': 'право',
    '1stinitialquarter.ovarios.direitoAspecto.label': 'внешний вид',
    '1stinitialquarter.ovarios.direitoAspecto.items.normal.text': 'нормальный',
    '1stinitialquarter.ovarios.direitoAspecto.items.alterado.text': 'изменено',
    '1stinitialquarter.ovarios.direitoAspecto.items.não visto.text': 'Не видел',
    '1stinitialquarter.ovarios.direitoLong.label': 'продольный',
    '1stinitialquarter.ovarios.direitoAnte.label': 'Передний задний',
    '1stinitialquarter.ovarios.direitoTransv.label': 'поперечный',
    '1stinitialquarter.ovarios.direitoVolume.label': 'объем',
    '1stinitialquarter.ovarios.esquerdo.label': 'слева',
    '1stinitialquarter.ovarios.esquerdoAspecto.label': 'внешний вид',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.normal.text': 'нормальный',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.alterado.text': 'изменено',
    '1stinitialquarter.ovarios.esquerdoAspecto.items.não visto.text': 'Не видел',
    '1stinitialquarter.ovarios.esquerdoLong.label': 'продольный',
    '1stinitialquarter.ovarios.esquerdoAnte.label': 'Передний задний',
    '1stinitialquarter.ovarios.esquerdoTransv.label': 'поперечный',
    '1stinitialquarter.ovarios.esquerdoVolume.label': 'объем',
    '1stinitialquarter.ovarios.anexos.label': 'вложения',
    '1stinitialquarter.ovarios.anexos.items.normal.text': 'нормальный',
    '1stinitialquarter.ovarios.anexos.items.alterado.text': 'изменено',
    '1stinitialquarter.ovarios.corpoluteo.label': 'Тело лютео',
    '1stinitialquarter.ovarios.corpoluteo.items.direito.text': 'право',
    '1stinitialquarter.ovarios.corpoluteo.items.esquerdo.text': 'слева',
    '1stinitialquarter.ovarios.corpoluteo.items.naovisto.text': 'Не видел',
    '1stinitialquarter.graph.label': 'графика',
    '1stinitialquarter.graph.sacoGestacional.label': 'Гестационный мешок',
    '1stinitialquarter.graph.ccn.label': 'CCN',
    '1stinitialquarter.conclusao.label': 'наблюдения',
    '1stinitialquarter.conclusao.conclusao.label': 'наблюдения',
    '1stinitialtracking.label': '1-й квартал трек',
    '1stinitialtracking.biometria.label': 'ФЕТАЛЬНАЯ БИОМЕТРИЯ',
    '1stinitialtracking.biometria.fetos.label': 'зародыши',
    '1stinitialtracking.biometria.fetos.feto$.label': 'плод',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.label': 'chorionicity',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.1.text': 'Monocoriônico',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.2.text': 'Dicoriônico',
    '1stinitialtracking.biometria.fetos.feto$.corionicidade.items.3.text': 'Tricoriônico',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.label': 'Amniocidade',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.1.text': 'Monoamniótico',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.2.text': 'Diamniótico',
    '1stinitialtracking.biometria.fetos.feto$.amniocidade.items.3.text': 'Trioamniótico',
    '1stinitialtracking.biometria.fetos.feto$.ccn.label': 'CCN',
    '1stinitialtracking.biometria.fetos.feto$.idadeGestaCCN.label': 'CCN',
    '1stinitialtracking.biometria.fetos.feto$.dbp.label': 'DBP',
    '1stinitialtracking.biometria.fetos.feto$.igDbp.label': 'DBP',
    '1stinitialtracking.biometria.fetos.feto$.cc.label': 'CC',
    '1stinitialtracking.biometria.fetos.feto$.igCC.label': 'CC',
    '1stinitialtracking.biometria.fetos.feto$.ca.label': 'переменный ток',
    '1stinitialtracking.biometria.fetos.feto$.igCA.label': 'переменный ток',
    '1stinitialtracking.biometria.fetos.feto$.cf.label': 'CF',
    '1stinitialtracking.biometria.fetos.feto$.igCF.label': 'CF',
    '1stinitialtracking.biometria.fetos.feto$.cu.label': 'UM',
    '1stinitialtracking.biometria.fetos.feto$.igCU.label': 'UM',
    '1stinitialtracking.biometria.fetos.feto$.ductoVenoso.label': 'Венозный проток',
    '1stinitialtracking.biometria.fetos.feto$.ductoVenosoIG.label': 'DV',
    '1stinitialtracking.biometria.fetos.feto$.tn.label': 'Теннесси',
    '1stinitialtracking.biometria.fetos.feto$.igTN.label': 'Теннесси',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.label': 'Носовая кость',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.items.Presente.text': 'настоящее время',
    '1stinitialtracking.biometria.fetos.feto$.ossoNasal.items.Ausente.text': 'отсутствующий',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.label': 'Трикуспидальная регургитация',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.items.Presente.text': 'настоящее время',
    '1stinitialtracking.biometria.fetos.feto$.regurgitacao.items.Ausente.text': 'отсутствующий',
    '1stinitialtracking.biometria.fetos.feto$.visiculaVitelinia.label': 'Вителиново-желчный',
    '1stinitialtracking.biometria.fetos.feto$.bcf.label': 'BCF',
    '1stinitialtracking.biometria.fetos.feto$.dopplerUtirinas.label': 'Маточный допплер',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaEsquerda.label': 'ИП левой матки',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaDireita.label': 'Правый маточный пи',
    '1stinitialtracking.biometria.fetos.feto$.piUterinaMedia.label': 'Маточный пи (средний)',
    '1stinitialtracking.anatomiaFetal.label': 'ФЕТАЛЬНАЯ АНАТОМИЯ',
    '1stinitialtracking.anatomiaFetal.fetos.label': 'зародыши',
    '1stinitialtracking.anatomiaFetal.fetos.feto$.label': 'плод',
    '1stinitialtracking.avalRiscoTrissomia.label': 'ОЦЕНКА РИСКА ДЛЯ ТРИССОМИИ',
    '1stinitialtracking.avalRiscoTrissomia.labelIncid.label': 'Заболеваемость трисомией при предыдущей беременности',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.label': 'T21',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.items.1.text': 'да',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia21Prev.items.0.text': 'не',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.label': 'T18',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.items.1.text': 'да',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia18Prev.items.0.text': 'не',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.label': 'T13',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.items.1.text': 'да',
    '1stinitialtracking.avalRiscoTrissomia.riscoTrissomia13Prev.items.0.text': 'не',
    '1stinitialtracking.avalRiscoTrissomia.fetos.label': 'зародыши',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.label': 'плод',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia21.label': 'Риск трисомии 21 по материнскому возрасту',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia21Corrigido.label': 'фиксированный',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia18.label': 'Риск трисомии 18 по материнскому возрасту',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia18Corrigido.label': 'фиксированный',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia13.label': 'Риск трисомии 13 по материнскому возрасту',
    '1stinitialtracking.avalRiscoTrissomia.fetos.feto$.riscoTrissomia13Corrigido.label': 'фиксированный',
    '1stinitialtracking.graph.label': 'графика',
    '1stinitialtracking.graph.ccn.label': 'CCN',
    '1stinitialtracking.graph.dbp.label': 'DBP',
    '1stinitialtracking.graph.cc.label': 'CC',
    '1stinitialtracking.graph.ca.label': 'переменный ток',
    '1stinitialtracking.graph.cf.label': 'CF',
    '1stinitialtracking.graph.cu.label': 'UM',
    '1stinitialtracking.graph.tn.label': 'Теннесси',
    '1stinitialtracking.conclusao.label': 'наблюдения',
    '1stinitialtracking.conclusao.conclusao.label': 'наблюдения',
    '2ndand3rdquarter.label': '2-й и 3-й квартал',
    '2ndand3rdquarter.avaliacaoGestacao.label': 'УПРАВЛЕНИЕ ОЦЕНКОЙ',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.label': 'зародыши',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.label': 'плод',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.label': 'chorionicity',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.1.text': 'Monocoriônico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.2.text': 'Dicoriônico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.corionicidade.items.3.text': 'Tricoriônico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.label': 'Amniocidade',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.1.text': 'Monoamniótico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.2.text': 'Diamniótico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.amniocidade.items.3.text': 'Trioamniótico',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.label': 'Фетальная ситуация',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Longitudinal.text': 'продольный',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Transversal.text': 'поперечный',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Oblíqua.text': 'косой',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.label': 'Фетальная презентация',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Cefálica.text': 'цефалический',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Pélvica.text': 'тазовый',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Córmica.text': 'Córmica',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Outros.text': 'другой',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.label': 'Фетальная спина',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Anterior.text': 'предыдущий',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Posterior.text': 'задний',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral direita.text': 'Правая сторона',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral esquerda.text': 'Левая сторона',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Outros.text': 'другой',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.label': 'Движения плода',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Presente.text': 'настоящее время',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Ausente.text': 'отсутствующий',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.label': 'Фетальный ритм',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Presente.text': 'настоящее время',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Ausente.text': 'отсутствующий',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.bcf.label': 'BCF',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.label': 'плацента',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Anterior.text': 'предыдущий',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Posterior.text': 'задний',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral direita.text': 'Правая сторона',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral esquerda.text': 'Левая сторона',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia parcial.text': 'Частичный предварительный просмотр',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia total.text': 'Общий предварительный просмотр',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placenta.items.Outros.text': 'другой',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.label': 'Зрелость плаценты (GRANUMM)',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.0.text': '0',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.I.text': 'Я',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.II.text': 'II',
    '2ndand3rdquarter.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.III.text': 'III',
    '2ndand3rdquarter.biometria.label': 'ФЕТАЛЬНАЯ БИОМЕТРИЯ',
    '2ndand3rdquarter.biometria.fetos.label': 'зародыши',
    '2ndand3rdquarter.biometria.fetos.feto$.label': 'плод',
    '2ndand3rdquarter.biometria.fetos.feto$.dbp.label': 'DBP',
    '2ndand3rdquarter.biometria.fetos.feto$.igDbp.label': 'DBP',
    '2ndand3rdquarter.biometria.fetos.feto$.cc.label': 'CC',
    '2ndand3rdquarter.biometria.fetos.feto$.igCC.label': 'CC',
    '2ndand3rdquarter.biometria.fetos.feto$.ca.label': 'переменный ток',
    '2ndand3rdquarter.biometria.fetos.feto$.igCA.label': 'переменный ток',
    '2ndand3rdquarter.biometria.fetos.feto$.cf.label': 'CF',
    '2ndand3rdquarter.biometria.fetos.feto$.igCF.label': 'CF',
    '2ndand3rdquarter.biometria.fetos.feto$.cu.label': 'UM',
    '2ndand3rdquarter.biometria.fetos.feto$.igCU.label': 'UM',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoCCCA.label': 'Соотношение DC / AC',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoCACF.label': 'Соотношение AC / CF',
    '2ndand3rdquarter.biometria.fetos.feto$.relacaoBPDCF.label': 'Соотношение BPD / CF',
    '2ndand3rdquarter.biometria.fetos.feto$.pesoEstimado.label': 'Расчетный вес (± 15%)',
    '2ndand3rdquarter.biometria.fetos.feto$.comprimentoEstimado.label': 'Расчетная длина',
    '2ndand3rdquarter.anatomiaFetal.label': 'ФЕТАЛЬНАЯ АНАТОМИЯ',
    '2ndand3rdquarter.anatomiaFetal.fetos.label': 'зародыши',
    '2ndand3rdquarter.anatomiaFetal.fetos.feto$.label': 'плод',
    '2ndand3rdquarter.avalBiofisicaFetal.label': 'БИОФИЗИЧЕСКАЯ ОЦЕНКА ФЕТАЛА',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.label': 'зародыши',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.label': 'плод',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.label': 'Дыхательное движение',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Presente.text': 'настоящее время',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Ausente.text': 'отсутствующий',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.label': 'Тонус плода',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Presente.text': 'настоящее время',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Ausente.text': 'отсутствующий',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.label': 'Амниотическая жидкость',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Normal.text': 'нормальный',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Diminuído.text': 'уменьшенный',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Aumentado.text': 'расширенный',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.labelILA.label': 'АМП',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qse.label': 'QSE',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qie.label': 'LL',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qsd.label': 'DSF',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.qid.label': 'QID',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.ilaTotal.label': 'общий',
    '2ndand3rdquarter.avalBiofisicaFetal.fetos.feto$.maiorBolsao.label': 'Самый большой карман',
    '2ndand3rdquarter.idadeGestacional.label': 'Гестационный возраст',
    '2ndand3rdquarter.idadeGestacional.calculada.label': 'вычисленный',
    '2ndand3rdquarter.graph.label': 'графика',
    '2ndand3rdquarter.graph.dbp.label': 'DBP',
    '2ndand3rdquarter.graph.cc.label': 'CC',
    '2ndand3rdquarter.graph.ca.label': 'переменный ток',
    '2ndand3rdquarter.graph.cf.label': 'CF',
    '2ndand3rdquarter.graph.cu.label': 'UM',
    '2ndand3rdquarter.graph.pesoEstimado.label': 'Расчетный вес',
    '2ndand3rdquarter.graph.ilaTotal.label': 'АМП',
    '2ndand3rdquarter.graph.maiorBolsao.label': 'Самый большой карман',
    '2ndand3rdquarter.conclusao.label': 'наблюдения',
    '2ndand3rdquarter.conclusao.conclusao.label': 'наблюдения',
    'morphological.label': 'Морфологические',
    'morphological.avaliacaoGestacao.label': 'УПРАВЛЕНИЕ ОЦЕНКОЙ',
    'morphological.avaliacaoGestacao.fetos.label': 'зародыши',
    'morphological.avaliacaoGestacao.fetos.feto$.label': 'плод',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.label': 'chorionicity',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.1.text': 'Monocoriônico',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.2.text': 'Dicoriônico',
    'morphological.avaliacaoGestacao.fetos.feto$.corionicidade.items.3.text': 'Tricoriônico',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.label': 'Amniocidade',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.1.text': 'Monoamniótico',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.2.text': 'Diamniótico',
    'morphological.avaliacaoGestacao.fetos.feto$.amniocidade.items.3.text': 'Trioamniótico',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.label': 'Фетальная ситуация',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Longitudinal.text': 'продольный',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Transversal.text': 'поперечный',
    'morphological.avaliacaoGestacao.fetos.feto$.situacaoFetal.items.Oblíqua.text': 'косой',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.label': 'Фетальная презентация',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Cefálica.text': 'цефалический',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Pélvica.text': 'тазовый',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Córmica.text': 'Córmica',
    'morphological.avaliacaoGestacao.fetos.feto$.apresentacaoFetal.items.Outros.text': 'другой',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.label': 'Фетальная спина',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Anterior.text': 'предыдущий',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Posterior.text': 'задний',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral direita.text': 'Правая сторона',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Lateral esquerda.text': 'Левая сторона',
    'morphological.avaliacaoGestacao.fetos.feto$.dorsoFetal.items.Outros.text': 'другой',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.label': 'Движения плода',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Presente.text': 'настоящее время',
    'morphological.avaliacaoGestacao.fetos.feto$.movimentosFetais.items.Ausente.text': 'отсутствующий',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.label': 'Фетальный ритм',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Presente.text': 'настоящее время',
    'morphological.avaliacaoGestacao.fetos.feto$.batimentosFetais.items.Ausente.text': 'отсутствующий',
    'morphological.avaliacaoGestacao.fetos.feto$.bcf.label': 'BCF',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.label': 'плацента',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Anterior.text': 'предыдущий',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Posterior.text': 'задний',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral direita.text': 'Правая сторона',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Lateral esquerda.text': 'Левая сторона',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia parcial.text': 'Частичный предварительный просмотр',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Prévia total.text': 'Общий предварительный просмотр',
    'morphological.avaliacaoGestacao.fetos.feto$.placenta.items.Outros.text': 'другой',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.label': 'Зрелость плаценты (GRANUMM)',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.0.text': '0',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.I.text': 'Я',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.II.text': 'II',
    'morphological.avaliacaoGestacao.fetos.feto$.placentaMaturidade.items.III.text': 'III',
    'morphological.biometria.label': 'ОСНОВНАЯ БИОМЕТРИЯ ФЕТАЛЛА',
    'morphological.biometria.fetos.label': 'зародыши',
    'morphological.biometria.fetos.feto$.label': 'плод',
    'morphological.biometria.fetos.feto$.dbp.label': 'DBP',
    'morphological.biometria.fetos.feto$.igDbp.label': 'DBP',
    'morphological.biometria.fetos.feto$.cc.label': 'CC',
    'morphological.biometria.fetos.feto$.igCC.label': 'CC',
    'morphological.biometria.fetos.feto$.ca.label': 'переменный ток',
    'morphological.biometria.fetos.feto$.igCA.label': 'переменный ток',
    'morphological.biometria.fetos.feto$.cf.label': 'CF',
    'morphological.biometria.fetos.feto$.igCF.label': 'CF',
    'morphological.biometria.fetos.feto$.cu.label': 'UM',
    'morphological.biometria.fetos.feto$.igCU.label': 'UM',
    'morphological.biometria.fetos.feto$.relacaoCCCA.label': 'Соотношение DC / AC',
    'morphological.biometria.fetos.feto$.relacaoCACF.label': 'Соотношение AC / CF',
    'morphological.biometria.fetos.feto$.relacaoBPDCF.label': 'Соотношение BPD / CF',
    'morphological.biometria.fetos.feto$.pesoEstimado.label': 'Расчетный вес (± 15%)',
    'morphological.biometria.fetos.feto$.comprimentoEstimado.label': 'Расчетная длина',
    'morphological.biometriaAvancada.label': 'РАСШИРЕННАЯ ФЕТАЛЬНАЯ БИОМЕТРИЯ',
    'morphological.biometriaAvancada.fetos.label': 'зародыши',
    'morphological.biometriaAvancada.fetos.feto$.label': 'плод',
    'morphological.biometriaAvancada.fetos.feto$.diametroCerebelar.label': 'Диаметр мозжечка',
    'morphological.biometriaAvancada.fetos.feto$.diametroCerebelarIG.label': 'процентиль',
    'morphological.biometriaAvancada.fetos.feto$.cisternaMagna.label': 'Цистерна Магна',
    'morphological.biometriaAvancada.fetos.feto$.cisternaMagnaIG.label': 'процентиль',
    'morphological.biometriaAvancada.fetos.feto$.atrioVentriculoLateral.label': 'Боковое предсердие желудочка',
    'morphological.biometriaAvancada.fetos.feto$.atrioVentriculoLateralIG.label': 'процентиль',
    'morphological.biometriaAvancada.fetos.feto$.diametroOcular.label': 'Диаметр глаза',
    'morphological.biometriaAvancada.fetos.feto$.diametroOcularIG.label': 'процентиль',
    'morphological.biometriaAvancada.fetos.feto$.distanciaInterocular.label': 'Межокулярное расстояние',
    'morphological.biometriaAvancada.fetos.feto$.distanciaInterocularIG.label': 'процентиль',
    'morphological.biometriaAvancada.fetos.feto$.distanciaBinocular.label': 'Бинокулярное расстояние',
    'morphological.biometriaAvancada.fetos.feto$.distanciaBinocularIG.label': 'процентиль',
    'morphological.biometriaAvancada.fetos.feto$.quintoDedoMao.label': 'Пятый палец',
    'morphological.biometriaAvancada.fetos.feto$.quintoDedoMaoIG.label': 'процентиль',
    'morphological.biometriaAvancada.fetos.feto$.ossoNasal.label': 'Носовая кость',
    'morphological.biometriaAvancada.fetos.feto$.pe.label': 'фут',
    'morphological.biometriaAvancada.fetos.feto$.diamPelvisRenalDir.label': 'Диаметр Почечный таз реж',
    'morphological.biometriaAvancada.fetos.feto$.diamPelvisRenalEsq.label': 'Диаметр Левый почечный таз',
    'morphological.anatomiaFetal.label': 'ФЕТАЛЬНАЯ АНАТОМИЯ',
    'morphological.anatomiaFetal.fetos.label': 'зародыши',
    'morphological.anatomiaFetal.fetos.feto$.label': 'плод',
    'morphological.avalBiofisicaFetal.label': 'БИОФИЗИЧЕСКАЯ ОЦЕНКА ФЕТАЛА',
    'morphological.avalBiofisicaFetal.fetos.label': 'зародыши',
    'morphological.avalBiofisicaFetal.fetos.feto$.label': 'плод',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.label': 'Дыхательное движение',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Presente.text': 'настоящее время',
    'morphological.avalBiofisicaFetal.fetos.feto$.movimentosRespiratorio.items.Ausente.text': 'отсутствующий',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.label': 'Тонус плода',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Presente.text': 'настоящее время',
    'morphological.avalBiofisicaFetal.fetos.feto$.tonusFetal.items.Ausente.text': 'отсутствующий',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.label': 'Амниотическая жидкость',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Normal.text': 'нормальный',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Diminuído.text': 'уменьшенный',
    'morphological.avalBiofisicaFetal.fetos.feto$.liquidoAmniotico.items.Aumentado.text': 'расширенный',
    'morphological.avalBiofisicaFetal.fetos.feto$.labelILA.label': 'АМП',
    'morphological.avalBiofisicaFetal.fetos.feto$.qse.label': 'QSE',
    'morphological.avalBiofisicaFetal.fetos.feto$.qie.label': 'LL',
    'morphological.avalBiofisicaFetal.fetos.feto$.qsd.label': 'DSF',
    'morphological.avalBiofisicaFetal.fetos.feto$.qid.label': 'QID',
    'morphological.avalBiofisicaFetal.fetos.feto$.ilaTotal.label': 'общий',
    'morphological.avalBiofisicaFetal.fetos.feto$.maiorBolsao.label': 'Самый большой карман',
    'morphological.graph.label': 'графика',
    'morphological.graph.dbp.label': 'DBP',
    'morphological.graph.cc.label': 'CC',
    'morphological.graph.ca.label': 'переменный ток',
    'morphological.graph.cf.label': 'CF',
    'morphological.graph.cu.label': 'UM',
    'morphological.graph.pesoEstimado.label': 'Расчетный вес',
    'morphological.graph.ilaTotal.label': 'АМП',
    'morphological.graph.maiorBolsao.label': 'Самый большой карман',
    'morphological.graph.ossoNasal.label': 'Носовая кость',
    'morphological.graph.diamPelvisRenalEsq.label': 'Левый почечный таз',
    'morphological.graph.diamPalvisRenalDir.label': 'Правый почечный таз',
    'morphological.conclusao.label': 'наблюдения',
    'morphological.conclusao.conclusao.label': 'наблюдения',
    'obstetricdoppler.label': 'Акушерский допплер',
    'obstetricdoppler.uterinas.label': 'МАТКИ',
    'obstetricdoppler.uterinas.uterinaEsquerda.label': 'Левая матка',
    'obstetricdoppler.uterinas.piUterinaEsquerda.label': 'ИП левой матки',
    'obstetricdoppler.uterinas.riUterinaEsquerda.label': 'Левый маточный ИК',
    'obstetricdoppler.uterinas.uterinaDireita.label': 'Правая матка',
    'obstetricdoppler.uterinas.piUterinaDireita.label': 'Правый маточный пи',
    'obstetricdoppler.uterinas.riUterinaDireita.label': 'Правый маточный ИК',
    'obstetricdoppler.uterinas.uterinaMedia.label': 'Средняя матка',
    'obstetricdoppler.uterinas.piUterinaMedia.label': 'Маточный пи (средний)',
    'obstetricdoppler.fetal.label': 'ПЛОДА',
    'obstetricdoppler.fetal.fetos.label': 'зародыши',
    'obstetricdoppler.fetal.fetos.feto$.label': 'плод',
    'obstetricdoppler.fetal.fetos.feto$.umbilical.label': 'пупочный',
    'obstetricdoppler.fetal.fetos.feto$.piUmbilical.label': 'PI',
    'obstetricdoppler.fetal.fetos.feto$.riUmbilical.label': 'Род-Айленд',
    'obstetricdoppler.fetal.fetos.feto$.diastole.label': 'диастола',
    'obstetricdoppler.fetal.fetos.feto$.diastole.items.PRESENTE.text': 'настоящее время',
    'obstetricdoppler.fetal.fetos.feto$.diastole.items.AUSENTE.text': 'отсутствующий',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.label': 'Диастола ноль',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.items.PRESENTE.text': 'настоящее время',
    'obstetricdoppler.fetal.fetos.feto$.diastoleZero.items.AUSENTE.text': 'отсутствующий',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.label': 'Обратная диастола',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.items.PRESENTE.text': 'настоящее время',
    'obstetricdoppler.fetal.fetos.feto$.diastoleReversa.items.AUSENTE.text': 'отсутствующий',
    'obstetricdoppler.fetal.fetos.feto$.cerebral.label': 'церебральный',
    'obstetricdoppler.fetal.fetos.feto$.piCerebral.label': 'PI',
    'obstetricdoppler.fetal.fetos.feto$.velocSistolica.label': 'Скорость. систолический',
    'obstetricdoppler.fetal.fetos.feto$.relacaoCerebralPlacentariaLabel.label': 'Мозг / Плацентарные Отношения',
    'obstetricdoppler.fetal.fetos.feto$.relacaoCerebralPlacentaria.label': 'Церебральный пи / пупочный пи',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.label': 'централизация',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.items.SIM.text': 'да',
    'obstetricdoppler.fetal.fetos.feto$.centralizacao.items.NAO.text': 'не',
    'obstetricdoppler.fetal.fetos.feto$.ductoVenoso.label': 'Венозный проток',
    'obstetricdoppler.fetal.fetos.feto$.piDuctoVenoso.label': 'PI',
    'obstetricdoppler.fetal.fetos.feto$.ductoVenosoIG.label': 'DV',
    'obstetricdoppler.fetal.fetos.feto$.saDuctoVenoso.label': 'S / A',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.label': 'Волна А',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.Positivo.text': 'положительный',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.Zero.text': 'ноль',
    'obstetricdoppler.fetal.fetos.feto$.ondaADuctoVenoso.items.FluxoReverso.text': 'Обратный поток',
    'obstetricdoppler.conclusao.label': 'наблюдения',
    'obstetricdoppler.conclusao.conclusao.label': 'наблюдения',
    'conclusion.label': 'заключение',
    'conclusion.text.label': 'заключение'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/formMessages.js